/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

import React, { useState,useEffect,useRef } from "react";
import axios from 'axios';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Menu, { Item as MenuItem } from 'rc-menu';
import Dropdown from 'rc-dropdown';
import 'rc-dropdown/assets/index.css';
import { API_URL, downloadFile } from"../network"
import { Document, Page } from 'react-pdf';
import 'react-inner-image-zoom/lib/InnerImageZoom/styles.css';
import InnerImageZoom from 'react-inner-image-zoom';
import { toast } from 'react-toastify';
import LoadingOverlay from 'react-loading-overlay';
import ScaleLoader from 'react-spinners/ScaleLoader'
// reactstrap components
import { Row, Col } from "reactstrap";
import { Button } from "reactstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter, Input, FormGroup, Label, ListGroup, ListGroupItem, UncontrolledTooltip } from 'reactstrap';
import { connect } from 'react-redux';
import { setProducts, setLogo,setLoading, setDefaultBrand, setOpenConfirmEditModal } from '../actions/quote'
import { setNoteId } from '../actions/ui'
import Lightbox from 'react-image-lightbox';

import 'react-image-lightbox/style.css'; // This only needs to be imported once in your app
import { supplier_arry, supplier_fee, brand_arry,setup_codes, setup_color_change_options, film_costs_arry, setup_discounts,delivery_options, supplier_short, positionList, wfm_category_options } from "../config"
import Summary from "./Summary"
import LeftSummary from "./LeftSummary"
import SummaryGross from "./SummaryGross"
import {Collapse} from 'react-collapse';
import "react-virtualized/styles.css";
import "assets/vendor/font-awesome/css/font-awesome.min.css";
import Product from "./IndexSections/Product.js";
import logo_contact from "assets/img/brand/logo-contact.jpg"
import { ReactNotifications, Store } from 'react-notifications-component'
import 'react-notifications-component/dist/theme.css'



var taskIndex = 0;
var note_id = false

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

/**
 * Moves an item from one list to another list.
 */
const move = (source, destination, droppableSource, droppableDestination) => {
  const sourceClone = Array.from(source);
  const destClone = Array.from(destination);
  const [removed] = sourceClone.splice(droppableSource.index, 1);

  destClone.splice(droppableDestination.index, 0, removed);

  const result = {};
  result[droppableSource.droppableId] = sourceClone;
  result[droppableDestination.droppableId] = destClone;

  return result;
};
const grid = 8;

// mykhailo 20251011
// get film count from logo size and given film metres (300*metres)
const getFilmSizeFromMetres = (film_metres, film_width, film_height) => {
  var widthFit = 300 % film_width;
  var heigthFit = 300 % film_height;

  if(widthFit > heigthFit){
    return Math.floor(300 / film_height ) * Math.floor(film_metres*1000/film_width);
  } else{
    return Math.floor(300 / film_width ) * Math.floor(film_metres*1000/film_height);
  }
}

const getItemStyle = (isDragging, draggableStyle, index, itemType="product", notFound= false) => {
  var background = isDragging ? "lightgreen" : (index%2==0?"white":"#edefef");
  if(itemType == "decoration"){
    background = (index%2==0?"rgb(201, 225, 231)":"rgb(172 204 213)");
  }
  else if(itemType == "discount" || itemType == "delivery" || itemType == "task" || itemType == "attention"){
    background = (index%2==0?"#F6E7A3":"#E5D693");
  }
  else if(itemType == "task_nav"){
    background = '#AA9331';
  }
  if(notFound){
    background = '#f7b0b0';
  }
  return(
    {
      // some basic styles to make the items look a bit nicer
      userSelect: "none",
      padding: '0 5px',
      margin: `0 0 0 0`,
      fontSize:'13.5px',
      // change background colour if dragging
      background: background,
      display:'flex',
      width:'100%',
      // styles we need to apply on draggables
      ...draggableStyle
    }
  );
}

const getItemStyle1 = (isDragging, draggableStyle, parentindex, index, itemType="product", length) => {
  var parentbackground = (parentindex%2==0?"#F6E7A3":"#E5D693");
  var background = isDragging ? "lightgreen" : parentbackground;
  return(
    {
      // some basic styles to make the items look a bit nicer
      userSelect: "none",
      padding: '0',
      margin: `0 0 0 0`,
      fontSize:'13.5px',
      // change background colour if dragging
      background: background,
      display:'flex',
      width:'100%',
      minHeight:(!isDragging&&length==1?'100%':'unset'),
      // styles we need to apply on draggables
      ...draggableStyle
    }
  );
}

const getHeaderStyle = ()=>({
  userSelect: "none",
  padding: grid * 2,
  paddingTop:0,
  paddingLeft:5,
  paddingRight:5,
  paddingBottom:0,
  margin: `0 0 0 0`,
  background:'#091E3F',
  fontWeight:'normal',
  display:'flex',
  width:'100%',
  color:'white',
  borderTopLeftRadius: '12px',
  borderTopRightRadius: '12px'
})
const getListStyle = isDraggingOver => ({
  background: isDraggingOver ? "lightblue" : "white",
  padding: 0,
  width: '100%',
  // borderBottom: '6px solid #091E3F',
  // minHeight:'50px',
  // marginBottom:'20px'
});


var ui_reducer
function Category(props) {
  const [state, setState] = useState([]);
  const [groups, setGroups] = useState({});
  const main = useRef();
  const logoRef = useRef(null);
  const [openProductImage, setOpenProductImage] = useState(false)
  const [modalImage, setModalImage] = useState(false)
  const [modalTitle, setModalTitle] = useState(false)
  const [deleteGroupConfirm, setDeleteGroupConfirm] = useState(false)
  const [deleteQuoteConfirm, setDeleteQuoteConfirm] = useState(false)  

  const [reorderConfirm, setReorderConfirm] = useState(false);

  const [smsModal, setSmsModal] = useState(false) 
  const [smsNumber, setSmsNumber] = useState(false) 
  const [smsNote, setSmsNote] = useState("Hi {first name}, great news, your quote #{quote number} for workwear & uniform has been reviewed by the team and submitted back to you for your approval. Please see your quote PDF using this link: {url} or log in to the portal.") 
  const [deleteGroupid, setDeleteId] = useState(0);
  const [openAddProduct, setOpenAddProduct] = useState(false);
  const [addGroupId, setAddGroupId] = useState(0);
  const [searchAltFocused, setSearchAltFocused] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedProducts, setSelectedProducts] = useState("");
  // const [selectedCatalogue, setSelectedCatalogue] = useState(null);
  const [selectedPosition, setSelectedPosition] = useState(null);
  const [positionSelectAll, setPositionSelectAll] = useState({});
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [tooltipProductsAddOpen, setTooltipProductsAddOpen] = useState(false);
  const [tooltipBrandCheckOpen, setTooltipBrandCheckOpen] = useState(false);
  const [tooltipBrandCheckOtherOpen, setTooltipBrandCheckOtherOpen] = useState(false);
  const [tooltipCategorySelectOpen, setTooltipCategorySelectOpen] = useState(false);
  const [tooltipBrandAddOpen, setTooltipBrandAddOpen] = useState(false);
  const [tooltipBrandFileOpen, setTooltipBrandFileOpen] = useState(false);
  const [tooltipBrandLogoOpen, setTooltipBrandLogoOpen] = useState(false);
  const [tooltipTaskAddOpen, setTooltipTaskAddOpen] = useState(false);
  const [tooltipDecorationPricesOpen, setTooltipDecorationPricesOpen] = useState(false);
  const [tooltipNavigateQuoteOpen, setTooltipNavigateQuoteOpen] = useState(false);
  const [tooltipSaveQuoteOpen, setTooltipSaveQuoteOpen] = useState(false);
  const [tooltipSubmitQuoteOpen, setTooltipSubmitQuoteOpen] = useState(false);
  const [tooltipDeleteQuoteOpen, setTooltipDeleteQuoteOpen] = useState(false);
  const [tooltipChatOpen, setTooltipChatOpen] = useState(false);
  const [tooltipOrderSummaryOpen, setTooltipOrderSummaryOpen] = useState(false);
  const [openCategory, setOpenCategory] = useState(true);
  const [openBrandManagement, setOpenBrandManagement] = useState(true);
  const [openTask, setOpenTask] = useState(true);  
  const [embProductions, setEmbProductions] = useState(null);
  const [screenProductions, setScreenProductions] = useState(null);
  const [digitalProductions, setDigitalProductions] = useState(null);
  const [vinylProductions, setVinylProductions] = useState(null);
  const [curSrc, setCurSrc] = useState(null);
  const [openPreview, setOpenPreview] = useState(false)
  const [hoverPosition, setHoverPosition] = useState(false)
  const [accepted, setAccepted] = useState(false)
  const [otherText, setOtherText] = useState("");
  const [taskOptions, setTasks] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [sendWordflowConfirm, setSendWordflowConfirm] = useState(false)
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [pdfScale, setPdfScale] = useState(0.8)
  const [pdfRotate, setPdfRotate] = useState(0)
  const [uploadingFile, setUploadingFile] = useState(false)
  const [wfm_category, setWfmCategory] = useState("")
  const [contentUpdated, setContentUpdated] = useState(false)
  const [logOpen, setLogOpen] = useState(false)
  const [logData, setLogData] = useState("")
  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }
  

  const toggletooltip = () => setTooltipOpen(!tooltipOpen);
  const toggletooltipProductsAddOpen = () => setTooltipProductsAddOpen(!tooltipProductsAddOpen);
  const toggletooltipBrandCheckOpen = () => setTooltipBrandCheckOpen(!tooltipBrandCheckOpen);
  const toggletooltipBrandCheckOtherOpen = () => setTooltipBrandCheckOtherOpen(!tooltipBrandCheckOtherOpen);
  const toggletooltipCategorySelectOpen = () => setTooltipCategorySelectOpen(!tooltipCategorySelectOpen);
  const toggletooltipBrandAddOpen = () => setTooltipBrandAddOpen(!tooltipBrandAddOpen);
  const toggletooltipBrandFileOpen = () => setTooltipBrandFileOpen(!tooltipBrandFileOpen);
  const toggletooltipBrandLogoOpen = () => setTooltipBrandLogoOpen(!tooltipBrandLogoOpen);
  const toggletooltipTaskAddOpen = () => setTooltipTaskAddOpen(!tooltipTaskAddOpen);
  const toggletooltipDecorationPricesOpen = () => setTooltipDecorationPricesOpen(!tooltipDecorationPricesOpen);
  const toggletooltipNavigateQuoteOpen = () => setTooltipNavigateQuoteOpen(!tooltipNavigateQuoteOpen);
  const toggletooltipSaveQuoteOpen = () => setTooltipSaveQuoteOpen(!tooltipSaveQuoteOpen);
  const toggletooltipSubmitQuoteOpen = () => setTooltipSubmitQuoteOpen(!tooltipSubmitQuoteOpen);
  const toggletooltipDeleteQuoteOpen = () => setTooltipDeleteQuoteOpen(!tooltipDeleteQuoteOpen);
  const toggletooltipChatOpen = () => setTooltipChatOpen(!tooltipChatOpen);
  const toggletooltipOrderSummaryOpen = () => setTooltipOrderSummaryOpen(!tooltipOrderSummaryOpen);
  const mode = props.mode;
  const doDeleteGroup=()=>{    
    const newState = [...state];
    newState.splice(deleteGroupid, 1);
    updateState(
      newState
    );
    setDeleteGroupConfirm(false)
  }
 
  const showProductImage = (idx, item)=>{
    setOpenProductImage(true)
    var item = state[idx][item];
    setModalTitle(item.code)
    setModalImage(item.imageurl)
  }
  const [emb, setEmb] = useState({
    code:"",
    desc:"",
    qty:0,
    price:""
  });
  const [groupOptions, setGroupOptions] = useState({})
  const embCodes = [
    'EMB',
    'SCR'
  ]
  const position_descriptions = [    
    'None',
    'Left Breast',
    'Right Breast',
    'Upper Back',
    'Centre Hat',
    'Hat Arch',
    'Other',
  ];
  const discounts = [
    'DISCOUNT-QTY +'
  ]
  const fees = [
  ]
  const toggleAddProduct = (groupId) => {
    setAddGroupId(groupId)
    setOpenAddProduct(!openAddProduct);
  }
  const addDecoration = (groupId) => {
    var newstate = [...props.state];
    var group = [];
    group =newstate[groupId]
    if(group){
      var newitem = {}
      newitem['code'] = props.quote.defaultBrand?props.quote.defaultBrand:"Embroidery";
      newitem['description'] = null;
      newitem['emb_note'] = "";
      newitem['price'] = 0;
      newitem['type'] = 'decoration';
      newitem['id'] = String((group?group.length:0)+1);
      if(newitem['code'] == "Embroidery"){
        newitem['setup_unit_cost'] = 0;
        newitem['setup_price'] = 0;
      }
      else if(newitem['code'] == "Screen Print" || newitem['code'] == "Screen Print 2C"){
        newitem['setup_unit_cost'] = 50;
        newitem['setup_price'] = 50;
      }
      group.push(newitem)
  
      newstate[groupId] = group
  
      updateState(newstate)
    }
  }

  const addAttention = (product, itemid) => {
    var newstate = [...state];
    var itemsInGroup = [];
    itemsInGroup =newstate[0]
    var groupoptions = newstate[0]['group_options']
    if(groupoptions == undefined || groupoptions == null){
      groupoptions = {};
    }    
    itemsInGroup = (
      itemsInGroup.map((item, index1)=>{
        if(index1 != itemid){
          return item;
        }
        else
          return(
            {...item, need_attention: 1}
          )
      })
    )

    if(itemsInGroup){
      var newitem = {...product}
      // newitem['code'] = props.quote.defaultBrand?props.quote.defaultBrand:"Embroidery";
      newitem['description'] = null;
      // newitem['emb_note'] = "";
      // newitem['price'] = 0;
      newitem['note'] = '';
      newitem['type'] = 'attention';
      newitem['id'] = String((itemsInGroup?itemsInGroup.length:0)+1);      
      newitem['from_product'] = product.id;
      
      itemsInGroup.push(newitem)
  
      newstate[0] = itemsInGroup
      newstate[0]['group_options'] = groupoptions;
  
      updateState(newstate)
    }
  }

  const removeAttention = (product, itemid) => {
    var newstate = [...state];
    var itemsInGroup = [];
    itemsInGroup =newstate[0]
    var groupoptions = newstate[0]['group_options']
    if(groupoptions == undefined || groupoptions == null){
      groupoptions = {};
    }    
    itemsInGroup = (
      itemsInGroup.map((item, index1)=>{
        if(index1 != itemid){
          return item;
        }
        else
          return(
            {...item, need_attention: 0}
          )
      })
    )

    if(itemsInGroup){
      let newGroup = itemsInGroup.filter((item)=>{return !(item.code == product.code && item.from_product == product.id && item.type == 'attention')})
      
      newstate[0] = newGroup
      newstate[0]['group_options'] = groupoptions;
  
      updateState(newstate)
    }
  }
  
  const onAddManage=(groupId, type)=>{
    var newstate = [...props.state];
    var group = [];
    group =newstate[groupId]
    if(group){
      var newitem = {}
      newitem['price'] = 0;
      newitem['type'] = type;
      newitem['id'] = String((group?group.length:0)+1);
      group.push(newitem)
  
      newstate[groupId] = group
  
      updateState(newstate)
    }
  }

  const toggleProductImage = () => {
    setOpenProductImage(!openProductImage);
  }
  
  const updateState = (state)=>{
    setState(state)
    var categoryInfo = props.category
    var cat_val={
      [0]:{
        category_info: categoryInfo,
        items: state,
        groups: props.groups
      }
    }
    var categoires = {...props.quote.categories}
    var category = {...categoires[0]}
    category = {...category, 
      category_info: categoryInfo,
      items: state,
      groups: props.groups
    }
    categoires[0] = category
    props.updateCategory(categoires)
    setContentUpdated(true)
  }
  const updateGroup = (groups)=>{
    var categoryInfo = props.category
    var cat_val={
      [categoryInfo.key]:{
        category_info: categoryInfo,
        items: props.state,
        groups: groups
      }
    }
    props.updateCategory(cat_val)
  }

  const repeatOrder=async(orderId)=>{
    // alert("clicked repeatOrder");
        
    const user = localStorage.getItem('user_bigbrand');
    var role = ""
    if(user && user != undefined){
      var userinfo = JSON.parse(user)
      role = userinfo['role']
    }
    var bodyFormData = new FormData();    
    axios.post(`/quotes/repeat/${orderId}`, bodyFormData).then(res => {
      const result = res.data;
      if(result.status == "success"){        
        toast.success("Your order has been copied");
        if(role=='admin')
          window.location.href = ("/admin/myorders/edit/"+result.data)
        else
          window.location.href = ("/myorders/edit/"+result.data)
      }
      else{
        toast.error(result.data);
      }
    }).catch(err => {
      toast.error('Something was wrong. Try again');
    });

    setReorderConfirm(false);
  }

  const duplicateOrder=async(orderId)=>{
    const user = localStorage.getItem('user_bigbrand');
    var role = ""
 
    if(user && user != undefined){
      var userinfo = JSON.parse(user)
      role = userinfo['role']
    }
    var bodyFormData = new FormData();    
    axios.post(`/quotes/repeat/${orderId}`, bodyFormData).then(res => {
      const result = res.data;
      if(result.status == "success"){        
        toast.success("Your order has been duplicated");
        if(role=='admin')
          window.location.href = ("/admin/myorders/edit/"+result.data)
        else
          window.location.href = ("/myorders/edit/"+result.data)
      }
      else{
        toast.error(result.data);
      }
    }).catch(err => {
      toast.error('Something was wrong. Try again');
    })
  }
  
  const deleteQuote=()=>{
    const token = localStorage.getItem('token_bigbrand');    
    const user = localStorage.getItem('user_bigbrand');
    var role = ""
    if(user && user != undefined){
      var userinfo = JSON.parse(user)
      role = userinfo['role']
    }
    var bodyFormData = new FormData();
    props.setLoading(true)
    axios.post(`/quotes/delete/${props.quote.id}`, bodyFormData).then(res => {
      if(res.data.status == "success"){  
        if(role=='admin')  
          props.history.push("/admin/requests")
        else
          props.history.push("/myorders")
      }
      else{
        toast.error("Failed to delete quote");
      }
      props.setLoading(false)
    }).catch(err => {
      toast.error("Failed to delete quote");
    })
  }

  const sendSmsQuote=()=>{
    if(!smsNumber || smsNumber == '')
      return
    var bodyFormData = new FormData();
    bodyFormData.append('telnum', smsNumber);
    bodyFormData.append('note', smsNote?smsNote:"");
    
    props.setLoading(true)
    axios.post(`/quotes/sendsms/${props.quote.id}`, bodyFormData).then(res => {
      var result = res.data
      try{
        if(result && result.toLowerCase().includes("success")){
          toast.success("Sms has been sent.");
        }
        else{
          toast.error("Failed to send sms");
        }
        setSmsModal(false)
      }
      catch(e){
        toast.error("Failed to send sms");
      }
      setSmsModal(false)
      props.setLoading(false)
    }).catch(err => {
      toast.error("Failed to send sms");
      props.setLoading(false)
      setSmsModal(false)
    })
  }

  const updateOtherText=(value)=>{        
    if(props.quote.status == 'Completed Quote' && role != 'admin'){
      props.setOpenConfirmEditModal(true);
      return false;
    }
    // if(props.quote && props.quote.user_id){
    //   var bodyFormData = new FormData();
    //   bodyFormData.append('other', value);
    //   axios.post(`/setting/setbyuserid/${props.quote.user_id}`, bodyFormData).then(res => {
    //     if(res.data.status == "success"){        
    //     }
    //     else{
    //       toast.error("Failed to set other text");
    //     }
    //   }).catch(err => {
    //     toast.error('Failed to set other text');
    //   })
    // }
    setOtherText(value)
    var categories = {...props.quote.categories}
    var category = categories[0] ? {...categories[0]} : {
      category_info: props.category,
      items: props.state || [],
      groups: props.groups || []
    }
    category['other_position'] = value
    props.updateCategory({[0]: category})
  }

  const savedOtherPosition = props.quote.categories && props.quote.categories[0]
    ? props.quote.categories[0].other_position
    : ""

  useEffect(()=>{
    setOtherText(savedOtherPosition || "")
  },[props.quote.id, savedOtherPosition])

  useEffect(()=>{
    if(props.quote && props.quote.user_id){
      // axios.get(`/setting/getbyuserid/${props.quote.user_id}`).then(res => {
      //   if(res.data.status == "success")
      //     var setting = res.data.data
      //     if(setting && setting.other){              
      //      setOtherText(setting.other)
      //     }
      // }) 
      axios.get(`/xero/gettemplates`).then(res => {
        if(res.data.status == "success")
          var setting = res.data.data
          if(setting && setting.templates){  
            setTemplates(setting.templates)
          }
          if(setting && setting.tasks){  
            setTasks(setting.tasks)
          }
      }) 
      axios.get(`/productions/index?userid=${props.quote.user_id}`).then(res => {
        if(res.data.status == "success")
          var productions = res.data.data
          if(productions){              
            setEmbProductions(productions.filter(item=>item.production_type=='emb'))
            setScreenProductions(productions.filter(item=>item.production_type=='screen_print'))
            setDigitalProductions(productions.filter(item=>item.production_type=='digital'))  
            setVinylProductions(productions.filter(item=>item.production_type=='vinyl'))       
          }
      })
      ui_reducer = props.ui
      checkAccess()
      const interval = setInterval(() => {
        checkAccess()
      }, 15000);
      return () => {clearInterval(interval); note_id = false};

    }



  },[props.quote.user_id])

  const checkAccess = ()=>{
    const user = localStorage.getItem('user_bigbrand');
    var role = ""
    if(user && user != undefined){
      var userinfo = JSON.parse(user)
      role = userinfo['role']
    }
    if(!props.quote.id) 
      return
    axios.get(`/quotes/checkaccess?quote_id=${props.quote.id}`).then(res => {      
      if(role != 'admin'){
        return;
      }
      if(res.data.status == "success")
        if(res.data.data == 'busy'){
          console.log("props.ui.note_id", ui_reducer)
          if(!note_id){
            note_id = Store.addNotification({
              title: <div><i class="fa fa-exclamation-triangle mr-1"/><span>Warning!</span></div>,
              message: "Someone is working with this quote",
              type: "danger",
              insert: "top",
              // content: <div><i class="fa fa-exclamation-triangle"/>Someone1 is online</div>,
              container: "top-left",
              animationIn: ["animate__animated", "animate__fadeIn"],
              animationOut: ["animate__animated", "animate__fadeOut"],
              dismiss: {
                duration: 0,
                onScreen: true
              },
              showIcon: true
            });
            console.log("noteId", note_id)
          }
        }
        else{
          if(note_id){
            Store.removeNotification(note_id)
            note_id = false
          }
        }
        
    }) 
  }
  
  useEffect(() => {
    var newstate = [...props.state];
    for(var ind=0; ind < newstate.length; ind++){
      var groupoptions = newstate[ind]['group_options']
      if(groupoptions == undefined || groupoptions == null){
        groupoptions = {};
      }
      
      if(!("decorations" in groupoptions)){      
        groupoptions['decorations'] = [];
      }
      
      var length = groupoptions['decorations'].length;
      if(length == 0){
        var decoration = {}
        decoration['code'] = null;
        decoration['description'] = null;
        decoration['emb_note'] = "";
        decoration['price'] = 0;
        groupoptions['decorations'].push(decoration);
      }
      newstate[ind]['group_options'] = groupoptions;
    }
    
    setState(newstate);
    
    updateSelectAll();
  },[props.state]);
  
  const updateSelectAll = ()=>{
    var newstate = [...props.state];
    var group = newstate[0];
    var new_positionSelectAll = {...positionSelectAll}
    for(var positionKey in positionList){
      var flag = 1;
      var position = positionList[positionKey]
      if(group && group.length > 0){
        for(var loop = 0; loop< group.length; loop++){
          var item = group[loop]
          if(item.type != "product") continue;
          if(item.position){
            if(!item.position[position]){
              flag = 0;
            }
          }
          else{
            flag = 0;
          }
        }
      }
      else{
        flag = 0;
      }
      new_positionSelectAll = ({...new_positionSelectAll, [position]:flag})
    }
    setPositionSelectAll(new_positionSelectAll)
  }

 
  
  const getFeeQty=()=>{
    var feeQty = 0;
    var catalogues = [];
    for(var loop=0; loop<state.length; loop++){
      var items = state[loop];
      for(var loop1=0; loop1< items.length; loop1++){
        var code = items[loop1]['code']   
        if(items[loop1]['type']=="product"){
          var codeArry = code.split(" - ");
          var catalogue = codeArry[0];
          if(!(catalogues.includes(catalogue))){
            catalogues.push(catalogue);
            feeQty++
          }
        }
      }
    }
    return feeQty;
  }
  const getEmpQty=(groupId)=>{
    var feeQty = 0;
    var items = state[groupId];
    for(var loop1=0; loop1< items.length; loop1++){
      if(items[loop1]['type']=="product"){
        var code = items[loop1]['code'] 
        var qty = items[loop1]['qty']*1 
        feeQty+=qty;   
      }
    }
    return feeQty;
  }

  const onAddTemplate=()=>{
    var newstate = [...props.state];
    if(newstate.length == 0){
      newstate.push([]);
    }
    var groupoptions = newstate[0]['group_options']
    if(groupoptions == undefined || groupoptions == null){
      groupoptions = {};
    }
    if(!("customs" in groupoptions)){      
      groupoptions['customs'] = [];
    }
    if(!("customfees" in groupoptions)){      
      groupoptions['customfees'] = [];
    }
    var custom = {}
    custom['custom_qty'] = 0;
    custom['custom_desc'] = "";
    custom['custom_price'] = 0;
    custom['custom_visible'] = true;
    groupoptions['customs'].push(custom);
    newstate[0]['group_options'] = groupoptions
    updateState(newstate)
    setOpenTask(true)
  }
  
  const onAddFee=()=>{
    var newstate = [...props.state];
    if(newstate.length > 0){
      var groupoptions = newstate[0]['group_options']
      if(groupoptions == undefined || groupoptions == null){
        groupoptions = {};
      }
      if(!("customfees" in groupoptions)){      
        groupoptions['customfees'] = [];
      }
      var customfee = {}
      customfee['customfee_qty'] = 1;
      customfee['catalogue'] = "";
      customfee['customfee_price'] = 0;
      groupoptions['customfees'].push(customfee);
      newstate[0]['group_options'] = groupoptions
      setState(newstate)
    }
  }

  var cost_visible = (state.length > 0 && state[0]['group_options'] && state[0]['group_options']['cost_visible'])

  function onDragStart() {
    if(props.quote.status == 'Completed Quote' && role != 'admin'){
      props.setOpenConfirmEditModal(true);
      return false;
    }
  }
  
  function  onDragEndProduct(result) {
    const { source, destination } = result;

    // dropped outside the list
    if (!destination) {
      return;
    }
    const sInd = +source.droppableId;
    const dInd = +destination.droppableId;
    var sourceList  = getItemList('product', state[sInd])
    var sourceInd = sourceList?.[source.index]?.['index']
    var destList  = getItemList('product', state[dInd])
    var destInd = destList?.[destination.index]?.['index']

    if (sInd === dInd) {
      const items = reorder(state[sInd], sourceInd, destInd);
      const newState = [...state];
      newState[sInd] = items;
      newState[sInd]["group_options"] = state[sInd].group_options;
      updateState(newState);
    } else {
      // const result = move(state[sInd], state[dInd], source, destination);
      // const newState = [...state];
      // newState[sInd] = result[sInd];
      // newState[dInd] = result[dInd];
      // newState[sInd]["group_options"] = state[sInd].group_options;

      // // updateState(newState.filter(group => group.length));
      // updateState(newState);
    }
  }

  function onDragEndDecoration(result) {
    const { source, destination } = result;

    // dropped outside the list
    if (!destination) {
      return;
    }
    const sInd = +source.droppableId;
    const dInd = +destination.droppableId;
    var sourceList  = getItemList('decoration', state[sInd])
    var sourceInd = sourceList?.[source.index]?.['index']
    var destList  = getItemList('decoration', state[dInd])
    var destInd = destList?.[destination.index]?.['index']

    if (sInd === dInd) {
      const items = reorder(state[sInd], sourceInd, destInd);
      const newState = [...state];
      newState[sInd] = items;
      newState[sInd]["group_options"] = state[sInd].group_options;
      updateState(newState);
    } else {
      // const result = move(state[sInd], state[dInd], source, destination);
      // const newState = [...state];
      // newState[sInd] = result[sInd];
      // newState[dInd] = result[dInd];
      // newState[sInd]["group_options"] = state[sInd].group_options;

      // // updateState(newState.filter(group => group.length));
      // updateState(newState);
    }
  }

  function onDragEnd(result) {
    const { source, destination } = result;

    // dropped outside the list
    if (!destination) {
      return;
    }
    const sInd = +source.droppableId;
    const dInd = +destination.droppableId;

    if (sInd === dInd) {
      const items = reorder(state[sInd], source.index, destination.index);
      const newState = [...state];
      newState[sInd] = items;
      newState[sInd]["group_options"] = state[sInd].group_options;
      updateState(newState);
    } else {
      const result = move(state[sInd], state[dInd], source, destination);
      const newState = [...state];
      newState[sInd] = result[sInd];
      newState[dInd] = result[dInd];
      newState[sInd]["group_options"] = state[sInd].group_options;

      // updateState(newState.filter(group => group.length));
      updateState(newState);
    }
  }

  function onDragEndTask(result, custom_ind) {
    const { source, destination } = result;

    // dropped outside the list
    if (!destination) {
      return;
    }
    const sInd = +source.droppableId;
    const dInd = +destination.droppableId;

    
    var newstate = [...state];
    var groupoptions = newstate[0]['group_options']
    if(groupoptions == undefined || groupoptions == null){
      groupoptions = {};
    }
    var tasks = [...groupoptions['customs'][custom_ind]['tasks']];
    tasks = reorder(tasks, source.index, destination.index);
    groupoptions['customs'][custom_ind]['tasks'] = tasks

    newstate[0]['group_options'] = groupoptions
    updateState(newstate)
  }

  const onChangeProduct = async (groupid, itemid, key, value)=>{
    if(props.quote.status == 'Completed Quote' && role != 'admin'){
      props.setOpenConfirmEditModal(true);
      return false;
    }
    var newState = [...state];
    var groupoptions = newState[0]['group_options']
    var itemsInGroup = [...newState[0]];
    if(groupoptions == undefined || groupoptions == null){
      groupoptions = {};
    }
    itemsInGroup = (
      itemsInGroup.map((item, index1)=>{
        if(index1 != itemid){
          return item;
        }
        else
          return(
            {...item, [key]: value}
          )
      })
    )
    newState[0] = itemsInGroup
    newState[0]['group_options'] = groupoptions;

    updateState(newState);
  }
  
  const onBlurProduct = async (groupid, itemid, key, value)=>{
    if(props.quote.status == 'Completed Quote' && role != 'admin'){
      props.setOpenConfirmEditModal(true);
      return false;
    }
    var newstate = [...state];
    newstate = await Promise.all(newstate.map(async (group, index)=>{
      if(groupid != index){
        return group;
      }
      else {
        var newgroup = (
          group.map((item, index1)=>{
            if(index1 != itemid){
              return item;
            }
            else
              return(
                {...item, [key]: value}
              )
          })
        );

        // If the quantity for a product is set to zero, remove the line
        if(key === 'qty' && Number(value) === 0 && group[itemid]?.type === 'product'){
          newgroup.splice(itemid, 1);
        }

        newgroup = await updateBrandingQty(newgroup)
        newgroup['group_options'] = newstate[index]['group_options']
        return newgroup;
      }
    }))
    updateState(newstate);
  }

  const setColumnPosition = async (position, e)=>{
    
    if(props.quote.status == 'Completed Quote' && role != 'admin'){
      props.setOpenConfirmEditModal(true);
      return false;
    }
    var ind;
    var newState = [...state];
    for(ind in newState){
      var el = [...newState[ind]];
      var group_options = {...newState[ind]['group_options']}
      for(var index in el){
        if(el[index].type == "product"){
          if(!el[index]['position']){
            el[index]['position'] = {};
          }
          el[index]['position'][position] = e.target.checked
        }
      }
      el = await updateBrandingQty(el)
      newState[ind] = el;
      newState[ind]['group_options'] = group_options;
    }
    updateState(newState);
  }

  const onChangeItemPosition=async (groupid, itemid, positionKey,value)=>{
    if(props.quote.status == 'Completed Quote' && role != 'admin'){
      props.setOpenConfirmEditModal(true);
      return false;
    }
    props.setLoading(true) 
    var newstate = [...state];
    var newstate = await Promise.all(newstate.map(async (group, index)=>{
      if(groupid != index){
        return group;
      }
      else {
        var newgroup = (
          group.map((item, index1)=>{
            if(index1 != itemid){
              return item;
            }
            else
              return(
                {...item, position: {...item.position, [positionKey]:value}}
              )
          })
        )
        newgroup = await updateBrandingQty(newgroup)
        newgroup['group_options'] = newstate[index]['group_options']
        return newgroup;
      }
    }))
    updateState(newstate);
    props.setLoading(false) 
  }

  const getItemPosition=(inItem)=>{
    var newstate = [...state];
    var group = state[0];
    var postion = 0;
    for(var i = 0; i < group.length; i++){
      var item = group[i];
      if((item.type == 'delivery' || item.type == 'discount') && (inItem.type == 'delivery' || inItem.type == 'discount')){
        if(item.id == inItem.id) break;
        postion++
      }
      if(item.type == 'product' && inItem.type == 'product'){
        if(item.id == inItem.id) break;
        postion++
      }
      if(item.type == 'decoration' && inItem.type == 'decoration'){
        if(item.id == inItem.id) break;
        postion++
      }
    }
    return postion;
  }

  const calcDigitalPrintPrice = (itemsInGroup)=>{
    var resultItem = false;
    var newItemsInGroup = [];
    if(itemsInGroup && itemsInGroup.length>0){
      var itemTotalCost = 0;
      var itemTotalQty = 0;
      for(var i = 0; i < itemsInGroup.length; i++){
        //var item = {...itemsInGroup[i]};
        var item = itemsInGroup[i];
        if(item.type == "decoration" && (item.code == 'Digital Print' )){
          var qty = item['qty']?item['qty']:0;
          var setup_qty = item['setup_qty']?item['setup_qty']:0;
          if(item['setup_code'] == 'None'){
            setup_qty = 0
          }
          var setup_unit_cost = item['setup_unit_cost']?(item['setup_unit_cost']*1):0;
          var film_qty = item['film_qty']?(item['film_qty']*1):0;
          var film_unit_cost = item['film_unit_cost']?(item['film_unit_cost']*1):0;
          var heat_qty = item['heat_qty']?(item['heat_qty']*1):0;
          var heat_unit_cost = item['heat_unit_cost']?(item['heat_unit_cost']*1):0;

          // add packing fee
          var packing_qty = item['packing_qty']?(item['packing_qty']*1) : 0;
          var packing_unit_cost = item['packing_unit_cost']?(item['packing_unit_cost']*1):0;

          if(isNaN(qty)) qty = 0;
          if(isNaN(setup_qty)) setup_qty = 0;
          if(isNaN(setup_unit_cost)) setup_unit_cost = 0;
          if(isNaN(film_qty)) film_qty = 0;
          if(isNaN(film_unit_cost)) film_unit_cost = 0;
          if(isNaN(heat_qty)) heat_qty = 0;
          if(isNaN(heat_unit_cost)) heat_unit_cost = 0;

          // packing fee
          if(isNaN(packing_qty)) packing_qty = 0;
          if(isNaN(packing_unit_cost)) packing_unit_cost = 0;

          // mykhailo 20251014
          var subTotalCost = setup_qty*setup_unit_cost + film_qty*film_unit_cost + heat_qty*heat_unit_cost + packing_qty*packing_unit_cost;

          itemTotalCost += subTotalCost; 

          item['unit_cost'] = (subTotalCost / qty).toFixed(2);
          //itemTotalCost += (setup_qty*setup_unit_cost + heat_qty*heat_unit_cost); // mykhailo
          itemTotalQty += qty*1
        }
      }
      var digitalCost = 0
      if(itemTotalQty){
        digitalCost = itemTotalCost/itemTotalQty
      }
      newItemsInGroup = itemsInGroup.map((item, index1)=>{
        if(item.code == 'Digital Print'){
          var output =  {...item}
         // output = {...output, unit_cost:(digitalCost*1).toFixed(2)}
          resultItem = {...output};
          return output;
        }
        else{                  
          return item;
        }
      })      
    }
    return newItemsInGroup;
  }
  
  const calcVinylPrintPrice = (itemsInGroup)=>{
    var resultItem = false;
    var newItemsInGroup = [];
    if(itemsInGroup && itemsInGroup.length>0){
      var itemTotalCost = 0;
      var itemTotalQty = 0;
      for(var i = 0; i < itemsInGroup.length; i++){
        var item = {...itemsInGroup[i]};
        if(item.type == "decoration" && (item.code == 'Vinyl Print')){
          var qty = item['qty']?item['qty']:0;
          var setup_qty = item['setup_qty']?item['setup_qty']:0;
          if(item['setup_code'] == 'None'){
            setup_qty = 0
          }
          var setup_unit_cost = item['setup_unit_cost']?(item['setup_unit_cost']*1):0;
          var film_qty = item['film_qty']?(item['film_qty']*1):0;
          var film_unit_cost = item['film_unit_cost']?(item['film_unit_cost']*1):0;
          var heat_qty = item['heat_qty']?(item['heat_qty']*1):0;
          var heat_unit_cost = item['heat_unit_cost']?(item['heat_unit_cost']*1):0;

          if(isNaN(qty)) qty = 0;
          if(isNaN(setup_qty)) setup_qty = 0;
          if(isNaN(setup_unit_cost)) setup_unit_cost = 0;
          if(isNaN(film_qty)) film_qty = 0;
          if(isNaN(film_unit_cost)) film_unit_cost = 0;
          if(isNaN(heat_qty)) heat_qty = 0;
          if(isNaN(heat_unit_cost)) heat_unit_cost = 0;
          itemTotalCost += (setup_qty*setup_unit_cost + film_qty*film_unit_cost + heat_qty*heat_unit_cost)
          itemTotalQty += qty*1
        }
      }
      var digitalCost = 0
      if(itemTotalQty){
        digitalCost = itemTotalCost/itemTotalQty
      }
      newItemsInGroup = itemsInGroup.map((item, index1)=>{
        if(item.code == 'Vinyl Print'){
          var output =  {...item}
          output = {...output, unit_cost:(digitalCost*1).toFixed(2)}
          resultItem = {...output};
          return output;
        }
        else{                  
          return item;
        }
      })      
    }
    return newItemsInGroup;
  }

  const updateBrandingQty =async (el)=>{
    var group = [...el]
    var positionSum = {};
    for(var i in positionList){
      positionSum[positionList[i]] = 0;
    }
    for(var loop = 0; loop < el.length; loop++){
      var item = group[loop]
      if(item.type== 'product'){
        var qty = item['qty']?item['qty']:0;
        for(var i in positionList){
          if(item['position']&& item['position'][positionList[i]])
            positionSum[positionList[i]]+= (qty*1);
        }
      }
    }

    for(var position in positionSum){
      if(positionSum[position] > 0){ // add missing brand
        var existFlag = false;
        for(var ind = 0; ind<group.length; ind++){
          var item = {...group[ind]};
          var newQty = positionSum[item['position']];
          if(item.type == "decoration" && item.position && item.position == position){ //update existing one
            existFlag = true;
          }
        }
        if(!existFlag){
          var newitem = {}
          newitem['code'] = props.quote.defaultBrand?props.quote.defaultBrand:"Embroidery";
          newitem['description'] = null;
          newitem['emb_note'] = "";
          newitem['price'] = 0;
          newitem['type'] = 'decoration';
          newitem['position'] = position;
          if(position == 'Other'){
            newitem['qty'] = 0;
            newitem['heat_qty'] = 0;
            newitem['qty_mode'] = 'manual';
            newitem['position_label'] = otherText;
          }
          newitem['id'] = String((group?group.length:0)+1);
          group.push(newitem)
        }
      }
    }

    var newgroup = (
      group.map((item, index1)=>{
        if(item.type != 'decoration'){ // || item.code == 'Digital Print'){ //mykhailo 20251011
          return item;
        }
        else if(item.position == 'Other' || item.qty_mode == 'manual'){
          return item;
        }
        else{
          return(
            // {...item, qty: (positionSum[item['position']]?positionSum[item['position']]:0), film_qty: (positionSum[item['position']]?positionSum[item['position']]:0), heat_qty: (positionSum[item['position']]?positionSum[item['position']]:0)}
            {...item, qty: (positionSum[item['position']]?positionSum[item['position']]:0), heat_qty: (positionSum[item['position']]?positionSum[item['position']]:0)}
          )
        }
      })
    )

    for(var position in positionSum){
      if(positionSum[position] > 0){ // add missing brand
        var existFlag = false;
        for(var ind = 0; ind<newgroup.length; ind++){
          var item = {...newgroup[ind]};
          var newQty = positionSum[item['position']];
          if(item.type == "decoration" && item.position && item.position == position){ //update existing one
            var unit_cost = item.unit_cost;
            var price = item.price;
            var setup_unit_cost = item.setup_unit_cost;
            var setup_price= item.setup_price;
            if(item.code == 'Embroidery'){
              if(item['setup_sc'] && item['qty']){
                // props.setLoading(true)                
                var lookup_qty = calculateEmbLookupQty(item, newgroup)
                var url = `/customerBrands/getcost?sc=${item['setup_sc']?item['setup_sc']:0}&qty=${lookup_qty?lookup_qty:0}`
                var supplier = item['supplier'];
                if(supplier == 'JS'){
                  url = `${url}&supplier=JS`
                }
                var res = await axios.get(url)   
                // props.setLoading(false)           
                if(res.data.status == "success")
                    unit_cost = res.data.data?res.data.data:0
              }
            }
            else if(item.code == 'Screen Print' || item.code == 'Screen Print 2C'){    
              if(item.code == 'Screen Print'){
                if(item['qty'] <= 25){
                  unit_cost = 3.2
                  price = 9.4
                }
                else if(item['qty'] > 25 && item['qty'] <= 60){
                  unit_cost = 2.75
                  price = 8.9
                }
                else if(item['qty'] > 60){
                  unit_cost = 2
                  price = 7.9
                }
              }
              else if(item.code == 'Screen Print 2C'){
                if(item['qty'] <= 25){
                  unit_cost = 3.9
                  price = 0
                }
                else if(item['qty'] > 25 && item['qty'] <= 60){
                  unit_cost = 3.45
                  price = 0
                }
                else if(item['qty'] > 60){
                  unit_cost = 2.70
                  price = 0
                }
                price = 9.9
              }
                  
              if(item.code == 'Screen Print'){
                if(item['position'] == 'Sleeve Upper Left' || item['position'] == 'Sleeve Upper Right'){
                  unit_cost = 4
                  price = 10
                }
              }
              if(item['setup_code'] == 'New Set Up'){
                setup_unit_cost = 50
                setup_price = 100
              }
              
              if(item['setup_code'] == 'Repeat Set Up'){
                setup_unit_cost = 20
                setup_price= 45
              }
            }
            
            newgroup[ind] = {...item, unit_cost:(unit_cost*1).toFixed(2), price, setup_unit_cost, setup_price}
            existFlag = true;
          }
        }
        if(!existFlag){
          // var newitem = {}
          // newitem['code'] = props.quote.defaultBrand?props.quote.defaultBrand:"Embroidery";
          // newitem['description'] = null;
          // newitem['emb_note'] = "";
          // newitem['price'] = 0;
          // newitem['type'] = 'decoration';
          // newitem['position'] = position;
          // newitem['id'] = String((newgroup?newgroup.length:0)+1);
          // newgroup.push(newitem)
        }
      }
      else{  //remove unused brand
        var tmp_group = [...newgroup];
        for(var ind = 0; ind<tmp_group.length; ind++){
          var item = tmp_group[ind];
          if(position != 'Other' && item.type == "decoration" && item.position && item.position == position && item.qty_mode != 'manual'){
            newgroup.splice(ind, 1);
          }
        }
      }
    }

    
    newgroup = calcDigitalPrintPrice(newgroup) //mykhailo
    newgroup = calcVinylPrintPrice(newgroup)
    

    

    return newgroup;
  }
  
  const onChangeCost=(groupid, itemid, e)=>{
    var newstate = [...state];
    newstate = newstate.map((group, index)=>{
      if(groupid != index){
        return group;
      }
      else {
        return(
          group.map((item, index1)=>{
            if(index1 != itemid){
              return item;
            }
            else
              return(
                {...item, costprice: e.target.value}
              )
          })
        )
      }
    })
    updateState(newstate);
  }
  const getCost= (item)=>{
    var qty = item['qty']?item['qty']:0;
    var price = item['cost']?item['cost']:0;
    return (qty*price)
  }  
  const getPriceExt= (item)=>{
    var qty = item['qty']?item['qty']:0;
    var price = item['price']?(item['price']*1).toFixed(2):0;
    return (qty*price)
  }   
  const getDiscountCost= (item)=>{
    if(!item) return 0;
    var discount_qty = item['qty']?item['qty']:0;
    var discount_price = item['cost']?item['cost']:0;
    if(isNaN(discount_qty)) discount_qty = 0;
      if(isNaN(discount_price)) discount_price = 0;
    return (discount_qty*discount_price)
  }  
  const getDiscountPriceExt= (item)=>{
    if(!item) return 0;
    var discount_qty = item['qty']?item['qty']:0;
    var discount_price = item['price']?(item['price']*1):0;
    if(isNaN(discount_qty)) discount_qty = 0;
    if(isNaN(discount_price)) discount_price = 0;
    return (discount_qty*discount_price)
  }      
  const empPrice = (ind)=>{
    var value = 0;
    var sum = 0;
    var group_options = state[ind]['group_options']
    if(group_options){
      var decorations = group_options['decorations']
      if(decorations){
        for(var loop = 0; loop < decorations.length; loop++){
          var decoration = decorations[loop]
          var qty = getEmpQty(ind)
          var price = 0;
          if(!isNaN(decoration.price))
          price = decoration.price
          value = qty*price
          sum+= value;
        }
      }
    }
    return sum
  } 
  const discountPrice = (ind)=>{
    var value = 0;
    var discount_qty = 0;
    var discount_price = 0;
    var group_options = state[ind]['group_options']
    if(group_options){
      if(!isNaN(group_options.discount_qty))
        discount_qty = group_options.discount_qty
      if(!isNaN(group_options.discount_price))
        discount_price = group_options.discount_price
      value = discount_qty*discount_price
    }
    return value
  }
  const setupPrice = (ind)=>{
    var value = 0;
    var setup_qty = 0;
    var setup_price = 0;
    var group_options = state[ind]['group_options']
    if(group_options){
      if(!isNaN(group_options.setup_qty))
        setup_qty = group_options.setup_qty
      if(!isNaN(group_options.setup_price))
        setup_price = group_options.setup_price
      value = setup_qty*setup_price
    }
    return value
  }
  const feePrice = (catalogue, ind)=>{
    var value = 0;
    var fee_qty = 0;
    var fee_price = 0;
    var group_options = state[ind]['group_options']
    if(group_options){
      fee_qty = 1;
      if(!isNaN(group_options["cat_fee_"+catalogue]))
        fee_price = group_options["cat_fee_"+catalogue]
      value = fee_qty*fee_price
    }
    return value
  }
  const customPrice = (ind)=>{
    var value = 0;
    var sum = 0;
    var group_options = state[ind]['group_options']
    if(group_options){
      var customs = group_options['customs']
      if(customs){
        for(var loop = 0; loop < customs.length; loop++){
          var custom = customs[loop]
          var custom_qty = 0;
          var custom_price = 0;
          if(!isNaN(custom.custom_qty))
            custom_qty = custom.custom_qty
          if(!isNaN(custom.custom_price))
            custom_price = custom.custom_price
          value = custom_qty*custom_price
          sum+= value;
        }
      }
    }
    return sum
  }
  const subTotal = ()=>{
    var subtotal = 0;
    for(var loop = 0; loop<state.length; loop++){
      var group = state[loop];
      for(var loop1 = 0; loop1 < group.length; loop1++){
        var item = group[loop1];
        subtotal+=getPriceExt(item)*1;
      }
      var emp_price = empPrice(loop)
      subtotal+=emp_price
      var discount_price = discountPrice(loop)
      var setup_price = setupPrice(loop)
      subtotal+=discount_price
      subtotal+=setup_price
      subtotal+=feePrice(loop)
      subtotal+=customPrice(loop)
    }
    return subtotal;
  }
  const subCostTotal = ()=>{
    var subtotal = 0;
    for(var loop = 0; loop<state.length; loop++){
      var group = state[loop];
      for(var loop1 = 0; loop1 < group.length; loop1++){
        var item = group[loop1];
        var price = item['costprice']?item['costprice']:0;
        subtotal+=price*1;
      }
    }
    return subtotal;
  }
  const onChangeEmb=(groupInd, key, value)=>{
    var newstate = [...state];
    var groupoptions = newstate[groupInd]['group_options']
    if(groupoptions == undefined || groupoptions == null){
      groupoptions = {};
    }
    groupoptions[key] = value;
    newstate[groupInd]['group_options'] = groupoptions
    updateState(newstate)
  }
  const onChangeEmbManage=(groupid, key, value, itemid)=>{
    var newstate = [...state];    
    var groupoptions = newstate[groupid]['group_options']
    newstate = newstate.map((group, index)=>{
      if(groupid != index){
        return group;
      }
      else {
        return(
          group.map((item, index1)=>{
            if(index1 != itemid){
              return item;
            }
            else{
              var output = (
                {...item, [key]: value}
              )
              return output;
            }
          })
        )
      }
    })
    newstate[groupid]['group_options'] = groupoptions
    
    updateState(newstate)
  }
  const onChangeEmbCustom =(groupInd, key, value, custom_ind)=>{
    var newstate = [...state];
    var groupoptions = newstate[groupInd]['group_options']
    if(groupoptions == undefined || groupoptions == null){
      groupoptions = {};
    }
    groupoptions['customs'][custom_ind][key] = value;
    newstate[groupInd]['group_options'] = groupoptions
    updateState(newstate)
  }
  const onChangeEmbCustomTask =(groupInd, key, value, custom_ind, task_ind)=>{
    var newstate = [...state];
    var groupoptions = newstate[groupInd]['group_options']
    if(groupoptions == undefined || groupoptions == null){
      groupoptions = {};
    }
    var tasks = [...groupoptions['customs'][custom_ind]['tasks']];
    var task = {...tasks[task_ind]}
    task[key] = value;
    if(key == "task_name"){
      task['task_label'] = '';
      if(value){
        for(var i = 0; i < taskOptions.length; i++){
          if(taskOptions[i].uuid == value){
            task['task_label'] = taskOptions[i].name;
          }
        }
      }
    }
    tasks[task_ind] = task;
    groupoptions['customs'][custom_ind]['tasks'] = tasks

    newstate[groupInd]['group_options'] = groupoptions
    console.log("task changed", newstate)
    updateState(newstate)
  }
  const onAddTask =(groupInd, custom_ind)=>{
    var newstate = [...state];
    var groupoptions = newstate[groupInd]['group_options']
    if(groupoptions == undefined || groupoptions == null){
      groupoptions = {};
    }
    var tasks;
    if(groupoptions['customs'][custom_ind]['tasks'])  
      tasks = [...groupoptions['customs'][custom_ind]['tasks']];
    else
      tasks = [];
    var task = {}
    task['task_qty'] = 0;
    task['task_note'] = "";
    task['task_desc'] = ""; // mykhailo
    task['task_price'] = 0;
    task['id'] = String((tasks?tasks.length:0)+1);
    tasks.push(task);

    groupoptions['customs'][custom_ind]['tasks'] = tasks;
    newstate[groupInd]['group_options'] = groupoptions
    updateState(newstate)
    
  }
  
  const onChangeEmbCustomFee =(groupInd, key, value, custom_ind)=>{ 
    if(props.quote.status == 'Completed Quote' && role != 'admin'){
      props.setOpenConfirmEditModal(true);
      return false;
    }

    var newstate = [...state];
    var groupoptions = newstate[groupInd]['group_options']
    if(groupoptions == undefined || groupoptions == null){
      groupoptions = {};
    }
    if(key == "catalogue" && value) {
      // var customfee_price = supplier_fee[value]['price']
      var customfee_price = (supplier_fee[value] && !isNaN(supplier_fee[value]['price'])) ? supplier_fee[value]['price'] : 0
      groupoptions['customfees'][custom_ind]['customfee_price'] = customfee_price;
    }
    groupoptions['customfees'][custom_ind][key] = value;
    newstate[groupInd]['group_options'] = groupoptions
    updateState(newstate)
  }

  const onChangeEmbCustomDiscount =(groupInd, key, value)=>{ 
    if(props.quote.status == 'Completed Quote' && role != 'admin'){
      props.setOpenConfirmEditModal(true);
      return false;
    }

    var newstate = [...state];
    var groupoptions = newstate[groupInd]['group_options']
    if(groupoptions == undefined || groupoptions == null){
      groupoptions = {};
    }
    if(!groupoptions['discount']){
      groupoptions['discount'] = {};
    }
    groupoptions['discount'][key] = value;
    newstate[groupInd]['group_options'] = groupoptions
    updateState(newstate)
  }
  
  const onChangeBrandLogoFile = (groupInd, itemId, e) => {
    if (e.target.files[0]) {
      setUploadingFile(true);
      var bodyFormData = new FormData();
      bodyFormData.append('brand', e.target.files[0]);
      axios.post(`/assets/add`, bodyFormData).then(res => {
        const result = res.data;
        setUploadingFile(false);
        if (result.status === "success") {
          toast.success("Your logo has been added");
          var logo_file = { ...result.data, archive: false };

          var newState = [...state];
          var groupoptions = newState[groupInd]['group_options'];
          var itemsInGroup = [...newState[0]];

          itemsInGroup = itemsInGroup.map((item, index1) => {
            if (index1 !== itemId) return item;
            var logo_files = item['logo_files'] ? [...item['logo_files']] : [];
            logo_files = [...logo_files, logo_file];
            var uploaded_name = (logo_file && logo_file.filename) ? logo_file.filename : e.target.files[0].name;
            var logo_name = item['logo_name'] ? item['logo_name'] : uploaded_name;
            return { ...item, logo_files, logo_name };
          });

          newState[0] = itemsInGroup;
          newState[0]['group_options'] = groupoptions;
          updateState(newState);
        } else {
          toast.error(result.data);
        }
      }).catch(err => {
        setUploadingFile(false);
        toast.error('Something was wrong. Try again');
      });
      e.target.value = null;
    }
  };

  const onChangeBrandVisualFile=(groupInd, itemId, e)=>{
    if(e.target.files[0]){
      // if(e.target.files[0].name.includes("'")){
      //   toast.error('File name is invalid');
      //   return
      // }
      setUploadingFile(true)
      var bodyFormData = new FormData();
      bodyFormData.append('brand', e.target.files[0]); 
      axios.post(`/assets/add`, bodyFormData).then(res => {
        const result = res.data;        
        setUploadingFile(false)
        if(result.status == "success"){        
          toast.success("Your visual has been added");
          var visuals = result.data;
          onChangeEmbDecoration(groupInd, "visuals", visuals, itemId)
        }
        else{
          toast.error(result.data);
        }
      }).catch(err => {     
        setUploadingFile(false)
        toast.error('Something was wrong. Try again');
      })
      e.target.value = null
    }
  }
  // const onChangeEmbDecoration =(groupInd, key, value, decoration_ind)=>{
  //   var newstate = [...state];
  //   var groupoptions = newstate[groupInd]['group_options']
  //   if(groupoptions == undefined || groupoptions == null){
  //     groupoptions = {};
  //   }
  //   groupoptions['decorations'][decoration_ind][key] = value;
  //   newstate[groupInd]['group_options'] = groupoptions
  //   console.log(newstate);
  //   updateState(newstate)
  // }

  const onAddEmbDiscount =(groupInd, itemid)=>{
    var newstate = [...state];    
    var groupoptions = newstate[groupInd]['group_options']
    newstate = newstate.map((group, index)=>{
      if(groupInd != index){
        return group;
      }
      else {
        return(
          group.map((item, index1)=>{
            if(index1 != itemid){
              return item;
            }
            else{
              var tmp =  {...item}
              var discounts = tmp['discounts'];
              if(!discounts){
                discounts = [];
              }
              var newDiscount = {
                setup_discount_enable:false,
                setup_discount:0,
                setup_discount_other:'',
                setup_discount_qty:0,
                setup_discount_cost:0,
                setup_discount_value:0,
              }
              discounts.push(newDiscount)
              tmp['discounts'] = discounts;
              return tmp;
            }
          })
        )
      }
    })
    newstate[groupInd]['group_options'] = groupoptions
    
    updateState(newstate)
  }

  const onRemoveEmbDiscount =(groupInd, itemid, discountInd)=>{
    var newstate = [...state];    
    var groupoptions = newstate[groupInd]['group_options']
    newstate = newstate.map((group, index)=>{
      if(groupInd != index){
        return group;
      }
      else {
        return(
          group.map((item, index1)=>{
            if(index1 != itemid){
              return item;
            }
            else{
              var tmp =  {...item}
              var discounts = tmp['discounts'];
              if(!discounts){
                discounts = [];
              }
              var newDiscounts = [...discounts]
              newDiscounts.splice(discountInd, 1);
              tmp['discounts'] = newDiscounts;
              return tmp;
            }
          })
        )
      }
    })
    newstate[groupInd]['group_options'] = groupoptions
    
    updateState(newstate)
  }

  const getDigitalPrintCost = (code, qty)=>{   
    console.log("film_costs", film_costs_arry) 
    var code_key = code
    var qty_key
    if(!code || code == 'None'){
      return 0
    }
    qty = qty*1
    if(isNaN(qty)) qty = 0;
    if(qty < 25){
      return 0
    }
    if(qty > 5000){
      return 0
    }

    if(qty >= 25 && qty <= 49){
      qty_key = `25 - 49`
    }
    else if(qty >= 50 && qty <= 5000){
      qty_key = `50 - 5000`
    }
    
    return film_costs_arry[code_key][qty_key]?film_costs_arry[code_key][qty_key]:0
  }

  const calculateEmbLookupQty = (searchItem, inGroup = false)=>{
    var lookup_qty = searchItem['qty']*1;
    var newstate = [...state];
    var group = [];
    if(inGroup){
      group = inGroup
    }
    else{
      group = state[0];
    }
    
    var postion = 0;
    for(var i = 0; i < group.length; i++){
      var item = group[i];
      if(item.type == 'decoration' && item.code== "Embroidery"){
        if(searchItem.setup_emb == item.setup_emb && searchItem.setup_sc == item.setup_sc && ((searchItem.supplier?searchItem.supplier:'') == (item.supplier?item.supplier:'')) && searchItem.id != item.id ) {
          lookup_qty+= item.qty*1
        }
      }
    }
    return lookup_qty;
  }

  const calculateEmbLookupSetupQty = (searchItem)=>{
    var lookup_qty = searchItem['setup_qty']*1;
    var newstate = [...state];
    var group = state[0];
    var postion = 0;
    for(var i = 0; i < group.length; i++){
      var item = group[i];
      if(item.type == 'decoration' && item.code== "Embroidery"){
        if(searchItem.setup_emb == item.setup_emb && searchItem.setup_sc == item.setup_sc && ((searchItem.supplier?searchItem.supplier:'') == (item.supplier?item.supplier:'')) && searchItem.id != item.id) {
          lookup_qty+= item.setup_qty*1
        }
      }
    }
    return lookup_qty;
  }

  const getEmbSetupCost = async (groupid, searchItem, itemid, key =false, value)=>{
    var qty = searchItem['qty'];
    var setup_sc = searchItem['setup_sc'];
    var supplier = searchItem['supplier'];
    var position = searchItem['position'];
    var unit_cost = 0;
    var setup_unit_cost = 0;
    var calculated =false    
    var lookup_qty = calculateEmbLookupSetupQty(searchItem)
    console.log("lookup_qty", lookup_qty)
    if(supplier == 'PW'){
      if(lookup_qty>=10 && lookup_qty <=50){
        setup_unit_cost = 28.75
      }
      else if(lookup_qty >= 51 && lookup_qty <= 100){
        setup_unit_cost = 17.25
      }
      else if(lookup_qty >= 100){
        setup_unit_cost = 0
      }

      var newstate = [...state];    
      var groupoptions = newstate[groupid]['group_options']
      var changedCode;
      newstate = 
      await Promise.all(newstate.map(async (group, index)=>{
        if(groupid != index){
          return group;
        }
        else {
          return(
            await Promise.all(
            group.map(async (item, index1)=>{
              if(index1 != itemid){
                return item;
              }
              else{
                {
                  var output = (
                    {...searchItem}
                    // {...item, [key]: value}
                  )
                  return output;
                }
              }
            })
            )
          )
        }
      }))
      newstate = 
      await Promise.all(newstate.map(async (group, index)=>{
        if(groupid != index){
          return group;
        }
        else {
          return(
            await Promise.all(
            group.map(async (item, index1)=>{
              if(item.type == 'decoration' && item.code== "Embroidery"){
                if(searchItem.setup_emb == item.setup_emb && searchItem.setup_sc == item.setup_sc && ((searchItem.supplier?searchItem.supplier:'') == (item.supplier?item.supplier:''))) {
                  var output = (
                    {...item, setup_unit_cost: setup_unit_cost}
                  )
                  if(key == 'supplier'){
                    output = (
                      {...output, [key]: supplier}
                    )
                  }
                  return output;
                }
                else{
                  var tmp_setup_unit_cost= 0;
                  var qty = calculateEmbLookupQty(item, group)
                  if(qty>=10 && qty <=50){
                    tmp_setup_unit_cost = 28.75
                  }
                  else if(qty >= 51 && qty <= 100){
                    tmp_setup_unit_cost = 17.25
                  }
                  else if(qty >= 100){
                    tmp_setup_unit_cost = 0
                  }

                  var output = (
                    {...item, setup_unit_cost: tmp_setup_unit_cost}
                  )
                  return output;
                }
              }
              else{
                return item;
              }
            })
            )
          )
        }
      }))
      newstate[groupid]['group_options'] = groupoptions
      
      console.log("decoration changed", newstate)
      updateState(newstate)
    }
  }
  

  const onBlurGetEmbCost = async (groupid, searchItem, itemid, key =false, value)=>{
    var qty = searchItem['qty'];
    var setup_sc = searchItem['setup_sc'];
    var supplier = searchItem['supplier'];
    var position = searchItem['position'];
    var lookup_qty = calculateEmbLookupQty(searchItem)
    console.log("lookup_qty", lookup_qty)
    props.setLoading(true) 
    var unit_cost = 0;
    if(supplier == 'PW'){
      if(lookup_qty<10){
        unit_cost = 5.50
      }
      else if(lookup_qty >= 10){
        unit_cost = 3.45
      }
    }
    else{
      var url = `/customerBrands/getcost?sc=${setup_sc?setup_sc:0}&qty=${lookup_qty?lookup_qty:0}`
      if(supplier == 'JS'){
        url = `${url}&supplier=JS`
      }
      var res = await axios.get(url) 
      if(res.data.status == "success"){
        unit_cost = res.data.data?res.data.data:0
      }
    }
    var newstate = [...state];    
    var groupoptions = newstate[groupid]['group_options']
    var changedCode;
    newstate = 
    await Promise.all(newstate.map(async (group, index)=>{
      if(groupid != index){
        return group;
      }
      else {
        return(
          await Promise.all(
          group.map(async (item, index1)=>{
            if(index1 != itemid){
              return item;
            }
            else{
              {
                var output = (
                  {...searchItem}
                  // {...item, [key]: value}
                )
                return output;
              }
            }
          })
          )
        )
      }
    }))
    newstate = 
    await Promise.all(newstate.map(async (group, index)=>{
      if(groupid != index){
        return group;
      }
      else {
        return(
          await Promise.all(
          group.map(async (item, index1)=>{
            if(item.type == 'decoration' && item.code== "Embroidery"){
              if(searchItem.setup_emb == item.setup_emb && searchItem.setup_sc == item.setup_sc && ((searchItem.supplier?searchItem.supplier:'') == (item.supplier?item.supplier:''))) {                
                var output = (
                  {...item, unit_cost: (unit_cost*1).toFixed(2)}
                )
                return output;
              }
              else{
                var lookup_qty = calculateEmbLookupQty(item, group)
                var url = `/customerBrands/getcost?sc=${item['setup_sc']?item['setup_sc']:0}&qty=${lookup_qty?lookup_qty:0}`
                var supplier = item['supplier'];
                if(supplier == 'JS'){
                  url = `${url}&supplier=JS`
                }
                var res = await axios.get(url)   
                // props.setLoading(false)           
                var unit_cost_tmp = 0;
                if(res.data.status == "success")
                unit_cost_tmp = res.data.data?res.data.data:0
                  var output = (
                    {...item, unit_cost: (unit_cost_tmp*1).toFixed(2)}
                  )
                  return output;
              }
            }
            else{
              return item;
            }

          })
          )
        )
      }
    }))
    newstate[groupid]['group_options'] = groupoptions
    
    console.log("decoration changed", newstate)
    updateState(newstate)
    props.setLoading(false)  
  }

  const automatedSizeCalculation = (height, width, qty) => {
    console.log("automatedSizeCalculation called", height, width, qty)
    const baseWidth = 300;
    const padding = 4; 
    const logoWidth = Number(width) + padding;
    const logoHeight = Number(height) + padding;
    const quantity = Number(qty);

    if (logoWidth <= 0 || logoHeight <= 0 || quantity <= 0) {
      return 0;
    }

    const calculateMetresForOrientation = (printWidth, printHeight) => {
      const logosPerRow = Math.floor(baseWidth / printWidth);
      if (logosPerRow <= 0){
        return 0;
      }

      const rows = Math.ceil(quantity / logosPerRow);
      const totalHeightInMM = rows * printHeight;

      return (totalHeightInMM / 1000) + 1;
    }

    let metres = calculateMetresForOrientation(logoWidth, logoHeight);

    if (metres <= 0){
      metres = calculateMetresForOrientation(logoHeight, logoWidth);
    }

    if (metres <= 0){
      return 0;
    }

    return Number(metres.toFixed(4));
  }

  const onChangeEmbDecoration =async (groupid, key, value, itemid, discountInd=0)=>{
    var resultItem = false;
    var newState = [...state];    
    var groupoptions = newState[groupid]['group_options']
    var changedCode;
    var itemsInGroup = [...newState[0]];
    itemsInGroup = 
    itemsInGroup.map((item, index1)=>{
      if(index1 != itemid){
        return item;
      }
      else{
        if(
          key == "setup_discount_enable" ||
          key == "setup_discount" ||
          key == "setup_discount_other" ||
          key == "setup_discount_qty" ||
          key == "setup_discount_cost" ||
          key == "setup_discount_qty" ||
          key == "setup_discount_value"
        ){
          // var output =  {...item, [key]: value}
          var output =  {...item}
          var discounts = output['discounts'];
          discounts = discounts.map((discount, dInd)=>{
            if(dInd != discountInd){
              return discount;
            }
            else{
              return({...discount, [key]: value})
            }
          })
          output = {...output, discounts}                
          resultItem = {...output};
          return output;
        }
        else if(key == 'visuals'){
          var output =  {...item}                
          var visuals = output['visuals'];
          if(!visuals) visuals = [];
          visuals = [...visuals, value];
          output = {...output, visuals}
          resultItem = {...output};
          return output;
        }
        else if(key == 'remove_visuals'){
          var output =  {...item}                
          var visuals = output['visuals'];
          if(!visuals) visuals = [];
          visuals.splice(value, 1)
          resultItem = {...output};
          output = {...output, visuals}
          return output;
        }
        else if (key == 'logo_files') {
          var output = { ...item };
          var logo_files = output['logo_files'];
          if (!logo_files) logo_files = [];
          logo_files = [...logo_files, value];
          output = { ...output, logo_files };
          resultItem = { ...output };
          return output;
        }
        else if (key == 'remove_logo_files') {
          var output = { ...item };
          var logo_files = output['logo_files'];
          if (!logo_files) logo_files = [];
          logo_files = [...logo_files]; 
          logo_files.splice(value, 1);
          output = { ...output, logo_files };
          resultItem = { ...output };
          return output;
        }
        else if(key == 'logo_archive_file'){
          var output = {...item};
          var logo_files = output['logo_files'];
          if (!logo_files) logo_files = [];

          logo_files = logo_files.map((logo, lInd) => {
            if (lInd != value.index) {
              return logo;
            }

            return {
              ...logo,
              archive: value.value,
            };
          });

          output = {...output, logo_files};

          resultItem = {...output};
          return output;
        }
        else if(key == 'logo_file'){
          var output =  {...item}       
          output = {...output, [key]: value}
          resultItem = {...output};
          return output;
        }
        else if(key == 'archive_file'){
          var output =  {...item}       
          output = {...output, [key]: value}
          output.visuals = output.visuals.map((visual, vInd)=>{
            if(vInd != output?.archive_file?.index){
              return visual;
            }
            else{
              return {
                ...visual,
                archive: value.value,
              }
            }
          })

          resultItem = {...output};
          return output;
        }
        else{
          var output = (
            {...item, [key]: value}
          )
          if(key == 'qty'){
            output = {...output, qty_mode: 'manual'}
          }
          resultItem = {...output};
          return output;
        }
      }
    })

    newState[0] = itemsInGroup
    newState[0]['group_options'] = groupoptions    
    console.log("decoration changed", newState)
    updateState(newState)
    return resultItem
  }

  const onBlurEmbDecoration =async (groupid, key, value, itemid, discountInd=0)=>{
    var resultItem = false;
    var newstate = [...state];    
    var groupoptions = newstate[groupid]['group_options']
    var changedCode;
    newstate = 
    await Promise.all(newstate.map(async (group, index)=>{
      if(groupid != index){
        return group;
      }
      else {
        return(
          await Promise.all(
          group.map(async (item, index1)=>{
            if(index1 != itemid){
              return item;
            }
            else{
              if(
                key == "setup_discount_enable" ||
                key == "setup_discount" ||
                key == "setup_discount_other" ||
                key == "setup_discount_qty" ||
                key == "setup_discount_cost" ||
                key == "setup_discount_qty" ||
                key == "setup_discount_value"
              ){
                // var output =  {...item, [key]: value}
                var output =  {...item}
                var discounts = output['discounts'];
                discounts = discounts.map((discount, dInd)=>{
                  if(dInd != discountInd){
                    return discount;
                  }
                  else{
                    return({...discount, [key]: value})
                  }
                })
                output = {...output, discounts}                
                resultItem = {...output};
                return output;
              }
              else if(key == 'visuals'){
                var output =  {...item}                
                var visuals = output['visuals'];
                if(!visuals) visuals = [];
                visuals = [...visuals, value];
                output = {...output, visuals}
                resultItem = {...output};
                return output;
              }
              else if(key == 'remove_visuals'){
                var output =  {...item}                
                var visuals = output['visuals'];
                if(!visuals) visuals = [];
                visuals.splice(value, 1)
                resultItem = {...output};
                output = {...output, visuals}
                return output;
              }
              else{
                var output = (
                  {...item, [key]: value}
                )
                if(key == 'qty' && item['position'] == 'Other'){
                  output['qty_mode'] = 'manual';
                }
                if(key == 'code' || key == 'position'){
                  var code = item['code']
                  var position = item['position']                
                  if(key == 'code')
                    code = value
                  if(key == 'position')
                    position = value
                  if(code && position == 'Other'){
                    output['qty_mode'] = 'manual';
                    if(!output['position_label'] && otherText){
                      output['position_label'] = otherText;
                    }
                  }
                  else if(code && position){
                    output['qty_mode'] = 'auto';
                    output['qty'] = 0;
                    var positionSum = {};
                    for(var i in positionList){
                      positionSum[positionList[i]] = 0;
                    }
                    for(var loop = 0; loop < group.length; loop++){
                      var item = group[loop]
                      // if(item.type == "decoration"){
                      //   for(var i in positionList){
                      //     positionSum[positionList[i]] = 0;
                      //   }
                      // }
                      if(group.length == loop){
                        break;
                      }
                      var qty = item['qty']?item['qty']:0;
                      if(item.type== 'product'){
                        for(var i in positionList){
                          if(item['position']&& item['position'][positionList[i]])
                            positionSum[positionList[i]]+= (qty*1);
                        }
                      }
                    }
                    if(output['position'] == position)
                      output['qty'] = positionSum[position];
                    
                    console.log("position sum", positionSum)
                  }
                  else{
                    output['qty_mode'] = 'auto';
                    output['qty'] = 0
                    output['unit_cost'] = 0
                    output['price'] = 0
                    output['setup_sc'] = 0
                    output['setup_size'] = ""
                    output['setup_color'] = ""
                    output['setup_screen'] = 0
                    output['setup_notes'] = 0
                    // output['setup_code'] = 0
                    output['setup_qty'] = 0
                    output['setup_unit_cost'] = 0
                    output['setup_price'] = 0                    
                    output['setup_color_change_qty'] = 0
                    output['setup_color_change_unit_cost'] = 0
                    output['setup_color_change_price'] = 0
                    output['setup_discount'] = 0
                    output['setup_discount_other'] = ''
                    output['setup_discount_qty'] = 0
                    output['setup_discount_cost'] = 0
                    output['setup_discount_value'] = 0
                    output['setup_emb'] = ""
                  }
                }
                if(key == 'setup_emb'){
                  if(embProductions){
                    for(var i=0; i<embProductions.length; i++){
                      if(embProductions[i]['id'] == value){
                        applyProductionDataToDecoration(output, embProductions[i]);
                        // output['file_path'] = embProductions[i]['file_path'];
                        // output['setup_sc'] = embProductions[i]['stitch_count'];
                        // output['setup_size'] = embProductions[i]['size'];
                        // output['setup_color'] = embProductions[i]['colours'];
                      }
                    }
                  }
                }
                
                if(key == 'setup_screen'){
                  if(screenProductions){
                    for(var i=0; i<screenProductions.length; i++){
                      if(screenProductions[i]['id'] == value){
                        applyProductionDataToDecoration(output, screenProductions[i]);
                        // output['file_path'] = screenProductions[i]['file_path'];
                        // output['setup_sc'] = screenProductions[i]['stitch_count'];
                        // output['setup_size'] = screenProductions[i]['size'];
                        // output['setup_color'] = screenProductions[i]['colours'];
                      }
                    }
                  }
                  
                  if(digitalProductions){
                    for(var i=0; i<digitalProductions.length; i++){
                      if(digitalProductions[i]['id'] == value){
                        applyProductionDataToDecoration(output, digitalProductions[i]);
                        // output['file_path'] = digitalProductions[i]['file_path'];
                        // output['setup_sc'] = digitalProductions[i]['stitch_count'];
                        // output['setup_size'] = digitalProductions[i]['size'];
                        // output['setup_color'] = digitalProductions[i]['colours'];
                      }
                    }
                  }

                  
                  if(vinylProductions){
                    for(var i=0; i<vinylProductions.length; i++){
                      if(vinylProductions[i]['id'] == value){
                        applyProductionDataToDecoration(output, vinylProductions[i]);
                        // output['file_path'] = vinylProductions[i]['file_path'];
                        // output['setup_sc'] = vinylProductions[i]['stitch_count'];
                        // output['setup_size'] = vinylProductions[i]['size'];
                        // output['setup_color'] = vinylProductions[i]['colours'];
                      }
                    }
                  }
                }
                if(output['code'] == 'Embroidery'){    
                  if(key == 'code' || key == "position"){ 
                    var position = output['position']
                    if(position){
                      props.setLoading(true)
                      var res = await axios.get(`/customerBrands/getbrand?user_id=${props.quote.user_id}&brand_id=${position}`)
                      if(res.data.status == "success"){
                        var data =  res.data.data;
                        if(data){
                          // output['qty'] = data.qty?data.qty:0
                          // output['unit_cost'] = data.unit_cost?data.unit_cost:0
                          // output['price'] = data.unit_price?data.unit_price:0
                          output['setup_sc'] = data.sc?data.sc:0
                          output['setup_size'] = data.size?data.size:""
                          output['setup_color'] = data.colours?data.colours:""
                          output['setup_screen'] = data.emb?data.emb:0
                          output['setup_notes'] = data.notes?data.notes:0
                          output['setup_code'] = data.setup_code?data.setup_code:0
                          output['setup_qty'] = data.setup_qty?data.setup_qty:0
                          output['setup_unit_cost'] = data.setup_unit_cost?data.setup_unit_cost:0
                          output['setup_price'] = data.setup_price?data.setup_price:0
                          output['setup_discount'] = data.setup_discount?data.setup_discount:0
                          output['setup_discount_other'] = data.setup_discount_other?data.setup_discount_other:''
                          output['setup_discount_qty'] = data.setup_discount_qty?data.setup_discount_qty:0
                          output['setup_discount_cost'] = data.setup_discount_cost?data.setup_discount_cost:0
                          output['setup_discount_value'] = data.setup_discount_value?data.setup_discount_value:0
                          output['setup_emb'] = data.emb?data.emb:""
                        }
                      }
                      props.setLoading(false)
                    }
                  }
                  if(key =='qty' || key =='setup_sc' || key =='position'){         
                    if(output['setup_sc'] && output['qty']){
                    }
                  }
                }
                if(output['code'] == 'Screen Print' || output['code'] == 'Screen Print 2C'){ 
                  if(key =="code"){
                    output['setup_sc'] = 0
                    output['setup_size'] = ""
                    output['setup_color'] = ""
                    output['setup_screen'] = 0
                    output['setup_notes'] = 0
                    output['setup_qty'] = 0
                    output['setup_unit_cost'] = 50
                    output['setup_price'] = 50
                    output['setup_color_change_qty'] = 0
                    output['setup_color_change_unit_cost'] = 0
                    output['setup_color_change_price'] = 0                    
                    output['setup_discount'] = 0
                    output['setup_discount_other'] = ''
                    output['setup_discount_qty'] = 0
                    output['setup_discount_cost'] = 0
                    output['setup_discount_value'] = 0
                    output['setup_emb'] = ""
                  }
                  if(key =="code" || key =='qty' || key =='setup_sc' || key =='position' || key =='setup_qty' || key == 'setup_code' || key == 'setup_screen'){ 
                    if(output['code'] == 'Screen Print'){   
                      if(output['qty'] <= 25){
                        output['unit_cost'] = 3.2
                        output['price'] = 9.4
                      }
                      else if(output['qty'] > 25 && output['qty'] <= 60){
                        output['unit_cost'] = 2.75
                        output['price'] = 8.9
                      }
                      else if(output['qty'] > 60){
                        output['unit_cost'] = 2
                        output['price'] = 7.9
                      }
                    }
                    else if(output['code'] == 'Screen Print 2C'){ 
                      if(output['qty'] <= 25){
                        output['unit_cost'] = 3.9
                        output['price'] = 0
                      }
                      else if(output['qty'] > 25 && output['qty'] <= 60){
                        output['unit_cost'] = 3.45
                        output['price'] = 0
                      }
                      else if(output['qty'] > 60){
                        output['unit_cost'] = 2.7
                        output['price'] = 0
                      }
                      output['price'] = 9.9
                    }
                    if(output['code'] == 'Screen Print'){     
                      if(output['position'] == 'Sleeve Upper Left' || output['position'] == 'Sleeve Upper Right'){
                        output['unit_cost'] = 4
                        output['price'] = 10
                      }
                    }
                    
                    if(output['setup_code'] == 'New Set Up'){
                      output['setup_unit_cost'] = 50
                      output['setup_price'] = 100
                    }
                    
                    if(output['setup_code'] == 'Repeat Set Up'){
                      output['setup_unit_cost'] = 20
                      output['setup_price'] = 45
                    }
                  }
                }
                
                if(output['code'] == 'Digital Print'){
                  changedCode = 'Digital Print'
                  if(key == 'code'){
                    output['setup_qty'] = 0
                    output['setup_unit_cost'] = 0
                    output['film_qty'] = 0
                    output['film_unit_cost'] = 1 //mykhailo
                    output['heat_unit_cost'] = 1
                    // output['heat_qty'] = getTotalGarments(group, index1)
                    output['heat_qty'] = 0
                    output['heat_code'] = output['position']
                  }
                  
                  if(key == 'position'){
                    output['heat_code'] = output['position']
                  }
                  if(key == 'setup_code' || key == 'setup_qty'){
                    if(output['setup_code'] == 'None' && key == 'setup_code'){
                      output['setup_qty'] = 0
                      output['setup_unit_cost'] = 0
                    }
                    else{
                      output['setup_qty'] = 1
                      output['setup_unit_cost'] = 30
                    }
                  }
                  if(key =='film_code' || key =='film_qty') {                    
                    // if(output['film_code'] == 'None' && key =='film_code'){
                    //   output['film_qty'] = 0
                    //   output['film_unit_cost'] = 0
                    // }
                    // else
                    //   output['film_unit_cost'] = getDigitalPrintCost(output['film_code'], output['film_qty']); // mykhailo
                  }

                  // mykhailo 20251011
                  if(key =='film_metres') { 
                    // var logo_size = [];
                    // var mesuredCount = getFilmSizeFromMetres(output['film_metres'], 105, 55);
                    // output['film_qty'] = mesuredCount;
                  }

                  if (
                      key == 'setup_size_width' ||
                      key == 'setup_size_height' ||
                      key == 'qty' ||
                      key == 'setup_screen'
                    )
                  {
                    let width = Number(output['setup_size_width']);
                    let height = Number(output['setup_size_height']);
                    let qty = Number(output['qty']);

                    console.log("width height qty changed", width, height, qty)

                    if(width > 0 && height > 0 && qty > 0){
                      let metres = automatedSizeCalculation(height, width, qty);
                      output['film_qty'] = metres;
                      console.log("calculated metres", metres)
                    }
                  }

                }
                
                if(output['code'] == 'Vinyl Print'){ 
                  changedCode = 'Vinyl Print'
                  if(key == 'code'){
                    output['setup_qty'] = 0
                    output['setup_unit_cost'] = 0
                    output['film_qty'] = 0
                    output['film_unit_cost'] = 1 //mykhailo from 0
                    output['heat_unit_cost'] = 1
                    output['heat_qty'] = 0
                    output['heat_code'] = output['position']
                  }
                  if(key == 'position'){
                    output['heat_code'] = output['position']
                  }
                  if(key =="code" || key =='qty' || key =='setup_sc' || key =='position' || key =='setup_qty' || key == 'setup_code' || key == 'setup_screen'){ 
                                        
                    if(output['setup_code'] == 'New Set Up'){
                      output['setup_unit_cost'] = 50
                      output['setup_price'] = 50
                    }
                    
                    if(output['setup_code'] == 'Repeat Set Up'){
                      output['setup_unit_cost'] = 50
                      output['setup_price'] = 50
                    }
                    if(output['setup_code'] == 'None'){
                      output['setup_unit_cost'] = 0
                      output['setup_price'] = 0
                    }
                  }
                }
                resultItem = {...output};
                return output;
              }
            }
          })
          )
        )
      }
    }))

    

    if(changedCode == 'Digital Print'){
      if(key =='code' || key =='qty' || key =='setup_qty' || key =='setup_unit_cost' || key =='film_qty' || key =='film_unit_cost' || key == 'heat_qty' || key == 'heat_unit_cost' || key == 'setup_screen' || key == 'setup_size_width' || key == 'setup_size_height'){
        var itemsInGroup = [...newstate[0]];
        itemsInGroup = calcDigitalPrintPrice(itemsInGroup)
        newstate[0] = itemsInGroup
      }

      // mykhailo 20251011
      if(key == "film_metres"){
        var itemsInGroup = [...newstate[0]];
        itemsInGroup = calcDigitalPrintPrice(itemsInGroup)
        newstate[0] = itemsInGroup
      }

    }
    if( changedCode == 'Vinyl Print'){
      if(key =='code' || key =='qty' || key =='setup_qty' || key =='setup_unit_cost' || key =='film_qty' || key =='film_unit_cost' || key == 'heat_qty' || key == 'heat_unit_cost' || key == 'setup_screen' || key == 'setup_size_width' || key == 'setup_size_height'){
        var itemsInGroup = [...newstate[0]];
        itemsInGroup = calcVinylPrintPrice(itemsInGroup)
        newstate[0] = itemsInGroup
      }

      // mykhailo 20251011
      if(key == "film_metres"){
        var itemsInGroup = [...newstate[0]];
        itemsInGroup = calcDigitalPrintPrice(itemsInGroup)
        newstate[0] = itemsInGroup
      }
    }
    newstate[groupid]['group_options'] = groupoptions
    
    console.log("decoration changed", newstate)
    updateState(newstate)
    return resultItem
  }

  const onBlurEmb =(groupInd, key, value, custom_ind = 0)=>{
    
    var newstate = [...state];
    var groupoptions = newstate[groupInd]['group_options']
    if(groupoptions == undefined || groupoptions == null){
      groupoptions = {};
    }
    if(key == "customfee_price" && value) {
      groupoptions['customfees'][custom_ind][key] = (value*1).toFixed(2);
    }
    else{
      groupoptions['customfees'][custom_ind][key] = value;
    }
    newstate[groupInd]['group_options'] = groupoptions
    updateState(newstate)
  }

  const token = localStorage.getItem('token_bigbrand');    
  const user = localStorage.getItem('user_bigbrand');
  var role = ""
  if(user && user != undefined){
    var userinfo = JSON.parse(user)
    role = userinfo['role']
  }
  const getAddedCategories = ()=>{
    var catalogues = [];    
    var categories = {...props.quote.categories}
    var category = null
    for(var catInd in categories){
      var category = {...categories[catInd]}
      break;
    }
    var removedFeeArray= [];
    if(category) removedFeeArray = category['removed_fee'];

    for(var loop=0; loop<state.length; loop++){
      var items = state[loop];
      for(var loop1=0; loop1< items.length; loop1++){
        var code = items[loop1]['code']   
        if(items[loop1]['type']=="product"){
          var codeArry = code.split(" - ");
          var catalogue = codeArry[0];
          if(!(catalogues.includes(catalogue))){
            if(!removedFeeArray || (removedFeeArray && removedFeeArray.length == 0)){
              catalogues.push(catalogue);
            }
            else if((removedFeeArray && !removedFeeArray.includes(catalogue)))
              catalogues.push(catalogue);
          }
        }
      }
    }
    return catalogues
  }
  const renderCategoryFee = (el, ind)=>{
    return (
      <>
        <div className="categoryfee-head">
          <div
            className="p-2">
            <span className="label">Catalogue Fee</span>
          </div>
          <div
            className="p-2">
            <div className="expand-btn" onClick={()=>setOpenCategory(!openCategory)}>  
              {
                openCategory?
                <span style={{fontSize:36}} className="material-icons ">expand_less</span> :
                <span style={{fontSize:36}} className="material-icons ">expand_more</span>
              }            
            </div>
          </div>
        </div>
        {el['group_options']&&  el['group_options']['customfees'] &&
        
        <Collapse isOpened={openCategory}>
          <>
            {
              el['group_options']['customfees'].map((customfee, customfee_ind)=>{
                if((role == 'admin' || (customfee&& customfee['customfee_qty']*1 > 0))){
                  return(
                    <div key={customfee_ind}>
                      <div
                        style={getItemStyle(
                          false,
                          {},
                          customfee_ind,
                          'customfee'
                        )}
                        className={"table-row"}
                      >
                        <div
                          className="p-2"
                          style={{
                            width:25,
                            textAlign:'center'
                          }}
                        >
                          {role == 'admin' &&
                          <i className="fa fa-times mt-2"
                            style={{cursor:'pointer'}}
                            onClick={() => {
                              const newState = [...state];
                              newState[ind]['group_options']['customfees'].splice(customfee_ind, 1);
                              updateState(
                                newState.filter(group => group.length)
                              );
                            }}
                          ></i>
                          }
                        </div>
                        <div
                          className="p-2"
                          style={{
                            width:25,
                            textAlign:'center'
                          }}
                        >
                        </div>
                        <div
                          className="p-2"
                          style={{
                            width:310
                          }}>
                          <div className="d-block">
                            <div className="d-flex">
                              <Input disabled={mode=="view"?true:false} type="select" value = {customfee?customfee['catalogue']:""} name="code" onChange={(e)=>onChangeEmbCustomFee(ind, "catalogue", e.target.value,customfee_ind)}>
                                <option value=""></option>
                                {
                                  supplier_arry.map((item,index)=>(                                
                                    <option key={item['key']} value={item['key']}>{`Catalogue Service Fee - ${[item['label']]}`}</option>
                                  ))
                                }
                              </Input>
                              <label className="help-icon" style={{margin:"9px 0 0 11px"}} href="#" id={`categoryfee-tooltip-${ind}-${customfee_ind}`}>i</label>                  
                              {
                              <UncontrolledTooltip  placement="bottom" className="text-left justify-content-start" target={`categoryfee-tooltip-${ind}-${customfee_ind}`} trigger="hover focus">                   
                                
                                Get the best value for your organization with our lowest ticket prices in Australia! Our Wholesale Service Fee applies to each order you place and covers our costs for freight, handling, and administration. 
                                <br/><br/>
                                This fee gives you access to direct wholesale pricing from the chosen catalogue for that order. 
                                <br/><br/>
                                The fee is calculated based on the number of catalogues you are ordering from, so if you order from multiple catalogues, your service fee will be higher. 
                                <br/>
                                However, if you place a large volume order, you may be eligible for discounts on the service fee or it may be waived altogether. 
                                <br/>
                                To keep your costs down and qualify for discounts, it is recommended that you select your garments from as few catalogues as possible. 
                                <br/>
                                When you submit your quote request to us, one of our Brand Management Team members will help identify potential savings and finalise your quote for your approval. We are here to help you get the best value from your order."
                                
                              </UncontrolledTooltip >
                              }
                            </div>
                          </div>
                        </div>
                        <div
                          className="p-2 "
                          style={{
                            width:60
                          }}>
                            <Input disabled={true} type="text" value = {customfee?customfee['customfee_qty']:""} style={{textAlign:'center'}} onChange={(e)=>onChangeEmbCustomFee(ind, "customfee_qty", e.target.value,customfee_ind)}/>
                        </div>
                        <div
                          className="p-2 cost-field"
                          style={{
                            width:60
                          }}>          
                          {(role == 'admin' && cost_visible)&&         
                          <Input disabled={role != 'admin' || mode=="view"?true:false} type="text" value = {customfee?(customfee['customfee_cost']):""} onBlur={(e)=>onBlurEmb(ind, "customfee_cost", e.target.value,customfee_ind)} onChange={(e)=>onChangeEmbCustomFee(ind, "customfee_cost", e.target.value,customfee_ind)}/>
                          }
                        </div>
                        <div
                          className="p-2 cost-field"
                          style={{
                            width:60
                          }}>
                          {(role == 'admin' && cost_visible)&&   
                          <span className="p-2">${((customfee&&!isNaN(customfee.customfee_qty)&&!isNaN(customfee.customfee_cost))?(customfee['customfee_qty']*customfee['customfee_cost']):0).toFixed(2)}</span>
                          }
                        </div>
                        <div
                          className="p-2"
                          style={{
                            width:60
                          }}>                                      
                          <Input disabled={role != 'admin' || mode=="view"?true:false} type="text" value = {customfee?(customfee['customfee_price']):""} onBlur={(e)=>onBlurEmb(ind, "customfee_price", e.target.value,customfee_ind)} onChange={(e)=>onChangeEmbCustomFee(ind, "customfee_price", e.target.value,customfee_ind)}/>
                          </div>
                        <div    
                          className="p-2"                          
                          // {...provided.dragHandleProps}
                          style={{
                            width:60
                          }}>
                            <span className="p-2">${((customfee&&!isNaN(customfee.customfee_qty)&&!isNaN(customfee.customfee_price))?(customfee['customfee_qty']*customfee['customfee_price']):0).toFixed(2)}</span>
                          </div>
                        <div    
                          className="p-2 v-separator"                          
                          // {...provided.dragHandleProps}
                          style={{
                            width:30
                          }}></div>                                
                        <div    //select
                          className="p-1"                          
                          // {...provided.dragHandleProps}
                          style={{
                            width:0
                          }}>                          
                        </div>
                        <div
                          className="p-2"
                          style={{
                            display:'block',
                            width:380,
                          }}>
                        </div>
                      </div>
                    </div>
                  )
                }
              })
            }
          </>
        </Collapse>
        } 
      </>
    )
  }
  const renderCategoryDiscount = (el, ind)=>{
    var discount = el['group_options'].discount
    if(role != 'admin'){      
      var discount_val = getDiscountPriceExt(discount);
      if (discount_val === 0){
        return(<div></div>)
      }
    }
    
    return (
      <div>
        <div
          style={getItemStyle(
            false,
            {},
            0,
            'customfee'
          )}
          className={"table-row"}
        >
          <div
            className="p-2"
            style={{
              width:25,
              textAlign:'center'
            }}
          >
            
          </div>
          <div
            className="p-2"
            style={{
              width:25,
              textAlign:'center'
            }}
          >
          </div>
          <div
            className="p-2 justify-content-center"
            style={{
              width:310
            }}>
            <span className="p-2">Discount</span>
          </div>
          <div
            className="p-2 "
            style={{
              width:60
            }}>
              <Input disabled={role != 'admin' || mode=="view"?true:false} type="text" value = {discount?discount['qty']:""} style={{textAlign:'center'}} onChange={(e)=>onChangeEmbCustomDiscount(ind, "qty", e.target.value)}/>
          </div>
          <div
            className="p-2 cost-field"
            style={{
              width:60
            }}>          
            {(role == 'admin' && cost_visible)&&         
            <Input disabled={role != 'admin' || mode=="view"?true:false} type="text" value = {discount?(discount['cost']):""} onBlur={(e)=>onBlurEmb(ind, "cost", e.target.value)} onChange={(e)=>onChangeEmbCustomDiscount(ind, "cost", e.target.value)}/>
            }
          </div>
          <div
            className="p-2 cost-field"
            style={{
              width:60
            }}>
            {(role == 'admin' && cost_visible)&&   
            <span className="p-2">${getDiscountCost(discount).toFixed(2)}</span>
            }
          </div>
          <div
            className="p-2"
            style={{
              width:60
            }}>                                      
            <Input disabled={role != 'admin' || mode=="view"?true:false} type="text" value = {discount?(discount['price']):""} onBlur={(e)=>onBlurEmb(ind, "price", e.target.value)} onChange={(e)=>onChangeEmbCustomDiscount(ind, "price", e.target.value)}/>
            </div>
          <div    
            className="p-2"                          
            // {...provided.dragHandleProps}
            style={{
              width:60
            }}>
              <span className="p-2">${getDiscountPriceExt(discount).toFixed(2)}</span>
            </div>
          <div    
            className="p-2 v-separator"                          
            // {...provided.dragHandleProps}
            style={{
              width:30
            }}></div>                                
          <div    //select
            className="p-1"                          
            // {...provided.dragHandleProps}
            style={{
              width:0
            }}>                          
          </div>
          <div
            className="p-2"
            style={{
              display:'block',
              width:380,
            }}>
              <Input disabled={role != 'admin' || mode=="view"?true:false} type="text" value = {discount?(discount['description']):""} onBlur={(e)=>onBlurEmb(ind, "description", e.target.value)} onChange={(e)=>onChangeEmbCustomDiscount(ind, "description", e.target.value)}/>
          </div>
        </div>
      </div>
    )
  }
  
  const renderCategoryFee1 = (el, ind)=>{
    var catalogues = getAddedCategories();
    var element = catalogues.map((catalogue, index)=>{
      return(
        <div
          key={index}
          style={getItemStyle(
            false,
            {},
            0
          )}
          className="table-row"
        >
          <div
            className="p-2"
            style={{
              width:'25px'
            }}>
            {role == "admin" &&
            <i className="fa fa-times mt-2"
              style={{cursor:'pointer'}}
              onClick={() => {
                var state=[]
                var categories = {...props.quote.categories}
                var category = null
                for(var catInd in categories){
                  var category = {...categories[catInd]}
                  break;
                }
                var removedFeeArray= category['removed_fee'];
                if(!removedFeeArray) removedFeeArray = [];
                if(!removedFeeArray.includes(catalogue))
                  removedFeeArray.push(catalogue);

                var cat_val={
                  [0]:{...category,
                    removed_fee: removedFeeArray
                  }
                }
                props.updateCategory(cat_val)
              }}
            ></i>
            }
          </div>
          <div
            className="p-2"
            style={{
              width:'25px'
            }}>
          </div>
          <div
            className="p-2"
            style={{
              width:310
            }}>
              <div className="d-block">
                <div className="d-flex">
                  <Input style={{maxWidth:350}} type="text" readOnly name="fee_desc" value={`Catalogue Service Fee - ${supplier_short[catalogue]}`}>
                  </Input>
                  <label className="help-icon" style={{margin:"9px 0 0 11px"}} href="#" id={`categoryfee-tooltip-${ind}-${index}`}>i</label>                  
                  {
                  <UncontrolledTooltip  placement="bottom" className="text-left" target={`categoryfee-tooltip-${ind}-${index}`}>                   
                    Each catalog enters as sepeerate line as prices per catalog prices can be different.<br/>
                    Here is a spot for a brief description of what the service fee is and what they get or maybe this  comes up with a hover icon
                  </UncontrolledTooltip >
                  }
                </div>
                <div style={{maxWidth:500}} className="mt-1">
                  Each catalog enters as sepeerate line as prices per catalog prices can be different Here 
                  is a spot for a brief description of what the service fee is and what they get or maybe this 
                  comes up with a hover icon
                </div>
              </div>
          </div>
          <div
            className="p-2"
            style={{
              width:60,
              textAlign:'center'
            }}>
              <span className="p-2" style={{width:'100%', textAlign:'center'}}>{1}</span>
          </div>
          <div
            className="p-2 cost-field"
            style={{
               width:60
            }}>
              
          </div>
          
          <div
            className="p-2 cost-field"
            style={{
               width:60
            }}>
            &nbsp;
          </div>
          
          <div
            className="p-2"
            style={{
               width:60
            }}>
              <Input disabled={mode=="view"?true:false} type="text" value = {el['group_options']?el['group_options']["cat_fee_"+catalogue]:""} name="fee_price"  onChange={(e)=>onChangeEmb(0, "cat_fee_"+catalogue, e.target.value)}/>
          </div>
          <div
            className="p-2"
            style={{
               width:60
            }}><span className="p-2">${feePrice(catalogue, 0).toFixed(2)}</span></div>
          <div    //select
            className="p-2 v-separator"                          
            // {...provided.dragHandleProps}
            style={{
              width:30
            }}>                          
          </div>
          <div    //select
            className="p-1"                          
            // {...provided.dragHandleProps}
            style={{
              width:0
            }}>                          
          </div>
        </div>
      )
    })
    return element;
  }
  const renderProduct = (ind, index,item,provided)=>{
    return(
      <>
        <div
          className=""
          style={{
            width:'35px',
            textAlign:'center',
            padding:'0.5rem 0 0.5rem 0.5rem'
          }}
        >
          <i className="fa fa-times mt-2"
            style={{cursor:'pointer'}}
            onClick={async () => {
              
              if(props.quote.status == 'Completed Quote' && role != 'admin'){
                props.setOpenConfirmEditModal(true);
                return false;
              }
              const newState = [...state];
              newState[ind].splice(index, 1);

              var itemsInGroup = [...newState[0]];

              var group_options = {...state[0]['group_options']}
              if(("customfees" in group_options)){      
                var customfees = group_options['customfees'];
                var newCustomfees = [...customfees]
                for(var i =0; i < customfees.length; i++){
                  var customfee = customfees[i];
                  var catalogue = customfee['catalogue'];
                  var existing = false;
                  for(var j = 0; j< itemsInGroup.length; j++){
                    var item = itemsInGroup[j];
                    if(item.code){
                      var tmp = item.code.split(" - ");
                      if(catalogue == tmp[0]){
                        existing = true;
                        break;
                      }
                    }
                  }
                  if(!existing){
                    newCustomfees.splice(i, 1)
                  }
                }
                group_options['customfees'] = newCustomfees;
              }
              itemsInGroup = await updateBrandingQty(itemsInGroup)
              newState[0] = itemsInGroup
              newState[0]['group_options'] = group_options;

              updateState(
                newState.filter(group => group.length)
              );
            }}
          ></i>
          {
            role=='admin'?
            <span style={{color:item?.['need_attention']?'red':'black', marginLeft:'3px', cursor:'pointer', width:'10px'}}
              onClick={
                (e)=>{
                  onChangeProduct(ind, index, 'need_attention',  !(item?item['need_attention']:false))
                  let flag = !(item?item['need_attention']:false)
                  setTimeout(()=>{
                    if(flag){
                      addAttention(item, index)
                    }
                    else{
                      removeAttention(item, index)
                    }
                  }, 200)                      
                } 
              }
            >
              <i className="fa fa-exclamation mt-2"></i>
            </span>:
            <>{
              item?.['need_attention'] &&
              <i style={{color:'red', marginLeft:'5px'}} className="fa fa-exclamation mt-2"></i>
            }
            </>
          }
        </div>
        <div
          className=""
          style={{
            width:'15px',
            textAlign:'center',
            padding:'0.5rem 0 0.5rem 0'
          }}>
          <span className=" mt-2" style={{cursor:"pointer"}} onClick={()=>showProductImage(ind, index)} width="50px" height="50px"> <i className="fa fa-camera" aria-hidden="true"></i></span>
        </div>
        <div className="d-block">
          <div className="d-flex">
            <div
              className="p-2 d-flex align-items-center"
              style={{
                width:130
              }}>
                {item.subtype=="custom_product"?
                <Input disabled={mode=="view"?true:false} type="text" value = {item['code']} onChange={(e)=>onChangeProduct(ind, index, 'code', e.target.value)} onBlur={(e)=>onBlurProduct(ind, index, 'code', e.target.value)} name="code" style={{ textAlign:'left'}}/>
                :
                <>{item.code}</>           
                }
            </div>
            <div
              className="p-2 d-flex align-items-center"
              style={{
                width:180
              }}>
              {item.subtype=="custom_product"?
              <Input disabled={mode=="view"?true:false} type="text" value = {item['description']} onChange={(e)=>onChangeProduct(ind, index, 'description',  e.target.value)} onBlur={(e)=>onBlurProduct(ind, index, 'description', e.target.value)} name="code" style={{ textAlign:'left'}}/>
              :
              <>{item.description}</>           
              }
            </div>
            <div
              className="p-2 d-flex align-items-center"
              style={{
                width:60
              }}>
                <Input disabled={mode=="view"?true:false} type="number" value = {item['qty']} onChange={(e)=>onChangeProduct(ind, index, 'qty',  e.target.value)} onBlur={(e)=>onBlurProduct(ind, index, 'qty', e.target.value)} name="qty" style={{ textAlign:'center'}}/>
              </div>
            <div
              className="p-2 cost-field d-flex align-items-center"
              style={{
                width:60
              }}>{(role == 'admin' && cost_visible)&&
              <>
                {item.subtype=="custom_product" || 1?
                <Input disabled={mode=="view"?true:false} type="number" value = {item['cost']} onChange={(e)=>onChangeProduct(ind, index, 'cost',  e.target.value)} onBlur={(e)=>onBlurProduct(ind, index, 'cost', e.target.value)} name="code" style={{ textAlign:'center'}}/>
                :
                <span className="p-2">${ (item['cost']*1).toFixed(2)}</span>       
                }
              </>
              
              }
            </div>
            <div
              className="p-2 cost-field d-flex align-items-center"
              style={{
                width:60
              }}>{(role == 'admin' && cost_visible)&&<span className="p-2">${ getCost(item).toFixed(2)}</span>}
            </div>        
            <div
              className="p-2 d-flex align-items-center"
              style={{
                width:60
              }}>
                <>
                {item.subtype=="custom_product" || 1?
                <Input disabled={mode=="view"?true:false} type="number" value = {item['price']} onChange={(e)=>onChangeProduct(ind, index, 'price',  e.target.value)} onBlur={(e)=>onBlurProduct(ind, index, 'price', e.target.value)} name="price" style={{ textAlign:'center'}}/>
                :
                <span className="p-2">${ (item['price']*1).toFixed(2)}</span>       
                }
              </>
            </div>                                
            <div
              className="p-2 d-flex align-items-center"
              style={{
                width:60
              }}><span className="p-2">${ getPriceExt(item).toFixed(2)}</span>
            </div>
          </div>
        </div>
        <div //select all
          className="p-0 v-separator"
          style={{
            width:30, fontSize:11, color:'#f6ce0e'
          }}>
        </div>
        <div    //select
            className="p-1"                          
            // {...provided.dragHandleProps}
            style={{
              width:0
            }}>                          
          </div>
        <div
          className="p-2 d-flex"
          style={{
          }}>
          {
              positionList.map((position, PositionIndex) => (
                <>
                  <div className="text-center" style={{width:28}} key={`item-customCheck-${ind}-${index}-${position}`}>
                    <div className="w-100 custom-checkbox">
                        <input
                          
                          key={`item-customCheckInput-${ind}-${index}-${position}`}
                          className="custom-control-input"
                          id={`item-customCheckInput-${ind}-${index}-${position}`}
                          type="checkbox"
                          name="primary_set"
                          checked={item['position']&&item['position'][position]?item['position'][position]:false}
                          value={item['position']&&item['position'][position]?item['position'][position]:false}
                          onChange={(e)=>onChangeItemPosition(ind, index, position,(item['position']&&item['position'][position])?!item['position'][position]:true)}
                        />
                        <label onMouseEnter = {(e)=>{setHoverPosition(position)}} className="custom-control-label vertical" htmlFor={`item-customCheckInput-${ind}-${index}-${position}`}>
                        </label>
                      </div>
                  </div>
                </>
              ))
          }
          {/* <Input style={{width:90, marginTop:20}} type="text" name="other_brand" value={'Other'}>
          </Input> */}
        </div>
        <div    
          className="p-2"                          
          {...provided.dragHandleProps}
          style={{
            width:30
          }}><i className="fa fa-arrows" style={{marginTop:10}}></i>
        </div>
      </>
    )
  }

  const renderTask = (el, ind, custom_ind,custom)=>{
    return (
      <>
        <div
          className="p-2"
          style={{
            width:25,
            textAlign:'center'
          }}
        >
          {role == 'admin' &&
          <i className="fa fa-times mt-2"
            style={{cursor:'pointer'}}
            onClick={() => {
              const newState = [...state];
              newState[ind]['group_options']['customs'].splice(custom_ind, 1);
              updateState(newState);
            }}
          ></i>
          }
        </div>
        <div
          className="p-2"
          style={{
            width:25,
            textAlign:'center'
          }}
        >
        </div>
        <div
          className="p-2"
          style={{
            width:130,
            display:'block'
          }}>
          <Input style={{textAlign:'left'}} disabled={role != 'admin' || mode=="view"?true:false} type="select" value = {custom?custom['custom_code']:""} name="code" onChange={(e)=>onChangeEmbCustom(ind, "custom_code", e.target.value,custom_ind)}>
            <option value="">None</option>
            {
              templates.map((item,index)=>(                                
                <option key={item['uuid']} value={item['uuid']}>{item['name']}</option>
              ))
            }
          </Input>
          {role == 'admin' &&
          <div onClick={()=>onAddTask(ind, custom_ind)} className="d-flex mt-2 align-items-center category-subtitle small" style={{cursor:'pointer'}}>
            <span className="logo-plus-icon mr-2 ml-0" style={{fontSize:20}}>
              +        
            </span>
            <span className="label">Add Task</span>
          </div>
          }
        </div>
        <DragDropContext onDragEnd={(result)=>onDragEndTask(result, custom_ind)}>
          <Droppable droppableId ={`0`}>
            {(provided, snapshot) => (
              <div className="d-block"
                ref={provided.innerRef}
                // style={getListStyle(snapshot.isDraggingOver)}
                {...provided.droppableProps}
              >
                {(custom['tasks'] && custom['tasks'].length>0) ?
                <>
                  {custom['tasks'].map((item, index) => (
                    <>
                    {(role =='admin' || item['task_checked'])&&
                      <Draggable
                      key={item.id}
                      draggableId={`task_${index+1}`}
                      index={index}
                      >
                        {(provided, snapshot) => (
                          <div
                          ref={provided.innerRef}    
                          {...provided.draggableProps}
                          style={getItemStyle1(
                            snapshot.isDragging,
                            provided.draggableProps.style,
                            custom_ind,
                            index,
                            item.type,
                            custom['tasks'].length
                          )}
                          className="table-row"
                          >
                            <div
                              className="p-2"
                              style={{
                                width:25,
                                textAlign:'center'
                              }}
                            >
                              {role == 'admin' &&
                              <i className="fa fa-times mt-2"
                                style={{cursor:'pointer'}}
                                onClick={() => {
                                  const newState = [...state];
                                  newState[ind]['group_options']['customs'][custom_ind]['tasks'].splice(index, 1);
                                  updateState(newState);
                                }}
                              ></i>
                              }
                            </div>
                            <div
                              className="p-2"
                              style={{
                                width:155
                              }}>
                              <Input style={{textAlign:'left'}} disabled={role != 'admin' || mode=="view"?true:false} type="select" value = {item?item['task_name']:""} name="code" onChange={(e)=>onChangeEmbCustomTask(ind, "task_name", e.target.value,custom_ind, index)}>
                                <option value="">None</option>
                                {
                                  taskOptions.map((item,index)=>(                                
                                    <option key={item['uuid']} value={item['uuid']}>{item['name']}</option>
                                  ))
                                }
                              </Input>
                            </div>
                            <div
                              className="p-2 "
                              style={{
                                width:60
                              }}>
                                <Input disabled={role != 'admin' || mode=="view"?true:false} type="number" value = {item?item['task_qty']:""} style={{textAlign:'center'}} onChange={(e)=>onChangeEmbCustomTask(ind, "task_qty", e.target.value,custom_ind, index)}/>
                            </div>
                            <div
                              className="p-2 cost-field"
                              style={{
                                width:60
                              }}>
                              {(role == 'admin' && cost_visible)&&
                              <Input disabled={role != 'admin' || mode=="view"?true:false} type="number" value = {item?item['task_cost']:""} onChange={(e)=>onChangeEmbCustomTask(ind, "task_cost", e.target.value,custom_ind, index)}/>
                              }
                            </div>
                            <div
                              className="p-2 cost-field"
                              style={{
                                width:60
                              }}>
                              {(role == 'admin' && cost_visible)&&
                                <span className="p-2">{((item&&!isNaN(item.task_qty)&&!isNaN(item.task_cost))?(item['task_qty']*item['task_cost']):0).toFixed(2)}</span>
                              }
                            </div>
                            <div
                              className="p-2"
                              style={{
                                width:60
                              }}>                                      
                              <Input disabled={role != 'admin' || mode=="view"?true:false} type="number" value = {item?item['task_price']:""} onChange={(e)=>onChangeEmbCustomTask(ind, "task_price", e.target.value,custom_ind, index)}/>
                              </div>
                            <div    
                              className="p-2"                          
                              // {...provided.dragHandleProps}
                              style={{
                                width:60
                              }}>
                                <span className="p-2">{((item&&!isNaN(item.task_qty)&&!isNaN(item.task_price))?(item['task_qty']*item['task_price']):0).toFixed(2)}</span>
                              </div>
                            <div    
                              className="p-2 v-separator"                          
                              // {...provided.dragHandleProps}
                              style={{
                                width:30
                              }}></div>                                
                            <div    //select
                              className="p-1"                          
                              // {...provided.dragHandleProps}
                              style={{
                                width:0
                              }}>                          
                            </div>
                            <div
                              className="p-2"
                              style={{
                                display:'block',
                                width:340,
                              }}>
                                <Input disabled={ role != 'admin' || mode=="view"?true:false} type="text" value = {item?item['task_note']:""} name="task_note" onChange={(e)=>onChangeEmbCustomTask(ind, "task_note", e.target.value,custom_ind,index)}/>
                            </div>
                            <div
                              className="p-2"
                              style={{
                                display:'block',
                                width:40,
                              }}>
                              {role == 'admin' &&
                              <div className="text-center" style={{width:28}}>
                                <div className="w-100 custom-checkbox">
                                  <input
                                    
                                    key={`item-task-${custom_ind}-${index}`}
                                    className="custom-control-input"
                                    id={`item-task-${custom_ind}-${index}`}
                                    type="checkbox"
                                    name="primary_set"
                                    checked={item&&item['task_checked']?true:false}
                                    value={true}
                                    onChange={(e)=>onChangeEmbCustomTask(ind, "task_checked", !(item&&item['task_checked']?true:false),custom_ind,index)}
                                  />
                                  <label className="custom-control-label vertical" htmlFor={`item-task-${custom_ind}-${index}`}>
                                  </label>
                                </div>
                              </div>
                              }
                            </div>
                            {role == 'admin' &&
                            <div    
                              className="p-2"                          
                              {...provided.dragHandleProps}
                              style={{
                                width:30
                              }}><i className="fa fa-arrows" style={{marginTop:10}}></i>
                            </div>
                            }
                          </div>
                        )}
                      </Draggable>
                      }
                    </>
                  ))}
                </>:
                <div
                  className="d-flex h-100"
                  >
                  <div    
                    className="p-2 v-separator"                          
                    // {...provided.dragHandleProps}
                    style={{
                      width:510
                    }}></div>                                
                  <div    //select
                    className="p-1"                          
                    // {...provided.dragHandleProps}
                    style={{
                      width:0
                    }}>                          
                  </div>
                  <div
                    className="p-2"
                    style={{
                      display:'block',
                      width:380,
                    }}>
                      &nbsp;
                  </div>
                </div>
                }
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </>
    )
  }

 

  const renderDecoration =  (el, ind, index,item,provided)=>{ 
    if(item.code == "Embroidery"){
      return renderEmbroidery(el, ind, index,item,provided)
    }
    else{
      return renderScreenPrint(el, ind, index,item,provided);
    }
  }

  const checkAvailableProduction = (embProductions, position)=>{
    var returnValue = [];
    if(!embProductions || !position || position == ''){
      return returnValue
    }
    for(var i = 0; i < embProductions?.length; i++){
      var embProduction = embProductions[i]
      var filePosition = embProduction['position'];
      // try{
      //   filePosition = JSON.parse(filePosition)
      //   if(filePosition?.[position]){
      //     returnValue.push(embProduction)
      //   }
      // }
      // catch(e){
      //   console.log("decode file position", e)
      // }
      try{
        if(typeof filePosition === 'string'){
          filePosition = JSON.parse(filePosition)
        }
        if(!filePosition || filePosition?.[position]){
          returnValue.push(embProduction)
        }
      }
      catch(e){
        returnValue.push(embProduction)
      }
    }
    return returnValue
  }

  const applyProductionDataToDecoration = (output, productionItem) => {
    if(!productionItem){
      return;
    }
    output['file_path'] = productionItem['file_path'];
    output['setup_sc'] = productionItem['stitch_count'];
    output['setup_size'] = productionItem['size'];
    output['setup_color'] = productionItem['colours'];

    if(productionItem.production_type === 'digital'){
      output['setup_size_width'] = productionItem['size_width'] ?? output['setup_size_width'];
      output['setup_size_height'] = productionItem['size_height'] ?? output['setup_size_height'];
    }
  }

  const renderEmbroidery =  (el, ind, index,item,provided)=>{ 
    return(
      <>
        <div
          className="p-2"
          style={{
            width:'25px',
            textAlign:'center'
          }}
        >
          {role == "admin" &&
          <i className="fa fa-times mt-2"
            style={{cursor:'pointer'}}
            onClick={() => {
              const newState = [...state];
              newState[ind].splice(index, 1);
              updateState(
                newState.filter(group => group.length)
              );
            }}
          ></i>
          }
        </div>
        <div
          className="p-2"
          style={{
            width:'25px',
            textAlign:'center'
          }}
        >
        </div>
        <div className="d-block">
          <div className="d-flex">
            <div
              className="p-2"
              style={{
                width:'130px', display:'block'
              }}>
                <Input disabled={role != 'admin' || mode=="view"?true:false} type="select" value = {item?item['code']:""} name="code" onChange={(e)=>onBlurEmbDecoration(ind, "code", e.target.value,index)}>
                  {
                    brand_arry.map((item,index)=>(                                
                      <option key={item['key']} value={item['key']}>{item['label']}</option>
                    ))
                  }
                </Input>
                <div className="mt-3">
                  <label className="d-block text-right">Set Up</label>
                </div>
            </div>
            <div
              className="p-2"
              style={{
                width:180, display:'block'
              }}>
              <Input disabled={role != 'admin' || mode=="view"?true:false} type="select" value = {item?item['position']:""} style={{width:'100%'}} name="position" onChange={async (e)=>{var changedItem = await onBlurEmbDecoration(ind, "position", e.target.value,index); await onBlurGetEmbCost(ind, changedItem,index,'position', e.target.value)}}>
                <option key={'None'} value=''>None</option>
                {
                  positionList.map((item, index)=>(                                
                    <option key={index} value={item}>{item}</option>
                  ))
                }
              </Input>
              <div className="mt-2">
                <Input disabled={role != 'admin' || mode=="view"?true:false} type="select" value = {item?item['setup_code']:""} style={{width:'100%'}} name="setup_code" onChange={(e)=>onBlurEmbDecoration(ind, "setup_code", e.target.value,index)}>
                  {
                    setup_codes.map((item, index)=>(                                
                      <option key={index} value={item.key}>{item.label}</option>
                    ))
                  }
                </Input>    
              </div>        
              <div className="mt-2">
                 {item?.position == 'Other' &&
                  <div className="mt-2">
                    <Input disabled={role != 'admin' || mode=="view"?true:false} type="text" value={item?.position_label || ""} placeholder="Other position" name="position_label" onChange={(e)=>onChangeEmbDecoration(ind, "position_label", e.target.value, index)} onBlur={(e)=>onBlurEmbDecoration(ind, "position_label", e.target.value, index)}/>
                  </div>
                  }
                {/* <Input className="mt-2" disabled={role != 'admin' || mode=="view"?true:false} type="text" value={item?.other_label || ""} placeholder="Other" name="other_label" onChange={(e)=>onChangeEmbDecoration(ind, "other_label", e.target.value, index)} onBlur={(e)=>onBlurEmbDecoration(ind, "other_label", e.target.value, index)}/> */}
              </div>
            </div>
            <div
              className="p-2"
              style={{
                width:60, display:'block'
              }}>
                <div>
                  <Input disabled={ role != 'admin' || mode=="view"?true:false} type="number" value = {item?item['qty']:""} name="qty" onChange={(e)=>{onChangeEmbDecoration(ind, "qty", e.target.value, index);}} onBlur={async (e)=>{var changedItem = await onBlurEmbDecoration(ind, "qty", e.target.value,index); onBlurGetEmbCost(ind, changedItem, index, 'qty', e.target.value)}}/>
                </div>
                <div className="mt-2">                                        
                  <Input disabled={ role != 'admin' || mode=="view"?true:false} type="number" value = {item?item['setup_qty']:""} name="setup_qty" onChange={(e)=>onChangeEmbDecoration(ind, "setup_qty", e.target.value, index)} onBlur={async (e)=>{var changedItem = await onBlurEmbDecoration(ind, "setup_qty", e.target.value,index); getEmbSetupCost(ind, changedItem, index, 'setup_qty')}}/>
                </div>
            </div>
            <div
              className="p-2 cost-field"
              style={{
                width:60, display:'block'
              }}>
              {(role == 'admin' && cost_visible)&&
                <>
                  <div className="d-flex align-items-center">
                    <Input disabled={role != 'admin' || mode=="view"?true:false} type="number" value = {item?item['unit_cost']:""} name="unit_cost" onChange={(e)=>onChangeEmbDecoration(ind, "unit_cost", e.target.value, index)} onBlur={(e)=>onBlurEmbDecoration(ind, "unit_cost", e.target.value, index)}/>
                  </div>
                  <div className="mt-2 d-flex align-items-center">                                        
                    <Input disabled={ role != 'admin' || mode=="view"?true:false} type="number" value = {item?item['setup_unit_cost']:""} name="setup_unit_cost" onChange={(e)=>onChangeEmbDecoration(ind, "setup_unit_cost", e.target.value, index)} onBlur={(e)=>onBlurEmbDecoration(ind, "setup_unit_cost", e.target.value, index)}/>
                  </div>
                </>
              }
            </div>
            <div    
              className="p-2 cost-field"         
              style={{
                width:60, display:'block'
              }}>
                {(role == 'admin' && cost_visible)&&
                <>
                  <div className="d-flex align-items-center item-field">
                    {((item&&!isNaN(item['qty'])&&!isNaN(item['unit_cost']))?(item['qty']*item['unit_cost']):0).toFixed(2)}
                  </div>
                  <div className="mt-2 d-flex align-items-center item-field">
                    {((item&&!isNaN(item['setup_qty'])&&!isNaN(item['setup_unit_cost']))?(item['setup_qty']*item['setup_unit_cost']):0).toFixed(2)}
                  </div>
                </>
                }
            </div>
            <div    
              className="p-2 d-block "         
              style={{
                width:60
              }}>
                <div className="d-flex align-items-center">
                  <Input disabled={role != 'admin' || mode=="view"?true:false} type="number" value = {item?item['price']:""} name="price" onChange={(e)=>onChangeEmbDecoration(ind, "price", e.target.value, index)} onBlur={(e)=>onBlurEmbDecoration(ind, "price", e.target.value, index)}/>
                </div>
                <div className="mt-2 d-flex align-items-center">                                        
                  <Input disabled={ role != 'admin' || mode=="view"?true:false} type="number" value = {item?item['setup_price']:""} name="setup_price" onChange={(e)=>onChangeEmbDecoration(ind, "setup_price", e.target.value, index)} onBlur={(e)=>onBlurEmbDecoration(ind, "setup_price", e.target.value, index)}/>
                </div>
            </div>  
                                   
            <div
              className="p-2 d-block"
              style={{
                width:60
              }}> 
                <div className="d-flex align-items-center item-field">
                  ${((item&&!isNaN(item['qty'])&&!isNaN(item['price']))?(item['qty']*item['price']):0).toFixed(2)}
                </div>
                <div className="mt-2 d-flex align-items-center item-field">
                ${((item&&!isNaN(item['setup_qty'])&&!isNaN(item['setup_price']))?(item['setup_qty']*item['setup_price']):0).toFixed(2)}
                </div>
            </div>      
          </div>
          {
            item.discounts && item.discounts.length > 0 &&
            <>
              {
                item.discounts.map((discountItem, discountInd)=>{
                  return(
                    <>
                      {(role == 'admin' || (role != 'admin' && discountItem && discountItem['setup_discount_enable']))&&  
                      <>   
                        <div className="d-flex align-items-center">
                          <div className="d-flex pl-2 pr-2 pb-2" style={{width:310}}>
                            {(role == 'admin') &&
                            <div className="d-flex align-items-center">
                              <i className="fa fa-times"
                                style={{cursor:'pointer', marginRight: 24}}
                                onClick={() => {
                                  onRemoveEmbDiscount(ind, index, discountInd);
                                }}
                              ></i>
                              <div className="custom-control custom-checkbox mb-0 mt-0 normal"
                                style={{marginRight: 12}}>
                                <input
                                  className="custom-control-input"
                                  id={`emb-discount-checkbox${ind}-${index}-${discountInd}`}
                                  type="checkbox"
                                  checked={discountItem?discountItem['setup_discount_enable']:false}
                                  value={true}
                                  onChange={(e)=>onBlurEmbDecoration(ind, "setup_discount_enable", !(discountItem?discountItem['setup_discount_enable']:false), index, discountInd)}
                                />
                                <label className="custom-control-label" htmlFor={`emb-discount-checkbox${ind}-${index}-${discountInd}`}>
                                </label>
                              </div>
                            </div>
                            }
                            <label className="mr-2 mb-0 text-right" style={{width: 80, paddingTop: 6}}>Discount</label>
                            <div style={{width:'100% - 80px'}}>
                              <Input disabled={role != 'admin' || mode=="view"?true:false} type="select" value = {discountItem?discountItem['setup_discount']:""} name="setup_discount" onChange={(e)=>onChangeEmbDecoration(ind, "setup_discount", e.target.value,index, discountInd)} onBlur={(e)=>onBlurEmbDecoration(ind, "setup_discount", e.target.value,index, discountInd)}>
                                <option key={index} value=""></option>
                                {
                                  setup_discounts.map((item, index)=>(                                
                                    <option key={index} value={item.key}>{item.label}</option>
                                  ))
                                }
                              </Input>
                              {discountItem && discountItem['setup_discount'] == 'Other' &&
                              <Input style={{width:'calc(100%)', marginTop: 5}} disabled={ role != 'admin' || mode=="view"?true:false} type="text" value = {discountItem?discountItem['setup_discount_other']:""} name="setup_discount_other" onChange={(e)=>onChangeEmbDecoration(ind, "setup_discount_other", e.target.value, index, discountInd)} onBlur={(e)=>onBlurEmbDecoration(ind, "setup_discount_other", e.target.value, index, discountInd)}/>
                              }
                            </div>
                          </div>
                          <div className="d-flex align-items-center pl-2 pr-2 pb-2" style={{width:60}}>
                            <Input disabled={role != 'admin' || mode=="view"?true:false} type="number" value = {discountItem?discountItem['setup_discount_qty']:""} style={{width:'100% - 80px'}} name="setup_discount_qty" onChange={(e)=>onChangeEmbDecoration(ind, "setup_discount_qty", e.target.value,index, discountInd)} onBlur={(e)=>onBlurEmbDecoration(ind, "setup_discount_qty", e.target.value,index, discountInd)}/>
                          </div>
                          <div className="d-flex align-items-center pl-2 pr-2 pb-2" style={{width:60}}>
                            {(role == 'admin' && cost_visible)&&     
                              <Input disabled={role != 'admin' || mode=="view"?true:false} type="number" value = {discountItem?discountItem['setup_discount_cost']:""} style={{width:'100% - 80px'}} name="setup_discount_cost" onChange={(e)=>onChangeEmbDecoration(ind, "setup_discount_cost", e.target.value,index, discountInd)} onBlur={(e)=>onBlurEmbDecoration(ind, "setup_discount_cost", e.target.value,index, discountInd)}/>
                            }
                          </div>
                          <div className="d-flex align-items-center pl-2 pr-2 pb-2" style={{width:60}}>
                            {(role == 'admin' && cost_visible)&&     
                              <div className="d-flex align-items-center item-field">
                                {((discountItem&&!isNaN(discountItem['setup_discount_cost'])&&!isNaN(discountItem['setup_discount_qty']))?(discountItem['setup_discount_cost']*discountItem['setup_discount_qty']):0).toFixed(2)}
                              </div>
                            }
                          </div>
                          {
                          <div className="d-flex align-items-center pl-2 pr-2 pb-2" style={{width:60}}>
                            <Input disabled={role != 'admin' || mode=="view"?true:false} type="number" value = {discountItem?discountItem['setup_discount_value']:""} style={{width:'100% - 80px'}} name="setup_discount_value" onChange={(e)=>onChangeEmbDecoration(ind, "setup_discount_value", e.target.value,index, discountInd)} onBlur={(e)=>onBlurEmbDecoration(ind, "setup_discount_value", e.target.value,index, discountInd)}/>
                          </div>
                          }                          
                          <div
                            className="pl-2 pr-2 pb-2 pt-0 d-block"
                            style={{
                              width:60
                            }}> 
                              {(role == 'admin' || (role != 'admin' && discountItem && discountItem['setup_discount_enable']))&&
                              <div className="d-flex align-items-center item-field">
                                ${((discountItem&&!isNaN(discountItem['setup_discount_value'])&&!isNaN(discountItem['setup_discount_qty']))?(discountItem['setup_discount_value']*discountItem['setup_discount_qty']):0).toFixed(2)}
                              </div>
                              }
                          </div>   
                        </div>
                      </>
                      }
                    </>
                  )
                })
              }
            </>
          }
          <>
          {role == 'admin' &&
          <>
            <div onClick={()=>onAddEmbDiscount(ind, index)} className="d-flex mt-2 align-items-center category-subtitle small" style={{cursor:'pointer', maxWidth:200}}>
              <span className="discount-plus-icon mr-2 ml-0" style={{fontSize:20}}>
                +        
              </span>
              <span className="label">Add Discount</span>
            </div>
            <div>
              <div style={{display:'flex'}}>                
                <div
                  className="p-2"
                  style={{
                    width:'130px', display:'flex', justifyContent:'end', alignItems:'center'
                  }}>
                    <label className="">Supplier</label>
                </div>
                <div
                  className="p-2"
                  style={{
                    width:180, display:'block'
                  }}>
                  <Input disabled={mode=="view"?true:false} type="select" name="supplier" value = {item?item['supplier']:""} onChange={async (e)=>{var changedItem = await onChangeEmbDecoration(ind, "supplier", e.target.value, index); await onBlurGetEmbCost(ind, changedItem, index, 'supplier', e.target.value); getEmbSetupCost(ind, changedItem, index, 'supplier', e.target.value)}}>
                    <option value=""></option>
                    {
                      supplier_arry.map((item,index)=>(                                
                        <option key={item['key']} value={item['key']}>{item['label']}</option>
                      ))
                    }
                  </Input>  
                </div>
              </div>
            </div>
          </>
          }
          </>
        </div>
        <div    
          className="p-0 v-separator"                          
          // {...provided.dragHandleProps}
          style={{
            width:30
          }}>
        </div>                                
        <div    //select
          className="p-1"                          
          // {...provided.dragHandleProps}
          style={{
            width:0
          }}>   
        </div>           
        <div
          className="p-2"
          style={{
            display:'block',
            width:380,
          }}>
            {(role == 'admin') &&
            <div className="d-flex align-items-center">
              <div className="d-flex align-items-center w-60">
                <label style={{width:60}} className="text-left">File</label>
                <Input style={{width:'calc(100% - 120px)'}} disabled={ role != 'admin' || mode=="view"?true:false} type="select" value = {item?item['setup_emb']:""} name="setup_emb" onChange={async (e)=>{var changedItem = await onBlurEmbDecoration(ind, "setup_emb", e.target.value, index); await onBlurGetEmbCost(ind, changedItem, index, 'setup_emb', e.target.value); getEmbSetupCost(ind, changedItem, index, 'setup_emb', e.target.value)}}>
                  <option value=""></option>
                  {embProductions&&
                  <>
                    {
                      checkAvailableProduction(embProductions, item['position']).map((item,index)=>(                                
                        <option key={item['id']} value={item['id']}>{`${[item['file_name']]}`}</option>
                      ))
                    }
                  </>
                  }
                </Input>
                <div style={{width:30, textAlign:'center'}}><a href={getProductLink(item['setup_emb'], "emb")?`${getProductLink(item['setup_emb'], "emb")}`:'#'} download target="_blank" style={{display:'inline', textAlign:'center'}}> <span className="material-icons brand-emb-icon">upload_file</span></a></div>
                <div style={{width:30, textAlign:'center'}}><span style={{cursor:"pointer"}} onClick={()=>{ if(getProductLink(item['setup_emb'], "emb")) { setCurSrc(`${getProductLink(item['setup_emb'], "emb")}`); setOpenPreview(true) }}} > <i className="fa fa-camera" aria-hidden="true"></i></span></div>
              </div>
              <div className="d-flex align-items-center w-40">
                <label style={{width:50}} className="ml-3 text-left">SC/Esc</label>
                <Input style={{width:'calc(100% - 50px)'}} disabled={ role != 'admin' || mode=="view"?true:false} type="number" value = {item?item['setup_sc']:""} name="setup_sc" onChange={(e)=>onChangeEmbDecoration(ind, "setup_sc", e.target.value, index)} onBlur={async (e)=>{var changedItem = await onBlurEmbDecoration(ind, "setup_sc", e.target.value, index); onBlurGetEmbCost(ind, changedItem, index, 'setup_sc', e.target.value)}}/>
              </div>
            </div>
            }
            <div className="d-flex align-items-center mt-2">
              <div className="d-flex align-items-center w-50">
                <label style={{width:60}} className="text-left">Size</label>
                <Input style={{width:'calc(100% - 60px)'}} disabled={ role != 'admin' || mode=="view"?true:false} type="text" value = {item?item['setup_size']:""} name="setup_size" onChange={(e)=>onChangeEmbDecoration(ind, "setup_size", e.target.value, index)} onBlur={(e)=>onBlurEmbDecoration(ind, "setup_size", e.target.value, index)}/>
              </div>
            </div>
            <div className="d-flex align-items-center mt-2">
                <label style={{width:60}} className="text-left">Colours</label>
                <Input style={{width:'calc(100% - 60px)'}} disabled={ role != 'admin' || mode=="view"?true:false} type="text" value = {item?item['setup_color']:""} name="setup_color" onChange={(e)=>onChangeEmbDecoration(ind, "setup_color", e.target.value, index)} onBlur={(e)=>onBlurEmbDecoration(ind, "setup_color", e.target.value, index)}/>
            </div>
            <div className="d-flex align-items-center mt-2">
              <label style={{width:60}} className="text-left">Notes</label>
              <Input style={{width:'calc(100% - 60px)'}} disabled={ role != 'admin' || mode=="view"?true:false} type="text" value = {item?item['setup_notes']:""} name="setup_notes" onChange={(e)=>onChangeEmbDecoration(ind, "setup_notes", e.target.value, index)} onBlur={(e)=>onBlurEmbDecoration(ind, "setup_notes", e.target.value, index)}/>
            </div>
            {/* <div className="d-flex align-items-start mt-2">
              <label style={{width:60}} className="text-left mt-2">Logo</label>
              <div style={{width:'calc(100% - 60px)'}}>
                  <div className="d-flex align-items-center mt-2">
                    <div><Input style={{width:'200px', marginBottom:10}} placeholder="Enter Logo Name" disabled={ role != 'admin' || mode=="view"?true:false} type="text" value = {item['logo_name']??""} name="logo_name" onChange={(e)=>onChangeEmbDecoration(ind, "logo_name", e.target.value, index)} onBlur={(e)=>onBlurEmbDecoration(ind, "logo_name", e.target.value, index)}/></div>
                    {
                      item['logo_file']&&
                      <>
                        <div style={{width:30, textAlign:'center'}}><a href={API_URL+item['logo_file']['url']} download target="_blank" style={{display:'inline', textAlign:'center'}}> <span className="material-icons brand-emb-icon">upload_file</span></a></div>
                        <div style={{width:30, textAlign:'center'}}><span style={{cursor:"pointer"}} onClick={()=>{ if(item['logo_file']['url']) { setCurSrc(`${API_URL+item['logo_file']['url']}`); setOpenPreview(true) }}} > <i className="fa fa-camera" aria-hidden="true"></i></span></div>
                        <div style={{width:30, textAlign:'center'}}><span style={{cursor:"pointer"}} onClick={()=>{ onChangeEmbDecoration(ind, "logo_file", null, index);  }} > <i className="fa fa-times" aria-hidden="true"></i></span></div>
                      </>
                    }
                  </div>
                
                {mode!="view" &&
                <>
                  <div className="d-flex align-items-center">
                    <Button size="sm" onClick={()=>{document.getElementById(`brand-logo-${ind}-${index}`).click();}} className="rounded-0" color="primary" type="button">
                      Upload
                    </Button>
                    <label className="help-icon" style={{color:'#091e3f', margin: '0 0 0 14px'}} href="#" id={`brand-logo-tooltip-${ind}-${index}`} >i</label>
                  </div>
                  <UncontrolledTooltip  placement="bottom" className="text-left justify-content-start" target={`brand-logo-tooltip-${ind}-${index}`} trigger="hover focus">  
                    You can upload your logo here. <br/>
                    We require EPS files, but PDF files created from EPS files are also accepted. Bitmap files like JPEG, PNG, and GIF can be used for reference only and cannot be used for production.
                  </UncontrolledTooltip>
                </>
                }
                <input type="file" id={`brand-logo-${ind}-${index}`} style={{display:'none'}} onChange={(e)=>onChangeBrandLogoFile(ind, index, e)}/>
              </div>
            </div> */}
            <div className="d-flex align-items-start mt-2">
              <label style={{width:60}} className="text-left mt-2">Logo</label>
              <div style={{width:'calc(100% - 60px)'}}>
                <Input className="mb-2" placeholder="Enter Logo Name" disabled={role != 'admin' || mode=="view"?true:false} type="text" value={item?.logo_name || ""} name="logo_name" onChange={(e)=>onChangeEmbDecoration(ind, "logo_name", e.target.value, index)} onBlur={(e)=>onBlurEmbDecoration(ind, "logo_name", e.target.value, index)}/>
                {/* List of uploaded logos */}
                {item['logo_files'] && item['logo_files'].length > 0 &&
                  <ListGroup id="brand-logo-list" className="mb-1">
                    {item['logo_files'].map((logo_file, logo_index) => (
                      <ListGroupItem key={logo_index} className="d-flex justify-content-between align-items-center py-1">
                        <span className="d-inline-block text-truncate" style={{maxWidth: 210}}>
                          {logo_file['filename']}
                        </span>
                        <div className="d-flex align-items-center">
                            <Input
                              type="checkbox"
                              className="my-0"
                              title="Archive"
                              onChange={(e) => {
                                const checked = e.target.checked;

                                onChangeEmbDecoration(
                                  ind,
                                  "logo_archive_file",
                                  {
                                    index: logo_index,
                                    value: checked
                                  },
                                  index
                                );

                                props.submitOrder(e, "save_order");
                              }}
                              checked={!!logo_file.archive}
                            />
                          <a href={API_URL + logo_file['url']} download target="_blank"
                            className="mx-1" style={{display:'inline', textAlign:'center'}}>
                            <span className="material-icons brand-emb-icon">upload_file</span>
                          </a>
                          <span style={{cursor:"pointer"}} className="mx-1"
                            onClick={() => {
                              if (logo_file['url']) {
                                setCurSrc(`${API_URL + logo_file['url']}`);
                                setOpenPreview(true);
                              }
                            }}>
                            <i className="fa fa-camera" aria-hidden="true"></i>
                          </span>
                          {role === 'admin' &&
                            <span style={{cursor:"pointer"}} className="mx-1"
                              onClick={() => onChangeEmbDecoration(ind, "remove_logo_files", logo_index, index)}>
                              <i className="fa fa-times" aria-hidden="true"></i>
                            </span>
                          }
                        </div>
                      </ListGroupItem>
                    ))}
                  </ListGroup>
                }
            
                {mode !== "view" &&
                  <>
                    <div className="d-flex align-items-center">
                      <Button size="sm"
                        onClick={() => document.getElementById(`brand-logo-${ind}-${index}`).click()}
                        className="rounded-0" color="primary" type="button">
                        Upload
                      </Button>
                      <label className="help-icon" style={{color:'#091e3f', margin:'0 0 0 14px'}}
                        id={`brand-logo-tooltip-${ind}-${index}`}>i</label>
                    </div>
                    <UncontrolledTooltip placement="bottom" target={`brand-logo-tooltip-${ind}-${index}`} trigger="hover focus">
                      You can upload your logo here.<br/>
                      We require EPS files, but PDF files created from EPS files are also accepted.
                      Bitmap files like JPEG, PNG, and GIF can be used for reference only.
                    </UncontrolledTooltip>
                  </>
                }
                <input type="file" id={`brand-logo-${ind}-${index}`}
                  style={{display:'none'}}
                  onChange={(e) => onChangeBrandLogoFile(ind, index, e)} />
              </div>
            </div>
            <div className="d-flex align-items-start mt-2">
              <label style={{width:60}} className="text-left mt-2">Visual</label>
              <div style={{width:'calc(100% - 60px)'}}>
                {
                  item['visuals']&&
                  <>
                    {
                      item['visuals'].filter((visual_file) => {
                        if (role == 'admin') {
                          return true;
                        }
                        return visual_file['archive'] == true; 
                      }).map((visual_file, visual_index)=> {
                        return(
                            <ListGroup id="brand-visual-list" key={visual_index} className="mb-0">
                              <ListGroupItem className="d-flex justify-content-between align-items-center py-1">
                                <div>
                                  <span class="d-inline-block text-truncate" style={{maxWidth: 210}}>{visual_file['filename']}</span>
                                </div>
                                <div>
                                  <div>
                                     <Input type="checkbox" className="my-0" title="Archive" onClick={(e) => {
                                      let value = e.target.checked;
                                      onChangeEmbDecoration(ind, "archive_file", {index: visual_index, value: value}, index);
                                      props.submitOrder(e, "save_order");
                                    }} 
                                    checked={visual_file['archive'] ? true : false} 
                                    />
                                   
                                  </div>
                                      
                                  <a href={API_URL+visual_file['url']} download target="_blank" > <span className="fa fa-upload" title="upload file"></span></a>
                                  <span style={{cursor:"pointer"}} onClick={()=>{ if(visual_file['url']) { setCurSrc(`${API_URL+visual_file['url']}`); setOpenPreview(true) }}} > <i className="fa fa-camera" aria-hidden="true" title="preview"></i></span>
                                  {
                                    role == 'admin' && <span style={{cursor:"pointer"}} onClick={()=>{ onChangeEmbDecoration(ind, "remove_visuals", visual_index, index) }} > <i className="fa fa-times" aria-hidden="true" title="remove"></i></span>
                                  }
                                </div>
                              </ListGroupItem>
                            </ListGroup>
                        )
                      })
                    }
                  </>
                }
                {role == 'admin' && mode!="view" &&
                <Button size="sm" onClick={()=>{document.getElementById(`brand-visual-${ind}-${index}`).click();}} className="rounded-0 mt-2" color="primary" type="button">
                  Upload
                </Button>
                }
                <input type="file" id={`brand-visual-${ind}-${index}`} style={{display:'none'}} onChange={(e)=>onChangeBrandVisualFile(ind, index, e)}/>
              </div>
            </div>
        </div>
        <div    
          className="p-2"                          
          {...provided.dragHandleProps}
          style={{
            width:30
          }}><i className="fa fa-arrows" style={{marginTop:10}}></i>
        </div>
      </>
    )
  }

  const renderScreenPrint = (el, ind, index,item,provided)=>{   
    const logo_url = `${API_URL}/upload/${item['logo_name']}`
    return(
      <>
        <div
          className="p-2"
          style={{
            width:'25px',
            textAlign:'center'
          }}
        >
          {role == "admin" &&
          <i className="fa fa-times mt-2"
            style={{cursor:'pointer'}}
            onClick={() => {
              const newState = [...state];
              newState[ind].splice(index, 1);
              updateState(
                newState.filter(group => group.length)
              );
            }}
          ></i>
          }
        </div>
        <div
          className="p-2"
          style={{
            width:'25px',
            textAlign:'center'
          }}
        >
        </div>
        <div className="d-block">
          <div className="d-flex">
            <div
              className="p-2"
              style={{
                width:'130px', display:'block'
              }}>
                <Input disabled={role != 'admin' || mode=="view"?true:false} type="select" value = {item?item['code']:""} name="code" onChange={(e)=>onBlurEmbDecoration(ind, "code", e.target.value,index)}>
                  {
                    brand_arry.map((item,index)=>(                                
                      <option key={item['key']} value={item['key']}>{item['label']}</option>
                    ))
                  }
                </Input>
                <div className="mt-3">
                  <label className="d-block text-right">Set Up</label>
                </div>
                {item?.position === 'Other' && (
                  <div style={{ height: '32px' }} />
                )}
                {item?.code?.includes("Screen Print")&&
                <div className="mt-4">
                  <label className="d-block text-right">Colour</label>
                </div>
                }
                {item?.code=='Other'&&
                <div className="mt-4">
                  <label className="d-block text-right">Label</label>
                </div>
                }
            </div>
            <div
              className="p-2"
              style={{
                width:180, display:'block'
              }}>
              <Input disabled={role != 'admin' || mode=="view"?true:false} type="select" value = {item?item['position']:""} style={{width:'100%'}} name="position" onChange={(e)=>onBlurEmbDecoration(ind, "position", e.target.value,index)}>
                <option key={'None'} value=''>None</option>
                {
                  positionList.map((item, index)=>(                                
                    <option key={index} value={item}>{item}</option>
                  ))
                }
              </Input>
              <div className="mt-2">
                <Input disabled={role != 'admin' || mode=="view"?true:false} type="select" value = {item?item['setup_code']:""} style={{width:'100%'}} name="setup_code" onChange={(e)=>onBlurEmbDecoration(ind, "setup_code", e.target.value,index)}>
                  {
                    setup_codes.map((item, index)=>(                                
                      <option key={index} value={item.key}>{item.label}</option>
                    ))
                  }
                </Input>    
                {item?.position == 'Other' &&
                  <div className="mt-2">
                    <Input disabled={role != 'admin' || mode=="view"?true:false} type="text" value={item?.position_label || ""} placeholder="Other position" name="position_label" onChange={(e)=>onChangeEmbDecoration(ind, "position_label", e.target.value, index)} onBlur={(e)=>onBlurEmbDecoration(ind, "position_label", e.target.value, index)}/>
                  </div>
                }
              </div>
             
              {item?.code?.includes("Screen Print")&& 
              <div className="mt-2">
                <Input disabled={role != 'admin' || mode=="view"?true:false} type="select" value = {item?item['setup_color_change']:""} style={{width:'100%'}} name="setup_color_change" onChange={(e)=>onBlurEmbDecoration(ind, "setup_color_change", e.target.value,index)}>
                  {
                    setup_color_change_options.map((item, index)=>(                                
                      <option key={index} value={item.key}>{item.label}</option>
                    ))
                  }
                </Input>    
              </div>   
              }   
                                      
            </div>
            <div
              className="p-2"
              style={{
                width:60, display:'block'
              }}>
                <div>
                  {/* panther */}
                  <Input disabled={ role != 'admin' || mode=="view"?true:false} type="number" value = {item?item['qty']:""} name="qty" onChange={(e)=>{onChangeEmbDecoration(ind, "qty", e.target.value, index);}} onBlur={(e)=>{onBlurEmbDecoration(ind, "qty", e.target.value, index);}}/>
                </div>
                <div className="mt-2">                                        
                  <Input disabled={ role != 'admin' || mode=="view"?true:false} type="number" value = {item?item['setup_qty']:""} name="setup_qty" onChange={(e)=>onChangeEmbDecoration(ind, "setup_qty", e.target.value, index)} onBlur={(e)=>{onBlurEmbDecoration(ind, "setup_qty", e.target.value, index);}}/>
                </div>
                {item?.position === 'Other' && (
                  <div style={{ height: '40px' }} />
                )}
                {item?.code?.includes("Screen Print")&&
                <div className="mt-2">                                        
                  <Input disabled={ role != 'admin' || mode=="view"?true:false} type="number" value = {item?item['setup_color_change_qty']:""} name="setup_color_change_qty" onChange={(e)=>onChangeEmbDecoration(ind, "setup_color_change_qty", e.target.value, index)} onBlur={(e)=>{onBlurEmbDecoration(ind, "setup_color_change_qty", e.target.value, index);}}/>
                </div>
                }
            </div>
            <div
              className="p-2 cost-field"
              style={{
                width:60, display:'block'
              }}>
              {(role == 'admin' && cost_visible)&&
                <>
                  <div className="d-flex align-items-center">
                    <Input disabled={role != 'admin' || mode=="view"?true:false} type="number" value = {item?item['unit_cost']:""} name="unit_cost" onChange={(e)=>onChangeEmbDecoration(ind, "unit_cost", e.target.value, index)} onBlur={(e)=>onBlurEmbDecoration(ind, "unit_cost", e.target.value, index)}/>
                  </div>
                  <div className="mt-2 d-flex align-items-center">                                        
                    <Input disabled={ role != 'admin' || mode=="view"?true:false} type="number" value = {item?item['setup_unit_cost']:""} name="setup_unit_cost" onChange={(e)=>onChangeEmbDecoration(ind, "setup_unit_cost", e.target.value, index)} onBlur={(e)=>onBlurEmbDecoration(ind, "setup_unit_cost", e.target.value, index)}/>
                  </div>
                  {item?.position === 'Other' && (
                  <div style={{ height: '40px' }} />
                  )}
                  {item?.code?.includes("Screen Print")&&
                  <div className="mt-2 d-flex align-items-center">                                        
                    <Input disabled={ role != 'admin' || mode=="view"?true:false} type="number" value = {item?item['setup_color_change_unit_cost']:""} name="setup_color_change_unit_cost" onChange={(e)=>onChangeEmbDecoration(ind, "setup_color_change_unit_cost", e.target.value, index)} onBlur={(e)=>onBlurEmbDecoration(ind, "setup_color_change_unit_cost", e.target.value, index)}/>
                  </div>
                  }
                </>
              }
            </div>
            <div    
              className="p-2 cost-field"         
              style={{
                width:60, display:'block'
              }}>
                {(role == 'admin' && cost_visible)&&
                <>
                  <div className="d-flex align-items-center item-field">
                    {((item&&!isNaN(item['qty'])&&!isNaN(item['unit_cost']))?(item['qty']*item['unit_cost']):0).toFixed(2)}
                  </div>
                  <div className="mt-2 d-flex align-items-center item-field">
                    {((item&&!isNaN(item['setup_qty'])&&!isNaN(item['setup_unit_cost']))?(item['setup_qty']*item['setup_unit_cost']):0).toFixed(2)}
                  </div>
                  {item?.position === 'Other' && (
                  <div style={{ height: '40px' }} />
                  )}
                  {item?.code?.includes("Screen Print")&&
                  <div className="mt-2 d-flex align-items-center item-field">
                    {((item&&!isNaN(item['setup_color_change_qty'])&&!isNaN(item['setup_color_change_unit_cost']))?(item['setup_color_change_qty']*item['setup_color_change_unit_cost']):0).toFixed(2)}
                  </div>
                  }
                </>
                }
            </div>
            <div    
              className="p-2 d-block "         
              style={{
                width:60
              }}>
                <div className="d-flex align-items-center">
                  <Input disabled={role != 'admin' || mode=="view"?true:false} type="number" value = {item?item['price']:""} name="price" onChange={(e)=>onChangeEmbDecoration(ind, "price", e.target.value, index)} onBlur={(e)=>onBlurEmbDecoration(ind, "price", e.target.value, index)}/>
                </div>
                <div className="mt-2 d-flex align-items-center">                                        
                  <Input disabled={ role != 'admin' || mode=="view"?true:false} type="number" value = {item?item['setup_price']:""} name="setup_price" onChange={(e)=>onChangeEmbDecoration(ind, "setup_price", e.target.value, index)} onBlur={(e)=>onBlurEmbDecoration(ind, "setup_price", e.target.value, index)}/>
                </div>
                {item?.position === 'Other' && (
                  <div style={{ height: '40px' }} />
                  )}
                {item?.code?.includes("Screen Print")&&
                <div className="mt-2 d-flex align-items-center">                                        
                  <Input disabled={ role != 'admin' || mode=="view"?true:false} type="number" value = {item?item['setup_color_change_price']:""} name="setup_color_change_price" onChange={(e)=>onChangeEmbDecoration(ind, "setup_color_change_price", e.target.value, index)} onBlur={(e)=>onBlurEmbDecoration(ind, "setup_color_change_price", e.target.value, index)}/>
                </div>
                }
            </div>   
            <div
              className="p-2 d-block"
              style={{
                width:60
              }}> 
                <div className="d-flex align-items-center item-field">
                  ${((item&&!isNaN(item['qty'])&&!isNaN(item['price']))?(item['qty']*item['price']):0).toFixed(2)}
                </div>
                <div className="mt-2 d-flex align-items-center item-field">
                  ${((item&&!isNaN(item['setup_qty'])&&!isNaN(item['setup_price']))?(item['setup_qty']*item['setup_price']):0).toFixed(2)}
                </div>
                {item?.position === 'Other' && (
                  <div style={{ height: '40px' }} />
                  )}
                {item?.code?.includes("Screen Print")&&
                <div className="mt-2 d-flex align-items-center item-field">
                  ${((item&&!isNaN(item['setup_color_change_qty'])&&!isNaN(item['setup_color_change_price']))?(item['setup_color_change_qty']*item['setup_color_change_price']):0).toFixed(2)}
                </div>
                }
            </div>    
          </div>
          {item.code == "Digital Print" && role == 'admin' &&
            <>
              <div className="d-flex">
                <div
                  className="p-2"
                  style={{
                    width:'130px', display:'block'
                  }}>
                    {/* <label className="d-block text-right">*Film Size</label> */}
                    <label className="d-block text-right">*Film Metres</label>
                </div>
                <div
                  className="p-2"
                  style={{
                    width:180, display:'block'
                  }}>
                    <Input disabled={ role != 'admin' || mode=="view"?true:false} type="number" value = {item?item['film_metres']:""} name="film_metres" onChange={(e)=>onChangeEmbDecoration(ind, "film_metres", e.target.value, index)} onBlur={(e)=>onBlurEmbDecoration(ind, "film_metres", e.target.value, index)}/>

                    {/* <Input disabled={role != 'admin' || mode=="view"?true:false} type="select" value = {item?item['film_code']:""} style={{width:'100%'}} name="film_code" onChange={(e)=>onChangeEmbDecoration(ind, "film_code", e.target.value,index)} onBlur={(e)=>onBlurEmbDecoration(ind, "film_code", e.target.value,index)}>
                      {
                        film_codes.map((item, index)=>(                                
                          <option key={index} value={item.key}>{item.label}</option>
                        ))
                      }
                    </Input>                           */}
                </div>
                <div
                  className="p-2"
                  style={{
                    width:60, display:'block'
                  }}>                                   
                    <Input disabled={ role != 'admin' || mode=="view"?true:false} type="number" value = {item?item['film_qty']:""} name="setup_qty" onChange={(e)=>onChangeEmbDecoration(ind, "film_qty", e.target.value, index)} onBlur={(e)=>onBlurEmbDecoration(ind, "film_qty", e.target.value, index)}/>
                </div>
                <div
                  className="p-2 cost-field"
                  style={{
                    width:60, display:'block'
                  }}>
                  {(role == 'admin' && cost_visible)&&
                    <>
                      <div className="d-flex align-items-center">                                        
                        <Input disabled={ role != 'admin' || mode=="view"?true:false} type="number" value = {item?item['film_unit_cost']:""} name="film_unit_cost" onChange={(e)=>onChangeEmbDecoration(ind, "film_unit_cost", e.target.value, index)} onBlur={(e)=>onBlurEmbDecoration(ind, "film_unit_cost", e.target.value, index)}/>
                      </div>
                    </>
                  }
                </div>
                <div    
                  className="p-2 cost-field"         
                  style={{
                    width:60, display:'block'
                  }}>
                    {(role == 'admin' && cost_visible)&&
                    <>
                      <div className="d-flex align-items-center item-field">
                        {((item&&!isNaN(item['film_qty'])&&!isNaN(item['film_unit_cost']))?(item['film_qty']*item['film_unit_cost']):0).toFixed(2)}
                      </div>
                    </>
                    }
                </div>
                <div    
                  className="p-2 d-block "         
                  style={{
                    width:60
                  }}>
                </div>   
                <div
                  className="p-2 d-block"
                  style={{
                    width:60
                  }}> 
                </div>    
              </div>
            </>
          }
          
          {(item.code == "Digital Print" || item.code == "Vinyl Print") && role == 'admin' &&
            <>
              <div className="d-flex">
                <div
                  className="p-2"
                  style={{
                    width:'130px', display:'block'
                  }}>
                    <label className="d-block text-right">*Heat Press</label>
                </div>
                <div
                  className="p-2"
                  style={{
                    width:180, display:'block'
                  }}>
                    <Input disabled={ role != 'admin' || mode=="view"?true:false} type="text" value = {item?item['heat_code']:""} name="heat_code" onChange={(e)=>onChangeEmbDecoration(ind, "heat_code", e.target.value, index)} onBlur={(e)=>onBlurEmbDecoration(ind, "heat_code", e.target.value, index)}/>                     
                </div>
                <div
                  className="p-2"
                  style={{
                    width:60, display:'block'
                  }}>                                   
                    <Input disabled={ role != 'admin' || mode=="view"?true:false} type="number" value = {item?item['heat_qty']:""} name="heat_qty" onChange={(e)=>onChangeEmbDecoration(ind, "heat_qty", e.target.value, index)} onBlur={(e)=>onBlurEmbDecoration(ind, "heat_qty", e.target.value, index)}/>
                </div>
                <div
                  className="p-2 cost-field"
                  style={{
                    width:60, display:'block'
                  }}>
                  {(role == 'admin' && cost_visible)&&
                    <>
                      <div className="d-flex align-items-center">                                        
                        <Input disabled={ role != 'admin' || mode=="view"?true:false} type="number" value = {item?item['heat_unit_cost']:""} name="heat_unit_cost" onChange={(e)=>onChangeEmbDecoration(ind, "heat_unit_cost", e.target.value, index)} onBlur={(e)=>onBlurEmbDecoration(ind, "heat_unit_cost", e.target.value, index)}/>
                      </div>
                    </>
                  }
                </div>
                <div    
                  className="p-2 cost-field"         
                  style={{
                    width:60, display:'block'
                  }}>
                    {(role == 'admin' && cost_visible)&&
                    <>
                      <div className="d-flex align-items-center item-field">
                         {((item&&!isNaN(item['heat_qty'])&&!isNaN(item['heat_unit_cost']))?(item['heat_qty']*item['heat_unit_cost']):0).toFixed(2)}
                      </div>
                    </>
                    }
                </div>
                
                <div
                  className="p-2"
                  style={{
                    width:120, display:'block'
                  }}>
                    {/* <Input disabled={role != 'admin' || mode=="view"?true:false} type="select" value = {item?item['heat_supplier']:""} style={{width:'100%'}} name="heat_supplier" onChange={(e)=>onChangeEmbDecoration(ind, "heat_supplier", e.target.value,index)} onBlur={(e)=>onBlurEmbDecoration(ind, "heat_supplier", e.target.value,index)}>
                      <option key="JS" value="JS">JS Supplies</option>
                      <option key="BB" value="BB">Big Branding Workwear</option>
                    </Input>                           */}
                </div>

                {/* <div    
                  className="p-2 d-block "         
                  style={{
                    width:60
                  }}>
                </div>   

                <div
                  className="p-2 d-block"
                  style={{
                    width:60
                  }}> 
                </div>     */}
              </div>
            </>
          }
          {(item.code == "Digital Print" || item.code == "Vinyl Print") && role == 'admin' &&
            <>
              <div className="d-flex">
                <div
                  className="p-2"
                  style={{
                    width:'130px', display:'block'
                  }}>
                    <label className="d-block text-right">Packing Fee</label>
                </div>
                <div
                  className="p-2"
                  style={{
                    width:180, display:'block'
                  }}>
                    {/* <Input disabled={ role != 'admin' || mode=="view"?true:false} type="text" value = {item?item['packing_fee']:""} name="packing_fee" onChange={(e)=>onChangeEmbDecoration(ind, "packing_fee", e.target.value, index)} onBlur={(e)=>onBlurEmbDecoration(ind, "packing_fee", e.target.value, index)}/>  */}
                </div>
                <div
                  className="p-2"
                  style={{
                    width:60, display:'block'
                  }}>                                   
                    <Input disabled={ role != 'admin' || mode=="view"?true:false} type="number" value = {item?item['packing_qty']:""} name="packing_qty" onChange={(e)=>onChangeEmbDecoration(ind, "packing_qty", e.target.value, index)} onBlur={(e)=>onBlurEmbDecoration(ind, "packing_qty", e.target.value, index)}/>
                </div>
                <div
                  className="p-2 cost-field"
                  style={{
                    width:60, display:'block'
                  }}>
                  {(role == 'admin' && cost_visible)&&
                    <>
                      <div className="d-flex align-items-center">                                        
                        <Input disabled={ role != 'admin' || mode=="view"?true:false} type="number" value = {item?item['packing_unit_cost']:""} name="packing_unit_cost" onChange={(e)=>onChangeEmbDecoration(ind, "packing_unit_cost", e.target.value, index)} onBlur={(e)=>onBlurEmbDecoration(ind, "packing_unit_cost", e.target.value, index)}/>
                      </div>
                    </>
                  }
                </div>
                <div    
                  className="p-2 cost-field"         
                  style={{
                    width:60, display:'block'
                  }}>
                    {(role == 'admin' && cost_visible)&&
                    <>
                      <div className="d-flex align-items-center item-field">
                        {((item&&!isNaN(item['packing_qty'])&&!isNaN(item['packing_unit_cost']))?(item['packing_qty']*item['packing_unit_cost']):0).toFixed(2)}
                      </div>
                    </>
                    }
                </div>
                <div    
                  className="p-2 d-block "         
                  style={{
                    width:60
                  }}>
                </div>   
                <div
                  className="p-2 d-block"
                  style={{
                    width:60
                  }}> 
                </div>    
              </div>
            </>
          }
          {(item.code == "Digital Print" || item.code == "Vinyl Print") && role == 'admin' &&
            <>
              <div className="d-flex">
                {/* panther
                <div
                  className="p-2"
                  style={{
                    width:'130px', display:'block'
                  }}>
                    <label className="d-block text-right">DTF Printing</label>
                </div>
                <div
                  className="p-2"
                  style={{
                    width:180, display:'block'
                  }}>
                    <Input disabled={ role != 'admin' || mode=="view"?true:false} type="text" value = {item?item['dtf_printing_fee']:""} name="dtf_printing_fee" onChange={(e)=>onChangeEmbDecoration(ind, "dtf_printing_fee", e.target.value, index)} onBlur={(e)=>onBlurEmbDecoration(ind, "dtf_printing_fee", e.target.value, index)}/>                     
                </div>
                <div
                  className="p-2"
                  style={{
                    width:60, display:'block'
                  }}>                                   
                    <Input disabled={ role != 'admin' || mode=="view"?true:false} type="number" value = {item?item['dtf_printing_qty']:""} name="dtf_printing_qty" onChange={(e)=>onChangeEmbDecoration(ind, "dtf_printing_qty", e.target.value, index)} onBlur={(e)=>onBlurEmbDecoration(ind, "dtf_printing_qty", e.target.value, index)}/>
                </div>
                <div
                  className="p-2 cost-field"
                  style={{
                    width:60, display:'block'
                  }}>
                  {(role == 'admin' && cost_visible)&&
                    <>
                      <div className="d-flex align-items-center">                                        
                        <Input disabled={ role != 'admin' || mode=="view"?true:false} type="number" value = {item?item['dtf_printing_unit_cost']:""} name="dtf_printing_unit_cost" onChange={(e)=>onChangeEmbDecoration(ind, "dtf_printing_unit_cost", e.target.value, index)} onBlur={(e)=>onBlurEmbDecoration(ind, "dtf_printing_unit_cost", e.target.value, index)}/>
                      </div>
                    </>
                  }
                </div>
                <div    
                  className="p-2 cost-field"         
                  style={{
                    width:60, display:'block'
                  }}>
                    {(role == 'admin' && cost_visible)&&
                    <>
                      <div className="d-flex align-items-center item-field">
                        {((item&&!isNaN(item['dtf_printing_qty'])&&!isNaN(item['dtf_printing_unit_cost']))?(item['dtf_printing_qty']*item['dtf_printing_unit_cost']):0).toFixed(2)}
                      </div>
                    </>
                    }
                </div>
                <div    
                  className="p-2 d-block "         
                  style={{
                    width:60
                  }}>
                </div>   
                <div
                  className="p-2 d-block"
                  style={{
                    width:60
                  }}> 
                </div>     */}
              </div>
            </>
          }
          {
            item.discounts && item.discounts.length > 0 &&
            <>
              {
                item.discounts.map((discountItem, discountInd)=>{
                  return(
                    <>
                      {(role == 'admin' || (role != 'admin' && discountItem && discountItem['setup_discount_enable']))&&  
                      <>   
                        <div className="d-flex align-items-center">
                          <div className="d-flex pl-2 pr-2 pb-2" style={{width:310}}>
                            {(role == 'admin') &&
                            <div className="d-flex align-items-center">
                              <i className="fa fa-times"
                                style={{cursor:'pointer', marginRight: 24}}
                                onClick={() => {
                                  onRemoveEmbDiscount(ind, index, discountInd);
                                }}
                              ></i>
                              <div className="custom-control custom-checkbox mb-0 mt-0 normal"
                                style={{marginRight: 12}}>
                                <input
                                  className="custom-control-input"
                                  id={`emb-discount-checkbox${ind}-${index}-${discountInd}`}
                                  type="checkbox"
                                  checked={discountItem?discountItem['setup_discount_enable']:false}
                                  value={true}
                                  onChange={(e)=>onBlurEmbDecoration(ind, "setup_discount_enable", !(discountItem?discountItem['setup_discount_enable']:false), index, discountInd)}
                                />
                                <label className="custom-control-label" htmlFor={`emb-discount-checkbox${ind}-${index}-${discountInd}`}>
                                </label>
                              </div>
                            </div>
                            }
                            <label className="mr-2 mb-0 text-right" style={{width: 80, paddingTop: 6}}>Discount</label>
                            <div style={{width:'100% - 80px'}}>
                              <Input disabled={role != 'admin' || mode=="view"?true:false} type="select" value = {discountItem?discountItem['setup_discount']:""} name="setup_discount" onChange={(e)=>onBlurEmbDecoration(ind, "setup_discount", e.target.value,index, discountInd)}>
                                <option key={index} value=""></option>
                                {
                                  setup_discounts.map((item, index)=>(                                
                                    <option key={index} value={item.key}>{item.label}</option>
                                  ))
                                }
                              </Input>
                              {discountItem && discountItem['setup_discount'] == 'Other' &&
                              <Input style={{width:'calc(100%)', marginTop: 5}} disabled={ role != 'admin' || mode=="view"?true:false} type="text" value = {discountItem?discountItem['setup_discount_other']:""} name="setup_discount_other" onChange={(e)=>onChangeEmbDecoration(ind, "setup_discount_other", e.target.value, index, discountInd)} onBlur={(e)=>onBlurEmbDecoration(ind, "setup_discount_other", e.target.value, index, discountInd)}/>
                              }
                            </div>
                          </div>
                          <div className="d-flex align-items-center pl-2 pr-2 pb-2" style={{width:60}}>
                            <Input disabled={role != 'admin' || mode=="view"?true:false} type="number" value = {discountItem?discountItem['setup_discount_qty']:""} style={{width:'100% - 80px'}} name="setup_discount_qty" onChange={(e)=>onChangeEmbDecoration(ind, "setup_discount_qty", e.target.value,index, discountInd)} onBlur={(e)=>onBlurEmbDecoration(ind, "setup_discount_qty", e.target.value,index, discountInd)}/>
                          </div>
                          <div className="d-flex align-items-center pl-2 pr-2 pb-2" style={{width:60}}>
                            {(role == 'admin' && cost_visible)&&     
                              <Input disabled={role != 'admin' || mode=="view"?true:false} type="number" value = {discountItem?discountItem['setup_discount_cost']:""} style={{width:'100% - 80px'}} name="setup_discount_cost" onChange={(e)=>onChangeEmbDecoration(ind, "setup_discount_cost", e.target.value,index, discountInd)} onBlur={(e)=>onBlurEmbDecoration(ind, "setup_discount_cost", e.target.value,index, discountInd)}/>
                            }
                          </div>
                          <div className="d-flex align-items-center pl-2 pr-2 pb-2" style={{width:60}}>
                            {(role == 'admin' && cost_visible)&&     
                              <div className="d-flex align-items-center item-field">
                                {((discountItem&&!isNaN(discountItem['setup_discount_cost'])&&!isNaN(discountItem['setup_discount_qty']))?(discountItem['setup_discount_cost']*discountItem['setup_discount_qty']):0).toFixed(2)}
                              </div>
                            }
                          </div>
                          {
                          <div className="d-flex align-items-center pl-2 pr-2 pb-2" style={{width:60}}>
                            <Input disabled={role != 'admin' || mode=="view"?true:false} type="number" value = {discountItem?discountItem['setup_discount_value']:""} style={{width:'100% - 80px'}} name="setup_discount_value" onChange={(e)=>onChangeEmbDecoration(ind, "setup_discount_value", e.target.value,index, discountInd)} onBlur={(e)=>onBlurEmbDecoration(ind, "setup_discount_value", e.target.value,index, discountInd)}/>
                          </div>
                          }                          
                          <div
                            className="pl-2 pr-2 pb-2 pt-0 d-block"
                            style={{
                              width:60
                            }}> 
                              {(role == 'admin' || (role != 'admin' && discountItem && discountItem['setup_discount_enable']))&&
                              <div className="d-flex align-items-center item-field">
                                ${((discountItem&&!isNaN(discountItem['setup_discount_value'])&&!isNaN(discountItem['setup_discount_qty']))?(discountItem['setup_discount_value']*discountItem['setup_discount_qty']):0).toFixed(2)}
                              </div>
                              }
                          </div>   
                        </div>
                      </>
                      }
                    </>
                  )
                })
              }
            </>
          }
          <>
          {role == 'admin' &&
          <>
            <div onClick={()=>onAddEmbDiscount(ind, index)} className="d-flex mt-2 align-items-center category-subtitle small" style={{cursor:'pointer', maxWidth:200}}>
              <span className="discount-plus-icon mr-2 ml-0" style={{fontSize:20}}>
                +        
              </span>
              <span className="label">Add Discount</span>
            </div>
            {/* <div>
              <div style={{display:'flex'}}>                
                <div
                  className="p-2"
                  style={{
                    width:'130px', display:'flex', justifyContent:'end', alignItems:'center'
                  }}>
                    <label className="">Supplier</label>
                </div>
                <div
                  className="p-2"
                  style={{
                    width:180, display:'block'
                  }}>
                  <Input disabled={mode=="view"?true:false} type="select" name="supplier" value = {item?item['supplier']:""} onChange={(e)=>onChangeEmbDecoration(ind, "supplier", e.target.value, index)}>
                    <option value=""></option>
                    {
                      supplier_arry.map((item,index)=>(                                
                        <option key={item['key']} value={item['key']}>{item['label']}</option>
                      ))
                    }
                  </Input>  
                </div>
              </div>
            </div> */}
          </>
          }
          </>
        </div>
          
        <div    
          className="p-0 v-separator"                          
          // {...provided.dragHandleProps}
          style={{
            width:30
          }}>
        </div>                                
        <div    //select
          className="p-1"                          
          // {...provided.dragHandleProps}
          style={{
            width:0
          }}>   
        </div>           
        <div
          className="p-2"
          style={{
            display:'block',
            width:380,
          }}>
            <div className="d-flex align-items-center">
              <div className="d-flex align-items-center w-100">
                <label style={{width:60}} className="text-left">File</label>
                <Input style={{width:'calc(100% - 120px)'}} disabled={ role != 'admin' || mode=="view"?true:false} type="select" value = {item?item['setup_screen']:""} name="setup_screen" onChange={(e)=>onBlurEmbDecoration(ind, "setup_screen", e.target.value, index)}>
                  <option value=""></option>
                  {item.code == "Digital Print" &&
                    <>
                      {digitalProductions&&
                      <>
                        {
                          checkAvailableProduction(digitalProductions, item['position']).map((item,index)=>(                                
                            <option key={item['id']} value={item['id']}>{`${[item['file_name']]}`}</option>
                          ))
                        }
                      </>
                      }
                    </>
                  }
                  {item.code == "Vinyl Print" &&
                    <>
                      {screenProductions&&
                      <>
                        {
                          checkAvailableProduction(vinylProductions, item['position']).map((item,index)=>(                                
                            <option key={item['id']} value={item['id']}>{`${[item['file_name']]}`}</option>
                          ))
                        }
                      </>
                      }
                    </>
                  }
                  {item.code !== "Digital Print" && item.code !== "Vinyl Print" &&
                    <>
                      {screenProductions&&
                      <>
                        {
                          checkAvailableProduction(screenProductions, item['position']).map((item,index)=>(                                
                            <option key={item['id']} value={item['id']}>{`${[item['file_name']]}`}</option>
                          ))
                        }
                      </>
                      }
                    </>
                  }
                </Input>
                <div style={{width:30, textAlign:'center'}}><a href={getProductLink(item['setup_screen'], item.code)?`${getProductLink(item['setup_screen'], item.code)}`:'#'} download target="_blank" style={{display:'inline', textAlign:'center'}}> <span className="material-icons brand-emb-icon">upload_file</span></a></div>
                <div style={{width:30, textAlign:'center'}}><span style={{cursor:"pointer"}} onClick={()=>{ if(getProductLink(item['setup_screen'], item.code)) { setCurSrc(`${getProductLink(item['setup_screen'], item.code)}`); setOpenPreview(true) }}} > <i className="fa fa-camera" aria-hidden="true"></i></span></div>
              </div>
            </div>
            <div className="d-flex align-items-center mt-2">
              {/* <pre>{JSON.stringify(item, null, 2)}</pre> */}
               {
                  item.code === 'Digital Print'
                    ? (
                        <div className="d-flex ">
                          <div className="d-flex align-items-center w-50">
                            <label style={{width:60}} className="text-left">Width</label>
                            <Input style={{width:'calc(100% - 60px)'}} disabled={ role != 'admin' || mode=="view"?true:false} type="text" value = {item?item['setup_size_width']:""} name="setup_size_width" onChange={(e)=>onChangeEmbDecoration(ind, "setup_size_width", e.target.value, index)} onBlur={(e)=>onBlurEmbDecoration(ind, "setup_size_width", e.target.value, index)}/>
                          </div>
                          <div className="d-flex align-items-center w-50">
                            <label style={{width:60}} className="ml-3 text-left">Height</label>
                            <Input style={{width:'calc(100% - 60px)'}} disabled={ role != 'admin' || mode=="view"?true:false} type="text" value = {item?item['setup_size_height']:""} name="setup_size_height" onChange={(e)=>onChangeEmbDecoration(ind, "setup_size_height", e.target.value, index)} onBlur={(e)=>onBlurEmbDecoration(ind, "setup_size_height", e.target.value, index)}/>
                          </div> 
                        </div>
                      )
                    : (
                        <div className="d-flex align-items-center w-50">
                          <label style={{width:60}} className="text-left">Size</label>
                          <Input style={{width:'calc(100% - 60px)'}} disabled={ role != 'admin' || mode=="view"?true:false} type="text" value = {item?item['setup_size']:""} name="setup_size" onChange={(e)=>onChangeEmbDecoration(ind, "setup_size", e.target.value, index)} onBlur={(e)=>onBlurEmbDecoration(ind, "setup_size", e.target.value, index)}/>
                        </div>
                      )
                }
              
            </div>
            <div className="d-flex align-items-center mt-2">
                <label style={{width:60}} className="text-left">Colours</label>
                <Input style={{width:'calc(100% - 60px)'}} disabled={ role != 'admin' || mode=="view"?true:false} type="text" value = {item?item['setup_color']:""} name="setup_color" onChange={(e)=>onChangeEmbDecoration(ind, "setup_color", e.target.value, index)} onBlur={(e)=>onBlurEmbDecoration(ind, "setup_color", e.target.value, index)}/>
            </div>
            <div className="d-flex align-items-center mt-2">
              <label style={{width:60}} className="text-left">Notes</label>
              <Input style={{width:'calc(100% - 60px)'}} disabled={ role != 'admin' || mode=="view"?true:false} type="text" value = {item?item['setup_notes']:""} name="setup_notes" onChange={(e)=>onChangeEmbDecoration(ind, "setup_notes", e.target.value, index)} onBlur={(e)=>onBlurEmbDecoration(ind, "setup_notes", e.target.value, index)}/>
            </div>
            {/* <div className="d-flex align-items-start mt-2">
              <label style={{width:60}} className="text-left mt-2">Logo</label>
              <div style={{width:'calc(100% - 60px)'}}>
                <div className="d-flex align-items-center mt-2">
                  <div><Input style={{width:'200px', marginBottom:10}} placeholder="Enter Logo Name" disabled={ role != 'admin' || mode=="view"?true:false} type="text" value = {item['logo_name']??""} name="logo_name" onChange={(e)=>onChangeEmbDecoration(ind, "logo_name", e.target.value, index)} onBlur={(e)=>onBlurEmbDecoration(ind, "logo_name", e.target.value, index)}/></div>
                  {
                    item['logo_name']&&
                    <>
                    <div style={{width:30, textAlign:'center'}}><a href={logo_url} download target="_blank" style={{display:'inline', textAlign:'center'}}> <span className="material-icons brand-emb-icon">upload_file</span></a></div>
                    <div style={{width:30, textAlign:'center'}}><span style={{cursor:"pointer"}} onClick={()=>{ if(item['logo_name']) { setCurSrc(`${logo_url}`); setOpenPreview(true) }}} > <i className="fa fa-camera" aria-hidden="true"></i></span></div>
                    <div style={{width:30, textAlign:'center'}}><span style={{cursor:"pointer"}} onClick={()=>{ onChangeEmbDecoration(ind, "logo_file", null, index);  }} > <i className="fa fa-times" aria-hidden="true"></i></span></div>
                    </>
                  }
                </div>
                
                {mode!="view" &&
                <Button size="sm" onClick={()=>{document.getElementById(`brand-logo-${ind}-${index}`).click();}} className="rounded-0 mt-2" color="primary" type="button">
                  Upload
                </Button>
                }
                <input type="file" id={`brand-logo-${ind}-${index}`} style={{display:'none'}} onChange={(e)=>onChangeBrandLogoFile(ind, index, e)}/>
              </div>
            </div> */}
            <div className="d-flex align-items-start mt-2">
              <label style={{width:60}} className="text-left mt-2">Logo</label>
              <div style={{width:'calc(100% - 60px)'}}>
                <Input className="mb-2" placeholder="Enter Logo Name" disabled={role != 'admin' || mode=="view"?true:false} type="text" value={item?.logo_name || ""} name="logo_name" onChange={(e)=>onChangeEmbDecoration(ind, "logo_name", e.target.value, index)} onBlur={(e)=>onBlurEmbDecoration(ind, "logo_name", e.target.value, index)}/>
                {/* List of uploaded logos */}
                {item['logo_files'] && item['logo_files'].length > 0 &&
                  <ListGroup id="brand-logo-list" className="mb-1">
                    {item['logo_files'].map((logo_file, logo_index) => (
                      <ListGroupItem key={logo_index} className="d-flex justify-content-between align-items-center py-1">
                        <span className="d-inline-block text-truncate" style={{maxWidth: 210}}>
                          {logo_file['filename']}
                        </span>
                        <div className="d-flex align-items-center">
                          <label className="d-flex align-items-center mb-0 mx-1" style={{fontSize:12}}>
                            <Input
                              type="checkbox"
                              style={{position:'static', margin:0, marginRight:4}}
                              disabled={mode === "view"}
                              checked={!!logo_file.archive}
                              onChange={(e) => {
                                onChangeEmbDecoration(ind, "logo_archive_file", {index: logo_index, value: e.target.checked}, index);
                                props.submitOrder(e, "save_order");
                              }}
                            />
                            Archive
                          </label>
                          <a href={API_URL + logo_file['url']} download target="_blank"
                            className="mx-1" style={{display:'inline', textAlign:'center'}}>
                            <span className="material-icons brand-emb-icon">upload_file</span>
                          </a>
                          <span style={{cursor:"pointer"}} className="mx-1"
                            onClick={() => {
                              if (logo_file['url']) {
                                setCurSrc(`${API_URL + logo_file['url']}`);
                                setOpenPreview(true);
                              }
                            }}>
                            <i className="fa fa-camera" aria-hidden="true"></i>
                          </span>
                          {role === 'admin' &&
                            <span style={{cursor:"pointer"}} className="mx-1"
                              onClick={() => onChangeEmbDecoration(ind, "remove_logo_files", logo_index, index)}>
                              <i className="fa fa-times" aria-hidden="true"></i>
                            </span>
                          }
                        </div>
                      </ListGroupItem>
                    ))}
                  </ListGroup>
                }

                {mode !== "view" &&
                  <>
                    <div className="d-flex align-items-center">
                      <Button size="sm"
                        onClick={() => document.getElementById(`brand-logo-${ind}-${index}`).click()}
                        className="rounded-0" color="primary" type="button">
                        Upload
                      </Button>
                      <label className="help-icon" style={{color:'#091e3f', margin:'0 0 0 14px'}}
                        id={`brand-logo-tooltip-${ind}-${index}`}>i</label>
                    </div>
                    <UncontrolledTooltip placement="bottom" target={`brand-logo-tooltip-${ind}-${index}`} trigger="hover focus">
                      You can upload your logo here.<br/>
                      We require EPS files, but PDF files created from EPS files are also accepted.
                      Bitmap files like JPEG, PNG, and GIF can be used for reference only.
                    </UncontrolledTooltip>
                  </>
                }
                <input type="file" id={`brand-logo-${ind}-${index}`}
                  style={{display:'none'}}
                  onChange={(e) => onChangeBrandLogoFile(ind, index, e)} />
              </div>
            </div>
            <div className="d-flex align-items-start mt-2">
              <label style={{width:60}} className="text-left mt-2">Visual</label>
              <div style={{width:'calc(100% - 60px)'}}>
                {
                  item['visuals']&&
                  <>
                    {
                      item['visuals'].map((visual_file, visual_index)=>{
                        return(
                            <ListGroup id="brand-visual-list" key={visual_index} className="mb-0">
                              <ListGroupItem className="d-flex justify-content-between align-items-center py-1">
                                <div>
                                  <span class="d-inline-block text-truncate" style={{maxWidth: 210}}>{visual_file['filename']}</span>
                                </div>
                                <div className="d-flex align-items-center justify-content-around">
                                  <a href={API_URL+visual_file['url']} download target="_blank" style={{display:'inline', textAlign:'center'}} className="mx-1"> <span className="material-icons brand-emb-icon">upload_file</span></a>
                                  <span style={{cursor:"pointer"}} className="mx-1" onClick={()=>{ if(visual_file['url']) { setCurSrc(`${API_URL+visual_file['url']}`); setOpenPreview(true) }}} > <i className="fa fa-camera" aria-hidden="true"></i></span>
                                  {role == 'admin' &&
                                    <span style={{cursor:"pointer"}} className="mx-1" onClick={()=>{ onChangeEmbDecoration(ind, "remove_visuals", visual_index, index) }} > <i className="fa fa-times" aria-hidden="true"></i></span>
                                  }
                                </div>
                              </ListGroupItem>
                            </ListGroup>
                        )
                      })
                    }
                  </>
                }
                {role == 'admin' && mode!="view" &&
                <Button size="sm" onClick={()=>{document.getElementById(`brand-visual-${ind}-${index}`).click();}} className="rounded-0 mt-2" color="primary" type="button">
                  Upload
                </Button>
                }
                <input type="file" id={`brand-visual-${ind}-${index}`} style={{display:'none'}} onChange={(e)=>onChangeBrandVisualFile(ind, index, e)}/>
              </div>
            </div>
        </div>
        <div    
          className="p-2"                          
          {...provided.dragHandleProps}
          style={{
            width:30
          }}><i className="fa fa-arrows" style={{marginTop:10}}></i>
        </div>
      </>
    )
  }

  const renderDiscount = (el, ind, index,item,provided)=>{   
    
    return(
      <>  
        <div
          className="p-2"
          style={{
            width:25,
            textAlign:'center'
          }}
        >
          <i className="fa fa-times mt-2"
              style={{cursor:'pointer'}}
              onClick={() => {                   
                const newState = [...state];
                newState[ind].splice(index, 1);
                updateState(
                  newState.filter(group => group.length)
                );
              }}
            ></i>
        </div>
        <div
          className="p-2"
          style={{
            width:25,
            textAlign:'center'
          }}
        >
        </div>
        <div className="d-block">
          <div className="d-flex">
            <div
              className="p-2"
              style={{
                width:130
              }}>
              <Input style={{textAlign:'left', width:'100%'}} disabled={mode=="view"?true:false} type="select" name="type" value="discount" onChange={(e)=>onChangeEmbManage(ind, "type", e.target.value, index)}>
                  <option value="delivery">Delivery</option>
                  <option value="discount">Discount</option>
              </Input>
            </div>
            <div
              className="p-2"
              style={{
                width:180
              }}>
              <Input disabled={role != 'admin' || mode=="view"?true:false} type="text" value = {item?item['discount_desc']:""} name="discount_desc" style={{color:'red'}} onChange={(e)=>onChangeEmbManage(ind, "discount_desc", e.target.value, index)}>
                
              </Input>
            </div>
          </div>
          <div style={{maxWidth:310}} className="p-2">
            <Input disabled={role != 'admin' || mode=="view"?true:false} type="textarea" rows="3" className="h-auto" value = {item?item['discount_note']:""} name="discount_note" onChange={(e)=>onChangeEmbManage(ind, "discount_note", e.target.value, index)}>
                
            </Input>
          </div>
        </div>
        <div
          className="p-2"
          style={{
            width:60
          }}>
            <Input disabled={role != 'admin' || mode=="view"?true:false} type="number" value = {item?item['discount_qty']:""} name="discount_qty" style={{textAlign:'center', color:'red'}} onChange={(e)=>onChangeEmbManage(ind, "discount_qty", e.target.value, index)}/>
        </div>
        <div
          className="p-2 cost-field"
          style={{
            width:60
          }}>
          {(role == 'admin' && cost_visible)&&
          <Input disabled={role != 'admin' || mode=="view"?true:false} type="number" value = {item?item['discount_unit_cost']:""} name="discount_unit_cost" style={{color:'red'}} onChange={(e)=>onChangeEmbManage(ind, "discount_unit_cost", e.target.value, index)}/>
          }
        </div>
        <div
          className="p-2 cost-field"
          style={{
            width:60
          }}>
          {(role == 'admin' && cost_visible)&&
          <span className="p-2">
            {((item&&!isNaN(item['discount_qty'])&&!isNaN(item['discount_unit_cost']))?(item['discount_qty']*item['discount_unit_cost']):0).toFixed(2)}
          </span>
          }
        </div>
        <div
          className="p-2"
          style={{
            width:60
          }}>
          <Input disabled={role != 'admin' || mode=="view"?true:false} type="number" value = {item?item['discount_price']:""} name="discount_price" style={{color:'red'}} onChange={(e)=>onChangeEmbManage(ind, "discount_price", e.target.value, index)}/>
        </div>
        <div
          className="p-2"
          style={{
            width:60
          }}>
            <span className="p-2">
            {((item&&!isNaN(item['discount_qty'])&&!isNaN(item['discount_price']))?(item['discount_qty']*item['discount_price']):0).toFixed(2)}
            </span>
          </div>
        <div    
          className="p-2 v-separator"                          
          // {...provided.dragHandleProps}
          style={{
            width:30
          }}></div>                      
          <div    //select
            className="p-1"                          
            // {...provided.dragHandleProps}
            style={{
              width:0
            }}>                          
          </div>
        <div
          className="p-2"
          style={{
            display:'block',
            width:340,
          }}>
            <div className="d-flex align-items-center">
              <label style={{width:60}} className="mr-2 text-right">Approved By</label>
              <Input style={{width:'calc(100% - 80px)'}} disabled={ mode=="view"?true:false} type="text" value = {item?item['discount_approvedby']:""} name="discount_approvedby" onChange={(e)=>onChangeEmbManage(ind, "discount_approvedby", e.target.value, index)}/>
            </div>
        </div>
        <div
          className="p-2"
          style={{
            display:'block',
            width:40,
          }}>
          {role == 'admin' &&
          <div className="text-center" style={{width:28}}>
            <div className="w-100 custom-checkbox">
              <input                
                key={`item-discount-check-${index}`}
                className="custom-control-input"
                id={`item-discount-check-${index}`}
                type="checkbox"
                name="primary_set"
                checked={item&&item['checked']?true:false}
                value={true}
                onChange={(e)=>onChangeEmbManage(ind, "checked", !(item&&item['checked']?true:false), index)}
              />
              <label className="custom-control-label vertical" htmlFor={`item-discount-check-${index}`}>
              </label>
            </div>
          </div>
          }
        </div>
        <div    
          className="p-2"                          
          {...provided.dragHandleProps}
          style={{
            width:30
          }}><i className="fa fa-arrows" style={{marginTop:10}}></i>
        </div>
      </>
    )
  }

  const renderDelivery = (el, ind, index,item,provided)=>{   
    
    return(
      <>
        <div
          className="p-2"
          style={{
            width:25,
            textAlign:'center'
          }}
        >
        {role == 'admin' &&
        <i className="fa fa-times mt-2"
          style={{cursor:'pointer'}}
          onClick={() => {            
            const newState = [...state];
            newState[ind].splice(index, 1);
            updateState(
              newState.filter(group => group.length)
            );
          }}
        ></i>
        }
        </div>
        <div
          className="p-2"
          style={{
            width:25,
            textAlign:'center'
          }}
        >
        </div>
        <div className="d-block">
          <div className="d-flex">
            <div
              className="p-2"
              style={{
                width:130
              }}>
              <Input style={{textAlign:'left', width:'100%'}} disabled={mode=="view"?true:false} type="select" name="type" value = {"delivery"} onChange={(e)=>onChangeEmbManage(ind, "type", e.target.value, index)}>
                  <option value="delivery">Delivery</option>
                  <option value="discount">Discount</option>
              </Input>
            </div>
            <div
              className="p-2"
              style={{
                width:180
              }}>
              <Input style={{textAlign:'left'}} disabled={role != 'admin' || mode=="view"?true:false} type="select" value = {item['delivery_desc']} name="delivery_desc" onChange={(e)=>onChangeEmbManage(ind, "delivery_desc", e.target.value, index)}>
                <option value=''>None</option>
                {
                  delivery_options.map((item, index)=>(                                
                    <option key={index} value={item.key}>{item.label}</option>
                  ))
                }
              </Input>
              {(item['delivery_desc'] == "Other")&&
                <Input className="mt-1" disabled={role != 'admin' || mode=="view"?true:false} type="text" value = {item['delivery_other']} name="delivery_other" onChange={(e)=>onChangeEmbManage(ind, "delivery_other", e.target.value, index)}>
                  
                </Input>
              }
            </div>
            <div
              className="p-2"
              style={{
                width:60
              }}>
                <Input disabled={role != 'admin' || mode=="view"?true:false} type="number" value = {item['delivery_qty']} name="delivery_qty" style={{ textAlign:'center'}} onChange={(e)=>onChangeEmbManage(ind, "delivery_qty", e.target.value, index)}/>
            </div>
            <div
              className="p-2 cost-field"
              style={{
                width:60
              }}>
              {(role == 'admin' && cost_visible)&&
              <Input disabled={role != 'admin' || mode=="view"?true:false} type="number" value = {item['delivery_unit_cost']} name="delivery_unit_cost" onChange={(e)=>onChangeEmbManage(ind, "delivery_unit_cost", e.target.value, index)}/>
              }
            </div>
            <div
              className="p-2 cost-field"
              style={{
                width:60
              }}>
                {(role == 'admin' && cost_visible)&&
                  <div className="p-2">
                  {((!isNaN(item['delivery_qty'])&&!isNaN(item['delivery_unit_cost']))?(item['delivery_qty']*item['delivery_unit_cost']):0).toFixed(2)}
                  </div>
                }
            </div>
            <div
              className="p-2"
              style={{
                width:60
              }}>
              <Input disabled={role != 'admin' || mode=="view"?true:false} type="number" value = {item?item['delivery_price']:""} name="delivery_price" onChange={(e)=>onChangeEmbManage(ind, "delivery_price", e.target.value, index)}/>
            </div>
          </div>
          <div className="p-2 d-flex align-items-center">
            <div className="d-flex align-items-center w-50">
              <label style={{width:60}} className="mr-2 text-right">Notes</label>
              <Input style={{width:'calc(100% - 80px)'}} disabled={ mode=="view"?true:false} type="text" value = {item?item['delivery_note']:""} name="delivery_note" onChange={(e)=>onChangeEmbManage(ind, "delivery_note", e.target.value, index)}/>
            </div>
            <div className="d-flex align-items-center w-50">
              <label style={{width:60}} className="mr-2 text-right">Discount</label>
              <Input style={{width:'calc(100% - 80px)'}} disabled={ mode=="view"?true:false} type="number" value = {item?item['delivery_discount']:""} name="delivery_discount" onChange={(e)=>onChangeEmbManage(ind, "delivery_discount", e.target.value, index)}/>
            </div>
          </div>
        </div>                      
        <div
          className="p-2"
          style={{
            width:60
          }}>
            <span className="p-2">
            {((item&&!isNaN(item['delivery_qty'])&&!isNaN(item['delivery_price']))?(item['delivery_qty']*item['delivery_price']):0).toFixed(2)}
            </span>
        </div>
        <div    
          className="p-2 v-separator"                          
          // {...provided.dragHandleProps}
          style={{
            width:30
          }}>
        </div>                      
        <div    //select
          className="p-1"                          
          // {...provided.dragHandleProps}
          style={{
            width:0
          }}>                          
        </div>
        <div
          className="p-2"
          style={{
            display:'block',
            width:340,
          }}>
            <div className="d-flex align-items-center">
              <label style={{width:60}} className="mr-2 text-left">Attn</label>
              <Input style={{width:'calc(100% - 80px)'}} disabled={ mode=="view"?true:false} type="text"  value = {item?item['delivery_attn']:""} name="delivery_attn" onChange={(e)=>onChangeEmbManage(ind, "delivery_attn", e.target.value, index)}/>
            </div>
            <div className="d-flex align-items-center mt-2">
              <label style={{width:60}} className="mr-2 text-left">Address</label>
              <Input style={{width:'calc(100% - 80px)'}} disabled={ mode=="view"?true:false} type="text" value = {item?item['delivery_address']:""} name="delivery_address" onChange={(e)=>onChangeEmbManage(ind, "delivery_address", e.target.value, index)}/>
            </div>
        </div>  
        <div
          className="p-2"
          style={{
            display:'block',
            width:40,
          }}>
          {role == 'admin' &&
          <div className="text-center" style={{width:28}}>
            <div className="w-100 custom-checkbox">
              <input                
                key={`item-delivery-check-${index}`}
                className="custom-control-input"
                id={`item-delivery-check-${index}`}
                type="checkbox"
                name="primary_set"
                checked={item&&item['checked']?true:false}
                value={true}
                onChange={(e)=>onChangeEmbManage(ind, "checked", !(item&&item['checked']?true:false), index)}
              />
              <label className="custom-control-label vertical" htmlFor={`item-delivery-check-${index}`}>
              </label>
            </div>
          </div>
          }
        </div>
        <div    
          className="p-2"                                       
          {...provided.dragHandleProps}
          style={{
            width:30
          }}><i className="fa fa-arrows" style={{marginTop:10}}></i>
        </div>             
      </>
    )
  }

  const renderAttention = (el, ind, index,item,provided)=>{   
    
    return(
      <>  
        <div
          className="p-2"
          style={{
            width:25,
            textAlign:'center'
          }}
        >
          <i className="fa fa-times mt-2"
              style={{cursor:'pointer'}}
              onClick={() => {                   
                const newState = [...state];
                newState[ind].splice(index, 1);
                updateState(
                  newState.filter(group => group.length)
                );
              }}
            ></i>
        </div>
        <div
          className="p-2"
          style={{
            width:25,
            textAlign:'center',
            alignItems:'center'
          }}
        >
        </div>
          <div
            className="p-2"
            style={{
              width:160,
            alignItems:'center'
            }}>
            {item?item['code']:""}
          </div>
        <div
          className="p-2"
          style={{
            width:210,
            alignItems:'center'
          }}>
              {item?item['description_trim']:""}
        </div>
        <div
          className="p-2"
          style={{
            width:180,
            alignItems:'center'
          }}>
              {item?item['size']:""} {item?item['colour']:""}
        </div>
        <div
          className="p-2"
          style={{
            width:60
          }}>
          </div>
        <div    
          className="p-2 v-separator"                          
          // {...provided.dragHandleProps}
          style={{
            width:30
          }}></div>                      
          <div    //select
            className="p-1"                          
            // {...provided.dragHandleProps}
            style={{
              width:0
            }}>                          
          </div>
        <div
          className="p-2"
          style={{
            display:'block',
            width:340,
          }}>
            <div className="d-flex align-items-center">
              <label style={{width:60}} className="mr-2 text-right">Note</label>
              <Input style={{width:'calc(100% - 80px)'}} disabled={ mode=="view"?true:false} type="text" value = {item?item['note']:""} name="note" onChange={(e)=>onChangeEmbManage(ind, "note", e.target.value, index)}/>
            </div>
        </div>
        <div
          className="p-2"
          style={{
            display:'block',
            width:40,
          }}>
          {role == 'admin' &&
          <div className="text-center" style={{width:28}}>
            <div className="w-100 custom-checkbox">
              <input                
                key={`item-discount-check-${index}`}
                className="custom-control-input"
                id={`item-discount-check-${index}`}
                type="checkbox"
                name="primary_set"
                checked={item&&item['checked']?true:false}
                value={true}
                onChange={(e)=>onChangeEmbManage(ind, "checked", !(item&&item['checked']?true:false), index)}
              />
              <label className="custom-control-label vertical" htmlFor={`item-discount-check-${index}`}>
              </label>
            </div>
          </div>
          }
        </div>
        <div    
          className="p-2"                          
          {...provided.dragHandleProps}
          style={{
            width:30
          }}><i className="fa fa-arrows" style={{marginTop:10}}></i>
        </div>
      </>
    )
  }
  
  const renderOthersSubtotal = (item, item_type, taskIndex)=>{
    var sumCost = 0;
    var sumPrice =0;
    var background;
    if(item){
      if(item_type == "discount"){      
        var qty = !isNaN(item['discount_qty'])&&item['discount_qty']?item['discount_qty']:0;
        var price = !isNaN(item['discount_price'])&&item['discount_price']?item['discount_price']:0;
        var cost =!isNaN(item['discount_unit_cost'])&& item['discount_unit_cost']?item['discount_unit_cost']:0;
        var sumCost = qty*cost;
        var sumPrice = qty*price;
        background = (taskIndex%2==0?"#F6E7A3":"#E5D693")
      }
      else if(item_type == "delivery"){      
        var qty = !isNaN(item['delivery_qty'])&& item['delivery_qty']?item['delivery_qty']:0;
        var price = !isNaN(item['delivery_price'])&& item['delivery_price']?item['delivery_price']:0;
        var cost = !isNaN(item['delivery_unit_cost'])&& item['delivery_unit_cost']?item['delivery_unit_cost']:0;
        var delivery_discount = !isNaN(item['delivery_discount'])&& item['delivery_discount']?item['delivery_discount']*1:0;
        var sumCost = qty*cost + delivery_discount;
        var sumPrice = qty*price + delivery_discount;
        background = (taskIndex%2==0?"#F6E7A3":"#E5D693")
      }
      else if(item_type == "decoration"){
        var qty = item['qty']?item['qty']:0;
        var price = item['price']?item['price']:0;
        var cost = item['unit_cost']?item['unit_cost']:0;
        var setup_qty = item['setup_qty']?item['setup_qty']:0;
        var setup_price = item['setup_price']?item['setup_price']:0;
        var setup_cost = item['setup_unit_cost']?item['setup_unit_cost']:0;
        
        var setup_color_change_qty = item['setup_color_change_qty']?item['setup_color_change_qty']:0;
        var setup_color_change_price = item['setup_color_change_price']?item['setup_color_change_price']:0;
        var setup_color_change_cost = item['setup_color_change_unit_cost']?item['setup_color_change_unit_cost']:0;
        
        var film_qty = item['film_qty']?item['film_qty']:0;
        var film_cost = item['film_unit_cost']?item['film_unit_cost']:0;
        
        var heat_qty = item['heat_qty']?item['heat_qty']:0;
        var heat_cost = item['heat_unit_cost']?item['heat_unit_cost']:0;

        var discounts = item['discounts'];
        var discountCostTotal = 0;
        var discountPriceTotal = 0;
        if(discounts && discounts.length > 0){
          for(var discountInd = 0; discountInd < discounts.length; discountInd++){
            var discountItem = discounts[discountInd]
            var setup_discount_cost = !isNaN(discountItem['setup_discount_cost'])&&discountItem['setup_discount_cost']?discountItem['setup_discount_cost']:0;
            var setup_discount_value =!isNaN(discountItem['setup_discount_value'])&& discountItem['setup_discount_value']?discountItem['setup_discount_value']:0;
            var setup_discount_qty = !isNaN(discountItem['setup_discount_qty'])&&discountItem['setup_discount_qty']?discountItem['setup_discount_qty']:0;
            discountCostTotal += setup_discount_cost*setup_discount_qty
            discountPriceTotal += setup_discount_value*setup_discount_qty
          }
        }
        var sumCost = 0;
        // sumCost = qty*cost + setup_qty*setup_cost + discountCostTotal + film_qty*film_cost + heat_qty*heat_cost;
        if(item['code'] == 'Digital Print' || item['code'] == 'Vinyl Print'){
          sumCost = qty*cost;
        }
        else{
          sumCost = qty*cost + setup_qty*setup_cost + setup_color_change_qty*setup_color_change_cost + discountCostTotal;
        }
        var sumPrice = qty*price+ setup_qty*setup_price + setup_color_change_qty*setup_color_change_price + discountPriceTotal
        background = (taskIndex%2==0?"rgb(201, 225, 231)":"rgb(172 204 213)")
      }
    }

    return(
      <div className="sub-total1 table-row"  style={{background: background}}>
        <div
          className="p-2 d-block"
          style={{
            width:350,
            textAlign:'right',
            color:'#f6ce0e'
          }}
        >
        </div>
        <div
          className="p-2 d-block"
          style={{
            width:60,
            textAlign:'center',
          }}
        >
        </div>
        <div
          className="p-2 d-block"
          style={{
            width:60,
            textAlign:'center'
          }}
        >
        </div>
        <div
          className="p-2 d-block cost-field"
          style={{
            width:60,
            textAlign:'left',
          }}
        >
          <div className="pl-2 pt-2 pb-2">
          {(role == 'admin' && cost_visible)&&
            <>${sumCost.toFixed(2)}</>
          }      
          </div>
        </div>
        <div
          className="p-2 d-block"
          style={{
            width:60,
            textAlign:'center'
          }}
        >
        </div>
        <div className="pt-2 pb-2">
          <div
            className="p-2 d-block round-0"
            style={{
              width:59,
              textAlign:'center',
              border:'2px solid #091D3C'
            }}
          >
            ${sumPrice.toFixed(2)}
          </div>
        </div>
        <div
          className="p-0 v-separator"
          style={{
            width:'30px', fontSize:11, color:'#f6ce0e'
          }}>
        </div>
      </div>
    )
  }
  
  const renderCustomSubtotal = (el, custom_ind)=>{
    var sumQty = 0;
    var sumCost = 0;
    var sumPrice = 0;
    var positionSum = {};
    var groupoptions = el['group_options']
    if(groupoptions && groupoptions['customs']  && groupoptions['customs'][custom_ind]){
      var tasks = [];
      if(groupoptions['customs'][custom_ind]['tasks'] && groupoptions['customs'][custom_ind]['tasks'].length>0)
        tasks = [...groupoptions['customs'][custom_ind]['tasks']];
      for(var loop = 0; loop < tasks.length; loop++){
        var item = tasks[loop]
        var qty = item['task_qty']?item['task_qty']:0;
        var price = item['task_price']?item['task_price']:0;
        var cost = item['task_cost']?item['task_cost']:0;
        sumQty+= (qty*1)
        sumCost+= (cost*qty)
        sumPrice+= (price*qty)
      }
    }

    return(
      <div className="sub-total table-row" style={{background:(custom_ind%2==0?"#F6E7A3":"#E5D693")}}>
        <div
          className="pl-2 pr-2 d-block"
          style={{
            width:350,
            textAlign:'right',
            color:'#091e3f'
          }}
        >
        </div>
        <div
          className="pl-2 pr-2 d-block"
          style={{
            width:60,
            textAlign:'center',
          }}
        >
        </div>
        <div
          className="pl-2 pr-2 d-block"
          style={{
            width:60,
            textAlign:'center'
          }}
        >
        </div>
        <div
          className="pl-2 pr-2 d-block cost-field"
          style={{
            width:60,
            textAlign:'left',
          }}
        >
          <div className="p-2">
            {(role == 'admin' && cost_visible)&&
              <>${sumCost.toFixed(2)}</>
            }      
          </div>    
        </div>
        <div
          className="pl-2 pr-2 d-block"
          style={{
            width:60,
            textAlign:'center'
          }}
        >
        </div>
        <div
          className="pl-2 pr-2 mt-1 mb-1 d-block round-0"
          style={{
            width:59,
            textAlign:'center',
            border:'2px solid #091D3C'
          }}
        >
          <div className="pt-2 pb-2"
          style={{
            textAlign:'center',
          }}>
            ${sumPrice.toFixed(2)}
          </div>    
        </div>
        <div
          className="p-0 v-separator"
          style={{
            width:30, fontSize:11, color:'#f6ce0e'
          }}>
        </div>
        <div    //select
            className="p-1"              
            style={{
              width:0
            }}>                          
          </div>
        <div
          className="pl-2 pr-2 d-flex align-items-center"
          style={{
          }}>
        </div>
      </div>
    )
  }
  const getTotalGarments = (el, index)=>{
    var sumQty = 0;
    for(var loop = 0; loop <= index; loop++){
      var item = el[loop]
      if(el.length == loop){
        break;
      }
      if(item.type == "product"){
        var qty = item['qty']?item['qty']:0;
        var price = item['price']?(item['price']*1).toFixed(2):0;
        var cost = item['cost']?(item['cost']*1).toFixed(2):0;
        sumQty+= (qty*1)
      }
    }
    return sumQty;
  }

  const renderProductSubtotal = (el, index)=>{
    var sumQty = 0;
    var sumCost = 0;
    var sumPrice = 0;
    var positionSum = {};
    for(var i in positionList){
      positionSum[positionList[i]] = 0;
    }
    for(var loop = 0; loop <= index; loop++){
      var item = el[loop]
      // if(item.type != "product" && item['type'] !="decoration"){
      //   sumQty = 0;
      //   sumCost = 0;
      //   sumPrice = 0;
      //   for(var i in positionList){
      //     positionSum[positionList[i]] = 0;
      //   }
      // }
      if(el.length == loop){
        break;
      }
      if(item.type == "product"){
        var qty = item['qty']?item['qty']:0;
        var price = item['price']?(item['price']*1).toFixed(2):0;
        var cost = item['cost']?(item['cost']*1).toFixed(2):0;
        sumQty+= (qty*1)
        sumCost+= (cost*qty)
        sumPrice+= (price*qty)

        
        

        for(var i in positionList){
          if(item['position']&& item['position'][positionList[i]])
            positionSum[positionList[i]]+= (qty*1);
        }
      }
    }
    // var discount = el['group_options']['discount'];
    // if(discount){
    //   var discount_qty = discount['qty']?discount['qty']*1:0;
    //   var discount_price = discount['price']?(discount['price']*1):0;
    //   var discount_cost = discount['cost']?(discount['cost']*1):0;
    //   if(isNaN(discount_qty)) discount_qty = 0;
    //   if(isNaN(discount_price)) discount_price = 0;
    //   if(isNaN(discount_cost)) discount_cost = 0;

    //   sumCost+= (discount_cost*discount_qty)
    //   sumPrice+= (discount_price*discount_qty)
    // }

    // var customfees = el['group_options']['customfees'];
    // if(customfees){
    //   for(var customFeeInd = 0; customFeeInd<customfees.length; customFeeInd++){
    //     var customfee = customfees[customFeeInd];
    //       var customfee_price = customfee['customfee_price']*1;
    //       var customfee_qty = customfee['customfee_qty']*1;
    //       if(isNaN(customfee_price)) customfee_price = 0;
    //       if(isNaN(customfee_qty)) customfee_qty = 0;
    //       sumPrice+=(customfee_price*customfee_qty)
    //       sumQty+= customfee_qty
    //   }
    // }

    return(
      <div className="sub-total table-row">
        <div
          className="pl-2 pr-2 d-block"
          style={{
            width:350,
            textAlign:'right',
            color:'#091e3f'
          }}
        >
          <div className="pt-2 pb-2">
            <b>Total garments</b>
          </div>
        </div>
        <div
          className="pl-2 pr-2 d-block"
          style={{
            width:60,
            textAlign:'center',
          }}
        >
          <div className="p-2 round-5"
          style={{
            textAlign:'center',
            background:'#091e3f',
            color:'#f6ce0e'
          }}>
            {sumQty}
          </div>
        </div>
        <div
          className="pl-2 pr-2 d-block"
          style={{
            width:60,
            textAlign:'center'
          }}
        >
        </div>
        <div
          className="pl-2 pr-2 d-block cost-field"
          style={{
            width:60,
            textAlign:'left',
          }}
        >
          <div className="p-2">
            {(role == 'admin' && cost_visible)&&
              <>${sumCost.toFixed(2)}</>
            }      
          </div>    
        </div>
        <div
          className="pl-2 pr-2 d-block"
          style={{
            width:60,
            textAlign:'center'
          }}
        >
        </div>
        <div
          className="pl-2 pr-2 mt-1 mb-1 d-block round-0"
          style={{
            width:59,
            textAlign:'center',
            border:'2px solid #091D3C'
          }}
        >
          <div className="pt-2 pb-2"
          style={{
            textAlign:'center',
          }}>
            ${sumPrice.toFixed(2)}
          </div>    
        </div>
        <div
          className="p-0 v-separator"
          style={{
            width:30, fontSize:11, color:'#f6ce0e'
          }}>
        </div>
        <div    //select
            className="p-1"                          
            // {...provided.dragHandleProps}
            style={{
              width:0
            }}>                          
          </div>
        <div
          className="pl-2 pr-2 d-flex align-items-center"
          style={{
          }}>
          {
            positionList.map((position, PositionIndex) => (
              <>
                <div className="text-center" style={{width:28,color:'#091e3f'}} key={`item-customCheck-cnt-${index}-${position}`}>
                  {positionSum[position]}
                </div>
              </>
            ))
          }
        </div>
        {/* <div style={{marginRight:'0', marginLeft:'auto'}}>
          <span>SUB TOTAL</span>
          <span className="ml-3">${subTotal().toFixed(2)}</span>
        </div> */}
      </div>
    )
  }
  const validProductSubtotal = (el, index)=>{
    var next_item = el[index+1]
    var searched = false;
    for(var i =index+1; i< el.length; i++){
      var item = el[i];
      if(item['type'] == 'product'){
        searched = true; break;
      }
    }
    if(!searched){
      return true;
    }
    if(!next_item) return true;
    if(next_item['type'] !="product" && next_item['type'] !="decoration" && next_item['type'] !="delivery" && next_item['type'] !="discount"&& next_item['type'] !="attention")
      return true;
    return false
  }
  
  const onChangeLogo=(e)=>{
    if(e.target.files[0])
    props.setLogo((e.target.files[0]))    
    // props.setLogo(URL.createObjectURL(e.target.files[0]))
  }


  const onSelect=({ key })=> {
    onAddManage(0, key)
  }
  
  function onVisibleChange(visible) {
  }
  const onSelectBrand=({ key})=>{
    props.setDefaultBrand(key)
    
    var newstate = [...state];    
    var groupoptions = newstate[0]['group_options']
    var itemsInGroup = [...newstate[0]];
    if(itemsInGroup && itemsInGroup.length>0){
      for(var i = 0; i < itemsInGroup.length; i++){
        var item = {...itemsInGroup[i]};
        if(item.type == "decoration"){
          if(item.code != key){
            item.code = key;
            item.description = "";
            item.emb_note = "";
            item.price = 0;
            itemsInGroup[i] = item;
          }
        }
      }
      newstate[0] = itemsInGroup;
    }
    newstate[0]['group_options'] = groupoptions
    updateState(newstate)
  }
  const onSelectAddProduct=({key})=>{
    if(props.quote.status == 'Completed Quote' && role != 'admin'){
      props.setOpenConfirmEditModal(true);
      return false;
    }
    if(key=="store"){
      setOpenAddProduct(true)
    }else{
      addCustomProduct();
    }
  }
  const addCustomProduct=()=>{
    var state=[]
    var categories = {...props.quote.categories}
    var category = null
    for(var catInd in categories){
      var category = {...categories[catInd]}
      break;
    }
    if(category)
      state = [...category.items]
    if(!state){
      state = [[]];
    }
    if(state.length == 0) 
      state = [[]];
    var itemsInGroup = [...state[0]];
    var group_options = {...state[0]['group_options']}

    var newitem={};
    var itemCount = 0;
    for(var loop1 = 0; loop1< state.length; loop1++){
      itemCount+= state[loop1].length;
    }
    newitem['id'] = (itemCount + 1).toString()
    newitem['type'] = "product";
    newitem['subtype'] = "custom_product";
    newitem['qty'] = 1;
    newitem['cost'] = 0;
    newitem['price'] = 0;
    itemsInGroup.push(newitem)
      
   
    state[0] = itemsInGroup;
    var newstate = [...state];
    newstate[0]['group_options'] = group_options;
    var cat_val={
      [0]:{
        ...category,
        items: newstate,
      }
    }
    props.updateCategory(cat_val);
    return true;
  }

  const getItemList = (item_type, el)=>{
    if(el && el.length){
      for(var i = 0; i < el.length; i++){
        el[i].index = i;
      }
      return el.filter((item)=>{return item.type==item_type});
    }
    else{
      return []
    }
  }
  const decorationMenu = (
    <Menu onClick={onSelect}>
      <MenuItem key="delivery">Delivery</MenuItem>
      <MenuItem key="discount">Discount</MenuItem>
    </Menu>
  );
  const brandMenu = (
    <Menu onSelect={onSelectBrand} activeKey={props.quote.defaultBrand}>
      {
        brand_arry.map((item, index)=>{
          return(
            <MenuItem key={item['key']}>{item['label']}</MenuItem>
          )
        })
      }
    </Menu>
  );
  const productMenu = (
    <Menu onClick={onSelectAddProduct}>
      <MenuItem key="store">From Store</MenuItem>
      <MenuItem key="custom">Custom</MenuItem>
    </Menu>
  );

  const DeleteElement = ()=>{
    if(role == 'admin'){
      return (<Button
        id="delete-quote-btn"
        onClick={()=>{setDeleteQuoteConfirm(true)}} outline
        className="d-block btn-icon btn-3 rounded-0 border-2 mb-2" color="primary" type="button">
        <span className="btn-inner--text">DELETE</span>
      </Button>)
    }
    else{
      return <div id="delete-quote-btn"></div>
    }
  }

  var extension = null;
  if(curSrc)
    extension = curSrc.split('.').pop();
  
  const getProductLink = (screen_id, type)=>{
    if(type == 'Digital Print'){
      type = 'digital'
    }
    if(type == 'Screen Print'){
      type = 'screen_print'
    }
    if(type == 'Vinyl Print'){
      type = 'vinyl'
    }
    if(type != 'screen_print' && type != 'digital' && 
      type != 'emb' && type != 'vinyl' ){
        type = 'digital'
      }
    if(type == "screen_print"){
      if(screenProductions && screen_id && screen_id!=""){
        for(var i = 0; i< screenProductions.length; i++){
          if(screen_id == screenProductions[i].id){
            if(screenProductions[i].file_path){
              var url = API_URL+screenProductions[i].file_path;
              return url;
            }
            else
              return false
          }
        }
      }
    }
    if(type == "digital"){
      if(digitalProductions && screen_id && screen_id!=""){
        for(var i = 0; i< digitalProductions.length; i++){
          if(screen_id == digitalProductions[i].id){
            if(digitalProductions[i].file_path){
              var url = API_URL+digitalProductions[i].file_path;
              return url;
            }
            else
              return false
          }
        }
      }
    }
    if(type == "emb"){
      if(embProductions && screen_id && screen_id!=""){
        for(var i = 0; i< embProductions.length; i++){
          if(screen_id == embProductions[i].id){
            if(embProductions[i].file_path){
              var url = API_URL+embProductions[i].file_path;
              return url;
            }
            else
              return false
          }
        }
      }
    }
    if(type == "vinyl"){
      if(vinylProductions && screen_id && screen_id!=""){
        for(var i = 0; i< vinylProductions.length; i++){
          if(screen_id == vinylProductions[i].id){
            if(vinylProductions[i].file_path){
              var url = API_URL+vinylProductions[i].file_path;
              return url;
            }
            else
              return false
          }
        }
      }
    }
    return false
  }
  var customs = [];
  if(state && state.length>0){
    var group_options = state[0]['group_options']
    if(group_options['customs'])
      customs = group_options['customs']
  }
  taskIndex = 0;

  const viewLog = (id)=>{
    axios.get(`/quotes/getlog/${id}`).then(res => {
      setLogOpen(true)
      setLogData(res.data)
    })    
  }

  // console.log("state", state)
  return (
    <>
      {role == 'admin' &&
        <ReactNotifications />
      }
      <Row>
        <Col md="9">
          <Row className="mt-5 catalogue-header">
            <Col md="12" className="d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                 
                {mode!="view" &&
                <Dropdown
                    trigger={['click']}
                    overlay={productMenu}
                    animation="slide-up"
                    onVisibleChange={onVisibleChange}
                  >
                    <Button
                      // onClick={toggleAddProduct}
                      className="rounded-0 d-flex align-items-center" color="white" type="button">
                      <span className="btn-inner--text">Add Product</span>   
                      <span style={{fontSize:17.5}} className="material-icons ml-2 mt-1">expand_more</span>
                    </Button>   
                </Dropdown> 
                }    
                {mode!="view" &&  
                <Button 
                  onClick={
                    ()=>{
                      if(props.quote.status == 'Completed Quote' && role != 'admin'){
                        props.setOpenConfirmEditModal(true);
                        return false;
                      }
                      logoRef.current.click()
                    }
                  } 
                  className="rounded-0 d-flex align-items-center" color="white" type="button"
                >
                  <label className="help-icon m-0 mr-1" style={{color:'#091D3C'}} href="#" id="TooltipExample" >i</label>
                  Upload Logos
                  <span style={{fontSize:17.5}}  href="#" className="material-icons ml-2 mt-1">upload_file</span>
                </Button>
                }    
                {role == 'admin' &&
                <Dropdown
                  trigger={['click']}
                  overlay={brandMenu}
                  animation="slide-up"
                  onVisibleChange={onVisibleChange}
                >
                  
                  <Button className="rounded-0 d-flex align-items-center" color="white" type="button">
                    <label className="help-icon m-0 mr-1" href="#" id="TooltipExample" >i</label>
                    Decoration
                    <span style={{fontSize:17.5}} className="material-icons ml-2 mt-1">expand_more</span>
                  </Button>    
                </Dropdown>
                }
                <input type="file" ref={logoRef} style={{display:'none'}} onChange={(e)=>onChangeLogo(e)}/>
                {/* <p>Somewhere in here is a <span style={{textDecoration: "underline", color:"blue"}} href="#" id="TooltipExample">tooltip</span>.</p> */}
                {/* <Tooltip placement="bottom" isOpen={tooltipOpen} className="text-left" target="TooltipExample" toggle={toggletooltip}>
                  PDF/EPS required.<br/>
                  *If you have a Brand Style Guide, you can upload it here.<br/>
                  *Jpegs & PNG are ok for reference only, but not suitable for production
                </Tooltip> */}
                {role=="admin"&&
                <Button  
                  onClick={() => {
                    onChangeEmb(0, "cost_visible", !cost_visible)
                  }}
                  color="warning" 
                  style={{color:'#F6CE0E', width:96}}
                  className="btn-eye btn-icon btn-3 add-brand rounded-0 d-flex align-items-center justify-content-center ml-2" type="button">     
                    
                    <>
                      {cost_visible?
                        <i className="fa fa-eye"
                        style={{fontSize:'33px', cursor:'pointer'}}
                       
                      ></i>:                
                      <i className="fa fa-eye-slash"
                        style={{fontSize:'33px', cursor:'pointer'}}
                      ></i>}
                    </>
                </Button>  
                } 
              </div>
              <div className="d-flex align-items-center">
                {role == 'admin' &&
                <Button
                  onClick={onAddTemplate}
                  color="primary" 
                  className="d-flex align-items-center btn-icon btn-3 rounded-0" type="button">
                  <label className="help-icon m-0 mr-1" style={{color:'#091e3f'}} href="#" id="TooltipExample" >i</label>
                  <span style={{color:'#F6CE0E'}}>Task</span>
                  <span className="logo-plus-icon ml-2" style={{fontSize:20}}>
                    +        
                  </span>
                </Button>
                }
                {role == 'admin' &&
                <Button
                  onClick={onAddFee}
                  color="primary" 
                  className="d-flex align-items-center btn-icon btn-3 rounded-0" type="button">
                  <label className="help-icon m-0 mr-1" style={{color:'#091e3f'}} href="#" id="TooltipExample" >i</label>
                  <span style={{color:'#F6CE0E'}}>Catalogue Fee</span>
                  <span className="logo-plus-icon ml-2" style={{fontSize:20}}>
                    +        
                  </span>
                </Button>
                }
                {role == 'admin' &&
                <>
                  <Button
                    onClick={()=>addDecoration(0)}
                    color="primary" 
                    className="d-flex align-items-center btn-icon btn-3 rounded-0" type="button">
                    <label className="help-icon m-0 mr-1" style={{color:'#091e3f'}} href="#" id="TooltipExample" >i</label>
                    <span style={{color:'#F6CE0E'}}>Brand Management</span>
                    <span className="logo-plus-icon ml-2" style={{fontSize:20}}>
                      +        
                    </span>
                  </Button>
                  <Dropdown
                    trigger={['click']}
                    overlay={decorationMenu}
                    animation="slide-up"
                    onVisibleChange={onVisibleChange}
                  >
                    <Button 
                      color="primary" 
                      style={{color:'#F6CE0E', height:44}}
                      className="btn-icon btn-3 add-brand rounded-0 d-flex align-items-center p-1" type="button">     
                      <span style={{fontSize:26}}  href="#" className="material-icons">expand_more</span>
                    </Button>    
                  </Dropdown>
                </>
                }
              </div>
            </Col>
          </Row>
        </Col>
        <Col md="3">
        </Col>
      </Row>
      <Row>
        <Col md="9">
          <div style={{overflowX:'auto'}}>
            <div className={"mb-4 pt-4 catalogue position-relative "+((cost_visible || role != 'admin')?"":"cost-disabled")}>
              {/* {  (role == 'admin') && 
                <div className="cost_visible">
                  <div className="visible-scope"></div>
                  {state.length > 0 &&
                  <>
                    {cost_visible?
                      <i className="fa fa-eye"
                      style={{fontSize:'20px!important', cursor:'pointer'}}
                      onClick={() => {
                        onChangeEmb(0, "cost_visible", false)
                      }}
                    ></i>:                
                    <i className="fa fa-eye-slash"
                      style={{fontSize:'20px!important', cursor:'pointer'}}
                      onClick={() => {
                        onChangeEmb(0, "cost_visible", true)
                      }}
                    ></i>}
                  </>}
                </div>
              } */}
              <div style={{ display: "block"}}>
                <div style={{ display: "block" ,minWidth:'1000px'}}>
                  <div
                    className="category-title"
                    style={getHeaderStyle()}
                  >
                    <div
                      className="p-2"
                      style={{
                        width:350,
                        justifyContent:'start'
                      }}>
                        <div 
                          onClick={
                            ()=>{
                              if(props.quote.status == 'Completed Quote' && role != 'admin'){
                                props.setOpenConfirmEditModal(true);
                                return false;
                              }
                              setOpenAddProduct(true)
                            }
                          } 
                          className="d-flex align-items-center category-subtitle" style={{cursor:'pointer'}}
                        >
                          <span className="logo-plus-icon mr-2" style={{fontSize:20}}>
                            +        
                          </span>
                          <span className="label" style={{color:'#F6CE0E'}}>Products</span>
                          <label className="help-icon" style={{color:'#091e3f', margin: '0 0 0 14px'}} href="#" id="products-label-tooltip" >i</label>
                        </div>
                        <UncontrolledTooltip  placement="bottom" className="text-left justify-content-start" target="products-label-tooltip" trigger="hover focus">  
                            To add products to your quote, first choose the catalogue you want to shop from.<br/>
                            Then, enter the SKU code, select the colors, sizes, and quantities of the garments you want to add. Once you have entered this information, the selected garments will be added to your quote.
                        </UncontrolledTooltip>
                      </div>
                    <div
                      className="p-2"
                      style={{
                        width:60
                      }}>Quantity</div>
                    <div
                      className="p-2"
                      style={{
                        width:60
                      }}>{(role == 'admin' && cost_visible)&&<>Unit<br/>Cost</>}</div>
                    
                    <div
                      className="p-2"
                      style={{
                        width:60
                      }}>{(role == 'admin' && cost_visible)&&<>Cost</>}</div>
                    
                    <div
                      className="p-2"
                      style={{
                        width:60
                      }}>Unit<br/>Price</div>
                    <div
                      className="p-2"
                      style={{
                        width:60
                      }}>Total</div>
                    <div
                      className="p-0"
                      style={{
                        width:47, fontSize:11, color:'#f6ce0e'
                      }}>
                        <div style={{marginTop:12, textAlign:'center'}}>
                          <label className="help-icon" style={{color:'#091e3f', margin: '0 0 9px 14px'}} href="#" id="brand-check-tooltip" >i</label><br/>
                          <span>Select All</span>
                        </div>
                        <UncontrolledTooltip  placement="bottom" className="text-left justify-content-start" target="brand-check-tooltip" trigger="hover focus">                   
                          
                            In this section, you can choose the area of the garment that you want decorated.<br/>
                            Simply select the position on the garment where you want the decoration to be applied. <br/>
                            This will automatically add a Brand Management Instruction to your quote and calculate the number of garments that require decoration. Keep it simple! <br/>
                            When you submit your quote request to our Brand Management team, we will complete the details, enter pricing, and attach any necessary files before sending it back to you for approval. <br/>
                            If you are a repeat ordering customer, the previous art files for your job will be automatically assigned to the new quote, ensuring accuracy and efficiency with every order you place. <br/>
                            If you need new art work, just let us know when you submit your quote and we will be in touch.
                          
                        </UncontrolledTooltip >
                    </div>
                    <div
                      className="p-2 d-flex align-items-end"
                      style={{
                      }}>
                      {
                          positionList.map((position, positionIndex) => (
                            <>
                              {position !="Other"?
                                <div className="text-center" style={{width:28}} key={positionIndex}>
                                  <label className="position-label">{position}</label>
                                  <div className="w-100 custom-checkbox">
                                      <input
                                        className="custom-control-input"
                                        id={`customCheck${position}`}
                                        type="checkbox"
                                        name="primary_set"
                                        // value={primary_set}
                                        checked={positionSelectAll[position]?true:false}
                                        onChange={(e)=>setColumnPosition(position, e)}
                                      />
                                      <label onMouseEnter = {(e)=>{setHoverPosition(position)}} className="custom-control-label vertical" htmlFor={`customCheck${position}`}>
                                      </label>
                                    </div>
                                </div>:
                                <div className="d-block">
                                  <div>
                                    <Input id="brand-check-other-tooltip" className="other-input" style={{width:60,  marginLeft:5}} type="text" name="other_position" value={otherText} onChange={(e)=>updateOtherText(e.target.value)}>
                                    </Input>
                                    <UncontrolledTooltip  placement="bottom" className="text-left justify-content-start" target="brand-check-other-tooltip" trigger="hover focus">  
                                        This visual reference can help you choose the preferred area of decoration for your garments. <br/>
                                        After you approve the quote, we will send you a detailed visual concept before starting production.
                                    </UncontrolledTooltip >
                                    {/* <Tooltip placement="bottom" isOpen={tooltipBrandCheckOtherOpen} className="text-left" target="brand-check-other-tooltip" toggle={toggletooltipBrandCheckOtherOpen}>
                                    This visual reference can help you choose the preferred area of decoration for your garments. After you approve the quote, we will send you a detailed visual concept before starting production.
                                    </Tooltip>         */}
                                  </div>
                                  <div className="w-100 custom-checkbox text-left">
                                      <input
                                        className="custom-control-input"
                                        id={`customCheck${position}`}
                                        type="checkbox"
                                        name="primary_set"
                                        // value={primary_set}
                                        checked={positionSelectAll[position]?true:false}
                                        onChange={(e)=>setColumnPosition(position, e)}
                                      />
                                      <label className="custom-control-label vertical" style={{marginLeft:15}} htmlFor={`customCheck${position}`}>
                                      </label>
                                    </div>
                                </div>
                              }
                            </>
                          ))              
                      }
                    </div>
                    
                  </div>

                  {/* <div style={{minHeight:(state.length==0?300:'unset')}}> */}
                  <div>
                    <DragDropContext  onDragStart={onDragStart} onDragEnd={onDragEndProduct}>
                      {state.map((el, ind) => (
                        <div key={ind} className="group">
                          {ind==0&&
                          <>
                            {renderCategoryFee(el, ind)}
                          </>                    
                          }
                          <Droppable key={ind} droppableId={`${ind}`}>
                            {(provided, snapshot) => (
                              <div
                                ref={provided.innerRef}
                                style={getListStyle(snapshot.isDraggingOver)}
                                {...provided.droppableProps}
                              >
                                {getItemList('product', el).map((item, index) => (          
                                  <>                      
                                    <Draggable
                                      key={item.id}
                                      draggableId={`product_${index+1}`}
                                      index={index}
                                      el_index = {item.index}
                                    >
                                      {(provided, snapshot) => (
                                        <>
                                          {item.type=="product"&&
                                          <div
                                            ref={provided.innerRef}     
                                            {...provided.draggableProps}
                                            style={getItemStyle(
                                              snapshot.isDragging,
                                              provided.draggableProps.style,
                                              // getItemPosition(item),
                                              index,
                                              item.type,
                                              item.notFound && role=="admin"
                                            )}
                                            className="table-row"
                                          >
                                            {renderProduct(ind, item.index, item,provided)}
                                          </div>                                
                                          }                                        
                                        </>
                                      )}
                                    </Draggable>
                                    
                                    {item.type=="product"&&validProductSubtotal(el, item.index)&&
                                    <>
                                      {ind==0&&
                                      <>
                                        {renderCategoryDiscount(el, ind)}  
                                      </>                    
                                      }
                                      {renderProductSubtotal(el, item.index)}
                                    </>
                                    }
                                  </>
                                ))}                              
                                {provided.placeholder}
                              </div>
                            )}
                          </Droppable>  
                          
                        </div>
                      ))}
                    </DragDropContext>
                    
                    <div style={{ display: "block" ,overflow:'auto'}}>
                      <div style={{ display: "block" ,minWidth:'1000px'}}>
                        <div
                          className="category-title rounded-0 justify-content-between"
                          style={getHeaderStyle()}
                        >
                          <div
                            className="p-2"
                            style={{
                              width:350,
                              justifyContent:'start'
                            }}>
                            {/* <Ripples> */}
                            {role == 'admin' ?
                              <div onClick={()=>addDecoration(0)} className="d-flex align-items-center category-subtitle" style={{cursor:'pointer'}}>
                                <span className="logo-plus-icon mr-2" style={{fontSize:20}}>
                                  +        
                                </span>
                                <span className="label" style={{color:'#F6CE0E'}}>Brand Management</span>
                                <label className="help-icon" style={{color:'#091e3f', margin: '0 0 -2px 14px'}} href="#" id="brand-add-tooltip" >i</label>
                              </div>:
                              <div className="d-flex align-items-center category-subtitle" style={{cursor:'pointer'}}>
                                <span className="label" style={{color:'#F6CE0E'}}>Brand Management</span>
                                <label className="help-icon" style={{color:'#091e3f', margin: '0 0 -2px 14px'}} href="#" id="brand-add-tooltip" >i</label>
                              </div>
                            }
                            <UncontrolledTooltip  placement="bottom" className="" target="brand-add-tooltip" trigger="hover focus">                   
                              
                                This is the Brand Management section, where we handle embroidery, screen printing, and other decoration techniques. <br/>
                                By default, embroidery will be selected when you raise a quote. However, one of our Brand Management team members will help identify the best value option for you based on factors such as the garments selected, quantities, decoration requirements, and the logo itself. <br/>
                                Before you submit a quote, we invite you to discuss your preferences with us to ensure that you get the best possible results.
                              
                            </UncontrolledTooltip>
                            {/* </Ripples> */}
                          </div>
                          <div
                            className="p-2"
                            style={{
                              width:350,
                              justifyContent:'end'
                            }}>
                              <div className="expand-btn" onClick={()=>setOpenBrandManagement(!openBrandManagement)}>  
                                {
                                  openBrandManagement?
                                  <span style={{fontSize:36}} className="material-icons ">expand_less</span> :
                                  <span style={{fontSize:36}} className="material-icons ">expand_more</span>
                                }            
                              </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <Collapse isOpened={openBrandManagement}>
                      <DragDropContext  onDragStart={onDragStart} onDragEnd={onDragEndDecoration}>
                        {state.map((el, ind) => (
                          <div key={ind} className="group">
                            <Droppable key={ind} droppableId={`${ind}`}>
                              {(provided, snapshot) => (
                                <div
                                  ref={provided.innerRef}
                                  style={getListStyle(snapshot.isDraggingOver)}
                                  {...provided.droppableProps}
                                >
                                  {getItemList('decoration', el).map((item, index) => ( 
                                    <>
                                      <Draggable
                                        key={item.id}
                                        draggableId={`decoration_${index+1}`}
                                        index={index}
                                      >
                                        {(provided, snapshot) => (
                                          <>
                                            <div
                                              ref={provided.innerRef}    
                                              {...provided.draggableProps}
                                              style={getItemStyle(
                                                snapshot.isDragging,
                                                provided.draggableProps.style,
                                                // getItemPosition(item),
                                                index,
                                                item.type
                                              )}
                                              className="table-row"
                                            >
                                              {/* panther */}
                                              {renderDecoration(el, ind, item.index,item,provided)}                                  
                                            </div>
                                          </>
                                        )}
                                      </Draggable>
                                      {item.type=="decoration"&&
                                      renderOthersSubtotal(item,"decoration", getItemPosition(item))}   
                                    </>
                                  ))}
                                  
                                  {provided.placeholder}
                                </div>
                              )}
                            </Droppable>   
                          </div>
                        ))}
                      </DragDropContext>
                    </Collapse>
                    <div style={{ display: "block" ,overflow:'auto'}}>
                      <div style={{ display: "block" ,minWidth:'1000px'}}>
                        <div
                          className="category-title rounded-0 justify-content-between"
                          style={getHeaderStyle()}
                        >
                          <div
                            className="p-2"
                            style={{
                              width:350,
                              justifyContent:'start'
                            }}>
                            {/* <Ripples> */}
                            {role == 'admin' ?
                              <div onClick={()=>onAddTemplate()} className="d-flex align-items-center category-subtitle" style={{cursor:'pointer'}}>
                                <span className="logo-plus-icon mr-2" style={{fontSize:20}}>
                                  +        
                                </span>
                                <span className="label" style={{color:'#F6CE0E'}}>Tasks</span>
                                <label className="help-icon" style={{color:'#091e3f', margin: '0 0 -2px 14px'}} href="#" id="task-add-tooltip" >i</label>
                              </div>:
                              <div className="d-flex align-items-center category-subtitle" style={{cursor:'pointer'}}>
                                <span className="label" style={{color:'#F6CE0E'}}>Tasks</span>
                                <label className="help-icon" style={{color:'#091e3f', margin: '0 0 -2px 14px'}} href="#" id="task-add-tooltip" >i</label>
                              </div>
                            }
                            <UncontrolledTooltip  placement="bottom" className="text-left justify-content-start" target="task-add-tooltip" trigger="hover focus"> 
                              When creating your job, we will identify any specific tasks required to complete your order.<br/>
                              Tasks may be added here,
                            </UncontrolledTooltip>
                            {/* </Ripples> */}
                          </div>
                          <div
                            className="p-2"
                            style={{
                              width:350,
                              justifyContent:'end'
                            }}>
                              <div className="expand-btn" onClick={()=>setOpenTask(!openTask)}>  
                                {
                                  openTask?
                                  <span style={{fontSize:36}} className="material-icons ">expand_less</span> :
                                  <span style={{fontSize:36}} className="material-icons ">expand_more</span>
                                }            
                              </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <Collapse isOpened={openTask}>
                      <DragDropContext  onDragStart={onDragStart} onDragEnd={onDragEnd}>
                        {state.map((el, ind) => (
                          <div key={ind} className="group">
                            {el['group_options']&&  el['group_options']['customs'] &&
                              <>
                                {
                                  el['group_options']['customs'].map((custom, custom_ind)=>{
                                    if((1|| role == 'admin' || (custom&& custom['custom_qty']*1 > 0) && custom['custom_visible'])){
                                      return(
                                        <div key={custom_ind}>
                                          <div
                                            style={getItemStyle(
                                              false,
                                              {},
                                              custom_ind,
                                              'task',
                                            )}
                                            className={"table-row "}
                                          >
                                            {renderTask(el, ind, custom_ind,custom)}
                                          </div>
                                          
                                                      
                                          { renderCustomSubtotal(el, custom_ind) }
                                        </div>
                                      )
                                    }
                                  })
                                }
                              </>
                            } 
                          </div>
                        ))}
                      </DragDropContext>
                      <DragDropContext  onDragStart={onDragStart} onDragEnd={onDragEnd}>
                        {state.map((el, ind) => (
                          <div key={ind} className="group">
                            <Droppable key={ind} droppableId={`${ind}`}>
                              {(provided, snapshot) => (
                                <div
                                  ref={provided.innerRef}
                                  style={getListStyle(snapshot.isDraggingOver)}
                                  {...provided.droppableProps}
                                >
                                  {el.map((item, index) => (
                                    <>                                                
                                      {(role =='admin' || item['checked'])&&item.type=="attention"&&
                                      <Draggable
                                        key={item.id}
                                        draggableId={`attention_${index+1}`}
                                        index={index}
                                      >
                                        {(provided, snapshot) => (
                                          <>
                                            {item.type=="attention"&&
                                            <div
                                              ref={provided.innerRef}    
                                              {...provided.draggableProps}
                                              style={getItemStyle(
                                                snapshot.isDragging,
                                                provided.draggableProps.style,
                                                getItemPosition(item)+customs.length,
                                                item.type
                                              )}
                                              className="table-row"
                                            >
                                              {renderAttention(el, ind, index,item,provided)}                                  
                                            </div>
                                            }
                                          </>
                                        )}
                                      </Draggable>
                                      }                         
                                    </>
                                  ))}
                                  
                                  {provided.placeholder}
                                </div>
                              )}
                            </Droppable>   
                          </div>
                        ))}
                      </DragDropContext>
                      <DragDropContext  onDragStart={onDragStart} onDragEnd={onDragEnd}>
                        {state.map((el, ind) => (
                          <div key={ind} className="group">
                            <Droppable key={ind} droppableId={`${ind}`}>
                              {(provided, snapshot) => (
                                <div
                                  ref={provided.innerRef}
                                  style={getListStyle(snapshot.isDraggingOver)}
                                  {...provided.droppableProps}
                                >
                                  {el.map((item, index) => (
                                    <>                   
                                      {(role =='admin' || item['checked'])&&item.type=="delivery"&&
                                      <Draggable
                                        key={item.id}
                                        draggableId={`delivery_${index+1}`}
                                        index={index}
                                      >
                                        {(provided, snapshot) => (
                                          <>
                                            {item.type=="delivery"&&
                                            <div
                                              ref={provided.innerRef}    
                                              {...provided.draggableProps}
                                              style={getItemStyle(
                                                snapshot.isDragging,
                                                provided.draggableProps.style,
                                                getItemPosition(item)+customs.length,
                                                item.type
                                              )}
                                              className="table-row"
                                            >
                                              {renderDelivery(el, ind, index,item,provided)}                                  
                                            </div>
                                            }
                                          </>
                                        )}
                                      </Draggable>
                                      }                                              
                                      {(role =='admin' || item['checked'])&&item.type=="discount"&&
                                      <Draggable
                                        key={item.id}
                                        draggableId={`discount_${index+1}`}
                                        index={index}
                                      >
                                        {(provided, snapshot) => (
                                          <>
                                            {item.type=="discount"&&
                                            <div
                                              ref={provided.innerRef}    
                                              {...provided.draggableProps}
                                              style={getItemStyle(
                                                snapshot.isDragging,
                                                provided.draggableProps.style,
                                                getItemPosition(item)+customs.length,
                                                item.type
                                              )}
                                              className="table-row"
                                            >
                                              {renderDiscount(el, ind, index,item,provided)}                                  
                                            </div>
                                            }
                                          </>
                                        )}
                                      </Draggable>
                                      }                              
                                      {item.type=="discount"&&
                                      renderOthersSubtotal(item, "discount", getItemPosition(item)+customs.length)}
                                      {item.type=="delivery"&&
                                      renderOthersSubtotal(item,"delivery",getItemPosition(item)+customs.length)}
                                    </>
                                  ))}
                                  
                                  {provided.placeholder}
                                </div>
                              )}
                            </Droppable>   
                          </div>
                        ))}
                      </DragDropContext>
                    </Collapse>
                  </div>
                </div>
              </div>
              <div className="">
                <Summary role ={role}/>
              </div>
              <div className="d-flex">
                <div style={{width:575}}>
                  <SummaryGross role={role}/>
                </div>
                
                <div style={{width:'calc(100% - 660px)'}}>
                  <div>
                    <div className="order-nav order-cat-nav d-flex">
                      <div className="mt-2 mx-2" > 
                         {/* style="background: rgb(10, 31, 65); color: rgb(246, 206, 14);" */}
                        <div className="quote-status d-flex justify-content-center align-items-center" style={{
                          background : '#0a1f41',
                          color : '#f6ce0e',
                          height: 55,
                        }}>
                          STATUS:  {props.quote.status}
                        </div>

                        <Button
                          id="view-history-btn"
                          onClick={(e)=> viewLog(props.quote.id)} outline
                          className="d-block btn-icon btn-3 rounded-0 border-2 mb-2" color="primary" type="button">
                          <span className="btn-inner--text">VIEW HISTORY</span>
                        </Button>   
                      </div>
                      <div className="m-auto" > 
                        {/* <div className="d-flex align-items-center  mb-2 mt-3">
                          {mode != "view"&& role!='admin' &&
                          <>
                            <label className="m-0 mr-3">Accept<b> terms</b></label>
                            <div className="custom-control custom-checkbox m-0 normal">
                              <input
                                className="custom-control-input"
                                id="accept-checkbox1"
                                type="checkbox"
                                checked={accepted?true:false}
                                value={accepted}
                                onChange={(e)=>setAccepted(!accepted)}
                              />
                              <label className="custom-control-label" htmlFor="accept-checkbox1">
                              </label>
                            </div>
                          </>}
                        </div>  */}
                        {role=='admin' ?
                          <div className="mt-2">
                            {props.quote.order_status? 
                              <>        
                                  <>         
                                    <Button
                                      id="save-order-btn"
                                      onClick={(e)=>props.submitOrder(e, "save_order")} outline
                                      className="d-block btn-icon btn-3 rounded-0 border-2 mb-2" color="primary" type="button">
                                      <span className="btn-inner--text">SAVE ORDER</span>
                                    </Button> 
                                    <Button
                                      id="submit-quote-btn"
                                      onClick={(e)=>props.submitOrder(e, "complete_quote")} outline
                                      className="d-block btn-icon btn-3 rounded-0 border-2 mb-2" color="primary" type="button">
                                      <span className="btn-inner--text">SUBMIT QUOTE</span>
                                    </Button>  
                                    {props.quote.order_status !== "Completed Order" &&  
                                    <Button
                                      onClick={(e)=>props.submitOrder(e, "accept_order")} outline
                                      className="d-block btn-icon btn-3 rounded-0 border-2 mb-2" color="primary" type="button">
                                      <span className="btn-inner--text">COMPLETE ORDER</span>
                                    </Button> 
                                    }
                                    <Button
                                      onClick={(e)=>props.setModal(true)} outline
                                      className="d-block btn-icon btn-3 rounded-0 border-2 mb-2" color="primary" type="button">
                                      <span className="btn-inner--text">Email</span>
                                    </Button> 
                                    <Button
                                      onClick={(e)=>{downloadFile(`/quotes/quotepdf1/${props.quote.id}`, props.quote.id+".pdf")}} outline
                                      className="d-block btn-icon btn-3 rounded-0 border-2 mb-2" color="primary" type="button">
                                      <span className="btn-inner--text">DOWNLOAD PDF</span>
                                    </Button> 
                                    <Button
                                      onClick={()=>{setReorderConfirm(true)}} outline //repeatOrder(props.quote.id)
                                      className="d-block btn-icon btn-3 rounded-0 border-2 mb-2" color="primary" type="button">
                                      <span className="btn-inner--text">Reorder</span>
                                    </Button>  
                                    <Button
                                      onClick={()=>setSendWordflowConfirm(true)} outline
                                      className="d-block btn-icon btn-3 rounded-0 border-2" color="primary" type="button">
                                      <span className="btn-inner--text">Send to Workflowmax</span>
                                    </Button>  
                                    <UncontrolledTooltip  placement="bottom" className="text-left justify-content-start" target="save-order-btn" trigger="hover focus"> 
                                      You can save your order and return to it later.
                                    </UncontrolledTooltip> 
                                  </>
                              </>
                                :
                              <>
                                <Button
                                  id="save-btn"
                                  onClick={(e)=>props.submitOrder(e, "save")} outline
                                  className="d-block btn-icon btn-3 rounded-0 border-2 mb-2" color="primary" type="button">
                                  <span className="btn-inner--text">Save</span>
                                </Button>   
                                <Button
                                  id="submit-quote-btn"
                                  onClick={(e)=>props.submitOrder(e, "complete_quote")} outline
                                  className="d-block btn-icon btn-3 rounded-0 border-2 mb-2" color="primary" type="button">
                                  <span className="btn-inner--text">SUBMIT QUOTE</span>
                                </Button>
                                <Button
                                    onClick={(e)=>props.submitOrder(e, "request_order")} outline
                                    className="d-block btn-icon btn-3 rounded-0 border-2 mb-2" color="primary" type="button">
                                    <span className="btn-inner--text">SUBMIT ORDER</span>
                                </Button>  
                                <Button
                                  onClick={(e)=>props.setModal(true)} outline
                                  className="d-block btn-icon btn-3 rounded-0 border-2 mb-2" color="primary" type="button">
                                  <span className="btn-inner--text">Email Quote</span>
                                </Button> 
                                <Button
                                  onClick={(e)=>{downloadFile(`/quotes/quotepdf1/${props.quote.id}`, props.quote.id+".pdf")}} outline
                                  className="d-block btn-icon btn-3 rounded-0 border-2 mb-2" color="primary" type="button">
                                  <span className="btn-inner--text">DOWNLOAD QUOTE PDF</span>
                                </Button>   
                                <Button
                                  onClick={()=>{duplicateOrder(props.quote.id)}} outline
                                  className="d-block btn-icon btn-3 rounded-0 border-2 mb-2" color="primary" type="button">
                                  <span className="btn-inner--text">Duplicate</span>
                                </Button>
                                <Button
                                  onClick={(e)=>setSmsModal(true)} outline
                                  className="d-block btn-icon btn-3 rounded-0 border-2 mb-2" color="primary" type="button">
                                  <span className="btn-inner--text">Send Quote SMS</span>
                                </Button> 

                                <DeleteElement />
                                
                                <UncontrolledTooltip  placement="bottom" className="text-left justify-content-start" target="save-btn" trigger="hover focus"> 
                                  You can save your quote and return to it later.
                                </UncontrolledTooltip> 
                                <UncontrolledTooltip  placement="bottom" className="text-left justify-content-start" target="submit-quote-btn" trigger="hover focus"> 
                                  Submit your quote request to us for review.
                                </UncontrolledTooltip> 
                                <UncontrolledTooltip  placement="bottom" className="text-left justify-content-start" target="delete-quote-btn" trigger="hover focus"> 
                                  You can delete a quote if you no longer require it on the database.
                                </UncontrolledTooltip> 
                              </>
                            }    
                          </div>:
                          <div className="mt-2">
                            {props.quote.order_status?                             
                              <>
                                  <Button
                                    onClick={()=>{setReorderConfirm(true)}} outline  //repeatOrder(props.quote.id)
                                    className="d-block btn-icon btn-3 rounded-0 border-2 mb-2" color="primary" type="button">
                                    <span className="btn-inner--text">Reorder</span>
                                  </Button>  
                              </>:
                              <>       
                                <Button
                                  onClick={(e)=>props.submitOrder(e, "save")} outline
                                  className="d-block btn-icon btn-3 rounded-0 border-2 mb-2" color="primary" type="button">
                                  <span className="btn-inner--text">Save</span>
                                </Button> 
                                {(props.quote.status == "Draft Quote" || contentUpdated) &&
                                <Button
                                  id="submit-quote-btn"
                                  onClick={(e)=>props.submitOrder(e, "request_quote")} outline
                                  className="d-block btn-icon btn-3 rounded-0 border-2 mb-2" color="primary" type="button">
                                  <span className="btn-inner--text">SUBMIT QUOTE</span>
                                </Button> 
                                }

                                <DeleteElement />
 
                                {props.quote.status == "Completed Quote" &&   
                                  <>
                                  <Button
                                      onClick={(e)=>props.submitOrder(e, "decline_quote")} outline
                                      className="d-block btn-icon btn-3 rounded-0 border-2 mb-2" color="primary" type="button">
                                      <span className="btn-inner--text">DECLINE</span>
                                    </Button>                            
                                    <Button
                                      // disabled={!accepted}
                                      onClick={(e)=>props.submitOrder(e, "request_order")} outline
                                      className="d-block btn-icon btn-3 rounded-0 border-2 mb-2" color="primary" type="button">
                                      <span className="btn-inner--text">Accept</span>
                                    </Button>   
                                  </>
                                } 
                                {(props.quote.status == "Draft Quote" || contentUpdated) &&
                                <UncontrolledTooltip  placement="bottom" className="text-left justify-content-start" target="submit-quote-btn" trigger="hover focus"> 
                                  Submit your quote request to us for review.
                                </UncontrolledTooltip> 
                                }
                                <UncontrolledTooltip  placement="bottom" className="text-left justify-content-start" target="delete-quote-btn" trigger="hover focus"> 
                                  You can delete a quote if you no longer require it on the database.
                                </UncontrolledTooltip> 
                              </>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
        </Col>
        <Col md="3">
          <div>
            <Row className="custom-card-header" style={{marginTop: 24}}>           
              <Col className="text-left" xs="12">
                  <h6 style={{fontSize:14}}><b>Position</b>&nbsp;<span style={{fontSize:12}}>(Hover to see)</span></h6>   
              </Col>
            </Row>
            <Row className="custom-card-body">           
              <Col className="text-left" xs="12">
                <div style={{height: 220}}>
                  <img width="100%" src={(hoverPosition && hoverPosition!="Other")?require(`assets/img/brand_imgs/${hoverPosition}.jpg`).default:''}/>
                </div>
              </Col>        
              <Col xs="12">
                <hr/>            
              </Col>        
              <Col className="text-left" xs="12">
                <div className="d-flex justify-content-between align-items-center">
                  <h6 ><b>{hoverPosition}</b></h6>  
                  <span style={{fontSize:10}}><b>Not Actual garment</b></span>
                </div>
              </Col>
            </Row>
          </div>
          <div>
            <Row className="custom-card-header" style={{marginTop: "3rem"}}>           
              <Col className="text-left" xs="12">
                  <h6 style={{fontSize:14}}>
                    <b>Order Summary</b>
                    <label className="help-icon" style={{color:'#091e3f', margin: '0 0 0 14px'}} href="#" id="order-summary-label" >i</label>
                  </h6>   
                  <UncontrolledTooltip  placement="bottom" className="text-left justify-content-start" target="order-summary-label" trigger="hover focus"> 
                    Order summary is a simplified overview of your order.
                  </UncontrolledTooltip>
              </Col>
            </Row>
            <Row className="custom-card-body">   
              <Col xs="12">
                <div className="order-nav order-cat-nav left">
                  <div className="m-auto" >      
                    <div>
                      <LeftSummary role={role} tasks={taskOptions} templates={templates} onChangeProduct={onChangeProduct} onChangeEmbDecoration={onChangeEmbDecoration} onChangeEmbManage={onChangeEmbManage} onChangeEmbCustomTask={onChangeEmbCustomTask}/>
                    </div>
                    {/* <div className="d-flex align-items-center mb-2">
                      {mode != "view"&& role!='admin' &&
                      <>
                        <label className="m-0 mr-3">Accept<b> terms</b></label>
                        <div className="custom-control custom-checkbox m-0 small yellow">
                          <input
                            className="custom-control-input"
                            id="accept-checkbox2"
                            type="checkbox"
                            checked={accepted?true:false}
                            value={accepted}
                            onChange={(e)=>setAccepted(!accepted)}
                          />
                          <label className="custom-control-label" htmlFor="accept-checkbox2">
                          </label>
                        </div>
                      </>   
                      }   
                    </div>   */}
                    {role=='admin' ?
                      <div mt={2}>
                        {props.quote.order_status? 
                          <>        
                              <>       
                                <Button
                                  id="save-order-btn"
                                  onClick={(e)=>props.submitOrder(e, "save_order")} outline
                                  className="d-block btn-icon btn-3 rounded-0 mb-2 yellow border-none" color="primary" type="button">
                                  <span className="btn-inner--text">SAVE ORDER</span>
                                </Button>   
                                {props.quote.order_status !== "Completed Order" &&      
                                <Button
                                  onClick={(e)=>props.submitOrder(e, "accept_order")} outline
                                  className="d-block btn-icon btn-3 rounded-0 mb-2 yellow border-none" color="primary" type="button">
                                  <span className="btn-inner--text">COMPLETE ORDER</span>
                                </Button> 
                                }
                                <Button
                                  onClick={(e)=>props.setModal(true)} outline
                                  className="d-block btn-icon btn-3 rounded-0  yellow border-none mb-2" color="primary" type="button">
                                  <span className="btn-inner--text">Email</span>
                                </Button>                                 
                                <Button
                                      onClick={(e)=>{downloadFile(`/quotes/quotepdf1/${props.quote.id}`, props.quote.id+".pdf")}} outline
                                      className="d-block btn-icon btn-3 rounded-0  yellow border-none mb-2" color="primary" type="button">
                                      <span className="btn-inner--text">DOWNLOAD PDF</span>
                                    </Button> 
                                <Button
                                  onClick={()=>{setReorderConfirm(true)}} outline //repeatOrder(props.quote.id)
                                  className="d-block btn-icon btn-3 rounded-0 mb-2 yellow border-none" color="primary" type="button">
                                  <span className="btn-inner--text">Reorder</span>
                                </Button>  
                                <Button
                                  onClick={()=>setSendWordflowConfirm(true)} outline
                                  className="d-block btn-icon btn-3 rounded-0  yellow border-none" color="primary" type="button">
                                  <span className="btn-inner--text">Send to Workflowmax</span>
                                </Button>  
                              </>
                          </>
                            :
                          <>
                            <Button
                              id="save-btn"
                              onClick={(e)=>props.submitOrder(e, "save")} outline
                              className="d-block btn-icon btn-3 rounded-0 mb-2 yellow border-none" color="primary" type="button">
                              <span className="btn-inner--text">Save</span>
                            </Button>   
                            <Button
                              onClick={(e)=>props.submitOrder(e, "accept_quote")} outline
                              className="d-block btn-icon btn-3 rounded-0 mb-2 yellow border-none" color="primary" type="button">
                              <span className="btn-inner--text">SUBMIT QUOTE</span>
                            </Button>
                            <Button
                              onClick={(e)=>props.setModal(true)} outline
                              className="d-block btn-icon btn-3 rounded-0 mb-2 yellow border-none" color="primary" type="button">
                              <span className="btn-inner--text">EMAIL QUOTE</span>
                            </Button> 

                            <DeleteElement />

                            <UncontrolledTooltip  placement="bottom" className="text-left justify-content-start" target="save-btn" trigger="hover focus"> 
                              You can save your quote and return to it later.
                            </UncontrolledTooltip>
                          </>
                        }    
                      </div>:
                      <>
                        {props.quote.order_status?                             
                          <>
                            <>
                              <Button
                                onClick={()=>{setReorderConfirm(true)}} outline //repeatOrder(props.quote.id)
                                className="d-block btn-icon btn-3 rounded-0 mb-2 yellow border-none" color="primary" type="button">
                                <span className="btn-inner--text">Reorder</span>
                              </Button>  
                            </>
                          </>:
                          <>       
                            <Button
                              id="save-btn"
                              onClick={(e)=>props.submitOrder(e, "save")} outline
                              className="d-block btn-icon btn-3 rounded-0 mb-2 yellow border-none" color="primary" type="button">
                              <span className="btn-inner--text">Save</span>
                            </Button> 
                            {(props.quote.status == "Draft Quote" || contentUpdated) &&                  
                            <Button
                              onClick={(e)=>props.submitOrder(e, "request_quote")} outline
                              className="d-block btn-icon btn-3 rounded-0 mb-2 yellow border-none" color="primary" type="button">
                              <span className="btn-inner--text">SUBMIT QUOTE</span>
                            </Button> 
                            }

                            <DeleteElement />

                            {props.quote.status == "Completed Quote" &&   
                              <>
                              <Button
                                  onClick={(e)=>props.submitOrder(e, "decline_quote")} outline
                                  className="d-block btn-icon btn-3 rounded-0 mb-2 yellow border-none" color="primary" type="button">
                                  <span className="btn-inner--text">DECLINE</span>
                                </Button>                            
                                <Button
                                  // disabled={!accepted}
                                  onClick={(e)=>props.submitOrder(e, "request_order")} outline
                                  className="d-block btn-icon btn-3 rounded-0 mb-2 yellow border-none" color="primary" type="button">
                                  <span className="btn-inner--text">Accept</span>
                                </Button>   
                              </>
                            } 
                            <UncontrolledTooltip  placement="bottom" className="text-left justify-content-start" target="save-btn" trigger="hover focus"> 
                              You can save your quote and return to it later.
                            </UncontrolledTooltip>
                          </>
                        }
                      </>
                    }
                  </div>
                </div>         
              </Col>     
            </Row>
          </div>
          <div style={{marginTop:'3rem'}} id="logo-contact">
            <img width="100%" src={logo_contact}/>
            
            <UncontrolledTooltip  placement="bottom" className="text-left justify-content-start" target="logo-contact" trigger="hover focus"> 
              This is Logo_the_legend_Kelpie<br/>
              He loves people and of course, ball is life.<br/>
              He embodies the values of our business:<br/>
              Hard working, focused and forever loyal.<br/>
              He also knows how to have fun.<br/><br/>
              Drop in to the showroom and say hi
            </UncontrolledTooltip>
          </div>
        </Col>
      </Row>
      
      <Modal isOpen={logOpen} toggle={()=>setLogOpen(false)} >
        <ModalHeader toggle={()=>setLogOpen(false)}>History</ModalHeader>
        <ModalBody>
            <FormGroup>
              <Input style={{whitespace: 'pre-line', maxHeight:150, overflowY:'auto'}} disabled type="textarea" rows="8" value={logData?logData:""}/> 
            </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" size="sm" onClick={()=>setLogOpen(false)}>Close</Button>
        </ModalFooter>
      </Modal>
      
      <Modal isOpen={deleteGroupConfirm} toggle={()=>setDeleteGroupConfirm(false)} >
        <ModalHeader toggle={()=>setDeleteGroupConfirm(false)}>Confirm</ModalHeader>
        <ModalBody>
          Deleting this group will remove the items within this group, are you sure?
        </ModalBody>
        <ModalFooter>
          <Button color="primary" size="sm" onClick={()=>doDeleteGroup(false)}>Yes</Button>{' '}
          <Button color="secondary" size="sm" onClick={()=>setDeleteGroupConfirm(false)}>No</Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={deleteQuoteConfirm} toggle={()=>setDeleteQuoteConfirm(false)} >
        <ModalHeader toggle={()=>setDeleteQuoteConfirm(false)}>Confirm</ModalHeader>
        <ModalBody>
          Are you sure to delete this quote?
        </ModalBody>
        <ModalFooter>
          <Button color="primary" size="sm" onClick={()=>deleteQuote(false)}>Yes</Button>{' '}
          <Button color="secondary" size="sm" onClick={()=>setDeleteQuoteConfirm(false)}>No</Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={smsModal} toggle={()=>setSmsModal(false)} size="md">
        <ModalHeader toggle={()=>setSmsModal(false)}>
          <h3 className="h4 font-weight-bold mb-0">
            Send Sms
          </h3>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col  md="12">
              <FormGroup>
                <Label><strong>Phone Number</strong></Label>
                <Input placeholder="" value={smsNumber?smsNumber:''} onChange={(e)=>setSmsNumber(e.target.value)}/>
              </FormGroup>
            </Col>
            <Col  md="12">
              <FormGroup>
                <Label><strong>Message</strong></Label>
                <Input type="textarea" spellcheck="true" placeholder="Note" rows="5" value={smsNote} onChange={(e)=>setSmsNote(e.target.value)}/>
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <div style={{display:'flex', justifyContent:'flex-end', padding:"20px"}}>
          <Button color="primary" onClick={()=>sendSmsQuote()}>Send</Button>{' '}
          <Button color="secondary" onClick={()=>setSmsModal(false)}>Cancel</Button>
        </div>
      </Modal>
      {openProductImage && (
        <Lightbox
          mainSrc={modalImage?modalImage:require("assets/img/theme/product-placeholder.jpg")}
          
          onCloseRequest={() => toggleProductImage()}
        />
      )}
      {openAddProduct &&
      <Product isOpen={openAddProduct} category={null} toggle = {()=>toggleAddProduct(null)}
        selectedCategory={selectedCategory}
        selectedProducts={selectedProducts}
        onAdd={(cat_items, categoryInfo) => {
          var state=[]
          var categories = {...props.quote.categories}
          var category = null
          for(var catInd in categories){
            var category = {...categories[catInd]}
            break;
          }
          if(category)
            state = [...category.items]
          if(!state){
            state = [[]];
          }
          if(state.length == 0) 
            state = [[]];
          var itemsInGroup = [...state[0]];
          var group_options = {...state[0]['group_options']}
          for(var categoryKey in cat_items){
            var newitems = [...cat_items[categoryKey]]
            for(var loop = 0; loop < newitems.length; loop++){
              var newitem = {...newitems[loop]}
              newitem['productid'] = newitem['id']
              var itemCount = 0;
              for(var loop1 = 0; loop1< state.length; loop1++){
                itemCount+= state[loop1].length;
              }
              newitem['id'] = (loop + itemCount + 1).toString()
              newitem['type'] = "product";
              itemsInGroup.push(newitem)
            }
            if(!("customfees" in group_options)){      
              group_options['customfees'] = [];
            }
            var checkgroup = false;
            for(var i = 0; i< group_options['customfees'].length; i++){
              if(group_options['customfees'][i]['catalogue'] == categoryKey){
                checkgroup = true;
              }
            }
            if(!checkgroup){
              var customfee = {}
              customfee['customfee_qty'] = 1;
              customfee['catalogue'] = categoryKey;
              // customfee['customfee_price'] = supplier_fee[categoryKey]['price'];
              customfee['customfee_price'] = (supplier_fee[categoryKey] && !isNaN(supplier_fee[categoryKey]['price'])) ? supplier_fee[categoryKey]['price'] : 0;
              group_options['customfees'].push(customfee);
            }
          }

          state[0] = itemsInGroup;
          var newstate = [...state];
          newstate[0]['group_options'] = group_options;
          var cat_val={
            [0]:{
              ...category,
              category_info: categoryInfo,
              items: newstate,
            }
          }
          props.updateCategory(cat_val)
        }}
      />
      }
      <Modal isOpen={sendWordflowConfirm} toggle={()=>setSendWordflowConfirm(false)} >
        <ModalHeader toggle={()=>setSendWordflowConfirm(false)}>Send to Workflowmax</ModalHeader>
        <ModalBody>
          <Row>
            <Col md="8">
              <FormGroup className="mb-1">
              <label>Category</label>
                <Input type="select" value={wfm_category} name="id" onChange={(e)=>setWfmCategory(e.target.value)}>
                  <option value="">None</option>
                  {
                    (() => {
                      var element = [];
                      for(var key in wfm_category_options){
                        element.push(
                          <option key={key} value={wfm_category_options[key]}>{wfm_category_options[key]}</option>
                        )
                      }
                      return element
                    })()
                  }
                </Input>
                  {/* <Input className="input-field" disabled = {!editMode} placeholder="Company Name" type="text" name="company" value={contact?contact.company:''} onChange={(e)=>setContact({...contact, company:e.target.value})}/> */}

              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" size="sm" onClick={()=>{props.sendWorkflowmax(props.quote.id, wfm_category); setSendWordflowConfirm(false)}}>Yes</Button>{' '}
          <Button color="secondary" size="sm" onClick={()=>setSendWordflowConfirm(false)}>No</Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={openPreview} toggle={()=>setOpenPreview(false)} >
        <ModalHeader toggle={()=>setOpenPreview(false)}>Preview</ModalHeader>
        <ModalBody>          
          <div className="resource-preview-container">
            <div className="resource-preview">
              {extension && ( extension.toLowerCase().includes("jpg") || extension.toLowerCase().includes("png") || extension.toLowerCase().includes("jpeg") || extension.toLowerCase().includes("gif") ) &&
                <InnerImageZoom src={curSrc} zoomSrc={curSrc} /> 
              }
              {extension && ( extension.includes("pdf")) &&
              <div>
                <Document file={curSrc} onLoadSuccess={onDocumentLoadSuccess}>
                  <Page scale={pdfScale} pageNumber={pageNumber}  rotate={pdfRotate}/>
                </Document>
              </div>
              }
            </div>
            {curSrc &&extension && ( extension.includes("pdf")) &&
            <div className="d-flex justify-content-between">
              <a href={curSrc} download target="_blank" ><i className="fa fa-folder-open"></i></a>
              <div>
                <i className="fa fa-search-minus mr-3" style={{cursor:'pointer'}} onClick={()=>{  setPdfScale(pdfScale*0.8)}}></i>
                <i className="fa fa-search-plus mr-3" style={{cursor:'pointer'}} onClick={()=>{ setPdfScale(pdfScale*1.2)}}></i>
                <i className="fa fa-rotate-left mr-3" style={{cursor:'pointer'}} onClick={()=>{  setPdfRotate((pdfRotate-90)%360)}}></i>
                <i className="fa fa-rotate-right mr-3" style={{cursor:'pointer'}} onClick={()=>{  setPdfRotate((pdfRotate+90)%360)}}></i>
                <i className="fa fa-chevron-left mr-3" style={{cursor:'pointer'}} onClick={()=>{ if(pageNumber>1) setPageNumber(pageNumber-1)}}></i>
                <span className="mr-3" style={{fontSize:14}}>Page {pageNumber} of {numPages}</span>
                <i className="fa fa-chevron-right" style={{cursor:'pointer'}} onClick={()=>{ if(pageNumber<numPages) setPageNumber(pageNumber+1)}} ></i>
              </div>
            </div>
            }
          </div>
        </ModalBody>
      </Modal>

      <Modal isOpen={reorderConfirm} toggle={()=>setReorderConfirm(false)} >
        <ModalHeader toggle={()=>setReorderConfirm(false)}>Confirm</ModalHeader>
        <ModalBody>
          Discounts on prior orders are subject to change when re-ordered.
        </ModalBody>
        <ModalFooter>
          <Button color="primary" size="sm" onClick={()=>repeatOrder(props.quote.id)}>OK</Button>{' '}
        </ModalFooter>
      </Modal>
      
      <LoadingOverlay
          active={props.quote.loadingFlag||!props.quote.companyLoaded||props.quote.quoteLoading||uploadingFile}
          styles={{
              overlay: (base) => ({
              ...base,
              fontSize:'18px',
              color: 'rgb(5, 37, 51)',
              background: 'rgb(60 60 60 / 48%)',
              position:'fixed',
              zIndex:1000000000
              })
          }}
          spinner = {<ScaleLoader color={'#1976d2'} radius={2.5} margin={2.5} height={40} width={5}/>}
          // spinner
          // text='Loading ...'
          >
      </LoadingOverlay> 
    </>
  );
}


const mapStateToProps = (state) => {
  return {
    quote: state.quote,
    ui: state.ui,
    selectedContactUser: state.quote.selectedContactUser,
  };
};

const mapDispatchProps = (dispatch) => {
  return {    
    setLogo: logoImage=>dispatch(setLogo(logoImage)),
    setProducts: products=>dispatch(setProducts(products)), 
    setLoading:  data=>dispatch(setLoading(data)),
    setDefaultBrand:  data=>dispatch(setDefaultBrand(data)),
    setOpenConfirmEditModal: data=>dispatch(setOpenConfirmEditModal(data)),
    setNoteId:  data=>dispatch(setNoteId(data)),
  };
};

export default connect(mapStateToProps, mapDispatchProps)(Category);